import { jsx as i, jsxs as E, Fragment as Ye } from "react/jsx-runtime";
import * as m from "react";
import lt, { forwardRef as Le, useRef as ce, useEffect as fe, useState as me, useLayoutEffect as Ar, createElement as oi, useMemo as ii, Fragment as li, createContext as ci, useContext as si } from "react";
import * as Pn from "react-dom";
import ui, { createPortal as di } from "react-dom";
var De = /* @__PURE__ */ ((e) => (e.Sm = "sm", e.Md = "md", e.Lg = "lg", e.Xl = "xl", e))(De || {}), fi = /* @__PURE__ */ ((e) => (e.Light = "light", e.Dark = "dark", e.Names = "names", e))(fi || {});
const J = (e, t = 16) => `${e / t}rem`;
function kn(e) {
  return Object.entries(e).reduce(
    (r, [n, a]) => (r[n] = `${a}px`, r),
    {}
  );
}
const hi = {
  "iota-primary": {
    0: "#000000",
    10: "#061244",
    20: "#182b8a",
    30: "#3131ff",
    40: "#2563f5",
    50: "#3f80f0",
    60: "#5b9cfe",
    70: "#85b5fb",
    80: "#adceff",
    90: "#d5e8ff",
    100: "#ffffff"
  },
  "iota-secondary": {
    0: "#000000",
    10: "#051631",
    20: "#17345f",
    30: "#2d4c7a",
    40: "#4b648a",
    50: "#637ca2",
    60: "#7e97bd",
    70: "#96b3d5",
    80: "#b6cde8",
    90: "#dde9f7",
    100: "#ffffff"
  },
  "iota-tertiary": {
    0: "#000000",
    10: "#071f22",
    20: "#18393b",
    30: "#185b60",
    40: "#317479",
    50: "#498c91",
    60: "#64a7ac",
    70: "#7fc2c7",
    80: "#9adde2",
    90: "#c2f1f4",
    100: "#ffffff"
  },
  "iota-error": {
    0: "#000000",
    10: "#330009",
    20: "#610012",
    30: "#b51431",
    40: "#ce2d4a",
    50: "#e64562",
    60: "#ff607d",
    70: "#ff889e",
    80: "#ffb0be",
    90: "#ffd9e0",
    100: "#ffffff"
  },
  "iota-neutral": {
    0: "#000000",
    4: "#0a0f17",
    6: "#0f141c",
    10: "#171d26",
    12: "#1c212b",
    20: "#253041",
    30: "#3c4656",
    40: "#545e6e",
    50: "#6e7787",
    60: "#8892a1",
    70: "#a8b2c0",
    80: "#cad4e2",
    90: "#dde4f0",
    92: "#e3eaf6",
    96: "#eff4fa",
    98: "#f8fafc",
    100: "#ffffff"
  },
  "iota-warning": {
    0: "#000000",
    10: "#2D1E00",
    20: "#422C00",
    30: "#674500",
    40: "#8C5D00",
    50: "#A47518",
    60: "#BE8F32",
    70: "#D9AA4D",
    80: "#F4C568",
    90: "#FFE3AB",
    100: "#FFFFFF"
  }
}, mi = {
  "names-primary": {
    0: "#000000",
    10: "#061244",
    20: "#182b8a",
    30: "#3131ff",
    40: "#2563f5",
    50: "#3f80f0",
    60: "#5b9cfe",
    70: "#85b5fb",
    80: "#adceff",
    90: "#d5e8ff",
    100: "#ffffff"
  },
  "names-secondary": {
    0: "#000000",
    10: "#051631",
    20: "#17345f",
    30: "#2d4c7a",
    40: "#4b648a",
    50: "#637ca2",
    60: "#7e97bd",
    70: "#96b3d5",
    80: "#b6cde8",
    90: "#dde9f7",
    100: "#ffffff"
  },
  "names-tertiary": {
    0: "#000000",
    10: "#00231F",
    20: "#00453D",
    30: "#00685C",
    40: "#008C7C",
    50: "#00AF9B",
    60: "#00D7BE",
    70: "#17F3D9",
    80: "#54FFEB",
    90: "#A6FFF4",
    100: "#ffffff"
  },
  "names-error": {
    0: "#000000",
    10: "#3D001F",
    20: "#620432",
    30: "#A30251",
    40: "#C90E6A",
    50: "#DC2B82",
    60: "#E35A9E",
    70: "#EF84B9",
    80: "#FCADD4",
    90: "#FFD7EB",
    100: "#ffffff"
  },
  "names-neutral": {
    0: "#000000",
    4: "#0A0D23",
    6: "#0F1228",
    10: "#181B31",
    12: "#20233C",
    20: "#2B2E45",
    30: "#404359",
    40: "#585B71",
    50: "#71748B",
    60: "#8C8FA5",
    70: "#ACAFC5",
    80: "#CED1E7",
    90: "#DFE2F8",
    92: "#E5E8FE",
    96: "#F0F2FF",
    98: "#F8F9FF",
    100: "#ffffff"
  },
  "names-solid": {
    blue: "#3131FF",
    purple: "#A139FF",
    green: "#14F0D6",
    neutral: "#20233C"
  },
  "names-warning": {
    0: "#000000",
    10: "#2D1E00",
    20: "#422C00",
    30: "#674500",
    40: "#8C5D00",
    50: "#A47518",
    60: "#BE8F32",
    70: "#D9AA4D",
    80: "#F4C568",
    90: "#FFE3AB",
    100: "#FFFFFF"
  }
}, vi = {
  "shader-primary-dark": {
    0: "#bed8ff00",
    8: "#bed8ff14",
    12: "#bed8ff1e",
    16: "#bed8ff28",
    48: "#bed8ff7a",
    72: "#bed8ffb7",
    100: "#bed8ff"
  },
  "shader-inverted-dark": {
    0: "#002f6d00",
    8: "#002f6d14",
    12: "#002f6d1e",
    16: "#002f6d28",
    48: "#002f6d7a",
    72: "#002f6db7",
    100: "#002f6d"
  },
  "shader-neutral-dark": {
    0: "#bed8ff00",
    8: "#bed8ff14",
    12: "#bed8ff1e",
    16: "#bed8ff28",
    48: "#bed8ff7a",
    72: "#bed8ffb7",
    100: "#bed8ff"
  },
  "shader-primary-light": {
    0: "#0067ee00",
    8: "#0067ee14",
    12: "#0067ee1e",
    16: "#0067ee28",
    48: "#0067ee7a",
    72: "#0067eeb7",
    100: "#0067ee"
  },
  "shader-inverted-light": {
    0: "#bed8ff00",
    8: "#bed8ff14",
    12: "#bed8ff1e",
    16: "#bed8ff28",
    48: "#bed8ff7a",
    72: "#bed8ffb7",
    100: "#bed8ff"
  },
  "shader-neutral-light": {
    0: "#002f6d00",
    8: "#002f6d14",
    12: "#002f6d1e",
    16: "#002f6d28",
    48: "#002f6d7a",
    72: "#002f6db7",
    100: "#002f6d"
  }
}, gi = {
  none: J(0),
  sm: J(2),
  DEFAULT: J(4),
  md: J(6),
  lg: J(8),
  xl: J(12),
  "2xl": J(16),
  "3xl": J(24),
  full: J(120)
}, pi = {
  none: J(0),
  xxxs: J(2),
  xxs: J(4),
  xs: J(8),
  sm: J(12),
  md: J(16),
  lg: J(24),
  xl: J(32),
  "2xl": J(48)
}, bi = {
  0: "0",
  8: "0.08",
  12: "0.12",
  16: "0.16",
  40: "0.4",
  60: "0.6",
  80: "0.8",
  100: "1"
}, xi = {
  "text-label-sm": [
    "11px",
    {
      lineHeight: "16px",
      letterSpacing: "0.2px",
      fontWeight: 500
    }
  ],
  "text-label-md": [
    "12px",
    {
      lineHeight: "16px",
      letterSpacing: "-0.1px",
      fontWeight: 500
    }
  ],
  "text-label-lg": [
    "14px",
    {
      lineHeight: "20px",
      letterSpacing: "-0.1px",
      fontWeight: 500
    }
  ]
}, wi = {
  "text-body-sm": [
    "12px",
    {
      lineHeight: "16px",
      letterSpacing: "0.1px",
      fontWeight: 400
    }
  ],
  "text-body-md": [
    "14px",
    {
      lineHeight: "20px",
      letterSpacing: "-0.1px",
      fontWeight: 400
    }
  ],
  "text-body-lg": [
    "16px",
    {
      lineHeight: "24px",
      letterSpacing: "0.1px",
      fontWeight: 400
    }
  ]
}, yi = {
  "text-body-ds-sm": [
    "12px",
    {
      lineHeight: "16px",
      letterSpacing: "0.1px",
      fontWeight: 400
    }
  ],
  "text-body-ds-md": [
    "14px",
    {
      lineHeight: "20px",
      letterSpacing: "-0.1px",
      fontWeight: 400
    }
  ],
  "text-body-ds-lg": [
    "16px",
    {
      lineHeight: "24px",
      letterSpacing: "0.2px",
      fontWeight: 400
    }
  ]
}, Si = {
  "text-title-sm": [
    "14px",
    {
      lineHeight: "120%",
      letterSpacing: "-0.1px",
      fontWeight: 500
    }
  ],
  "text-title-md": [
    "16px",
    {
      lineHeight: "120%",
      letterSpacing: "-0.15px",
      fontWeight: 500
    }
  ],
  "text-title-lg": [
    "20px",
    {
      lineHeight: "120%",
      letterSpacing: "-0.4px",
      fontWeight: 500
    }
  ]
}, Ci = {
  "text-headline-sm": [
    "24px",
    {
      lineHeight: "120%",
      fontWeight: "var(--headline-sm-font-weight)",
      letterSpacing: "-0.2px"
    }
  ],
  "text-headline-md": [
    "28px",
    {
      lineHeight: "120%",
      fontWeight: "var(--headline-md-font-weight)",
      letterSpacing: "-0.4px"
    }
  ],
  "text-headline-lg": [
    "32px",
    {
      lineHeight: "120%",
      fontWeight: "var(--headline-lg-font-weight)",
      letterSpacing: "-0.4px"
    }
  ]
}, Ei = {
  "text-display-sm": [
    "36px",
    {
      lineHeight: "var(--display-sm-line-height)",
      fontWeight: "var(--display-sm-font-weight)"
    }
  ],
  "text-display-md": [
    "48px",
    {
      lineHeight: "var(--display-md-line-height)",
      fontWeight: "var(--display-md-font-weight)"
    }
  ],
  "text-display-lg": [
    "60px",
    {
      lineHeight: "var(--display-lg-line-height)",
      fontWeight: "var(--display-lg-font-weight)"
    }
  ]
}, Ni = {
  ...xi,
  ...wi,
  ...yi,
  ...Si,
  ...Ci,
  ...Ei
}, _i = Object.entries(Ni).reduce(
  (e, [t, r]) => {
    const n = t.startsWith("text-") ? t.replace("text-", "") : t;
    return { ...e, [n]: r };
  },
  {}
), Mn = {
  "xs--rs": ["4px", "8px"],
  "sm--rs": ["8px", "12px"],
  "md--rs": ["16px", "24px"]
};
function Oi(e, t) {
  const r = [
    De.Sm,
    De.Md,
    De.Lg,
    De.Xl
  ], n = Mn[e];
  let a = `${n[0]}`;
  for (let o = 1; o < n.length; o++)
    if (n[o]) {
      const l = t[r[o]];
      l && (a = `clamp(${a}, (100vw - ${l}) * 99, ${n[o]})`);
    }
  return a;
}
function Ai(e) {
  return Object.keys(Mn).reduce((r, n) => {
    const a = Oi(
      n,
      e
    );
    return {
      ...r,
      [n]: a
    };
  }, {});
}
const Ri = {
  inter: ["Inter", "sans-serif"],
  "alliance-no2": ["AllianceNo2", "sans-serif"],
  "roboto-flex": ["Roboto Flex Variable", "sans-serif"]
}, Di = {
  "default-surface": "var(--default-surface)",
  "on-default": "var(--on-default)",
  "warning-surface": "var(--warning-surface)",
  "on-warning": "var(--on-warning)",
  "error-surface": "var(--error-surface)",
  "on-error": "var(--on-error)",
  "success-surface": "var(--success-surface)",
  "on-success": "var(--on-success)"
};
var kt = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Pr(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Bn = {}, Fn = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "default", {
    enumerable: !0,
    get: function() {
      return r;
    }
  });
  function t(n, a) {
    return {
      handler: n,
      config: a
    };
  }
  t.withOptions = function(n, a = () => ({})) {
    const o = function(l) {
      return {
        __options: l,
        handler: n(l),
        config: a(l)
      };
    };
    return o.__isOptionsFunction = !0, o.__pluginFunction = n, o.__configFunction = a, o;
  };
  const r = t;
})(Fn);
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "default", {
    enumerable: !0,
    get: function() {
      return n;
    }
  });
  const t = /* @__PURE__ */ r(Fn);
  function r(a) {
    return a.__esModule ? a : {
      default: a
    };
  }
  const n = t.default;
})(Bn);
let br = Bn;
var Ti = (br.__esModule ? br : { default: br }).default;
const Vn = /* @__PURE__ */ Pr(Ti), Li = Vn(({ addVariant: e }) => {
  e("firefox", "@-moz-document url-prefix()");
}), Ii = Vn(({ addVariant: e }) => {
  e("names", "&:is(.names *)");
}), Pi = {
  "names-gradient-primary": "var(--names-gradient-primary)"
}, Un = {
  content: ["./src/**/*.{html,js,jsx,ts,tsx}"],
  darkMode: "selector",
  plugins: [Li, Ii],
  theme: {
    extend: {
      fontSize: {
        ..._i
      },
      borderRadius: {
        ...gi
      },
      spacing: (e) => {
        const t = e.theme("screens"), r = Ai(t);
        return {
          ...pi,
          ...r
        };
      },
      opacity: {
        ...bi,
        30: "0.3"
      },
      colors: {
        ...hi,
        ...mi,
        ...vi,
        ...Di
      },
      fontFamily: Ri,
      backgroundImage: {
        ...Pi
      }
    }
  }
};
var Zt = { exports: {} };
Zt.exports;
(function(e, t) {
  var r = 200, n = "__lodash_hash_undefined__", a = 800, o = 16, l = 9007199254740991, s = "[object Arguments]", f = "[object Array]", d = "[object AsyncFunction]", v = "[object Boolean]", g = "[object Date]", b = "[object Error]", y = "[object Function]", w = "[object GeneratorFunction]", p = "[object Map]", S = "[object Number]", C = "[object Null]", T = "[object Object]", N = "[object Proxy]", L = "[object RegExp]", I = "[object Set]", z = "[object String]", _ = "[object Undefined]", O = "[object WeakMap]", j = "[object ArrayBuffer]", B = "[object DataView]", ee = "[object Float32Array]", le = "[object Float64Array]", xe = "[object Int8Array]", Ie = "[object Int16Array]", Ue = "[object Int32Array]", M = "[object Uint8Array]", P = "[object Uint8ClampedArray]", K = "[object Uint16Array]", te = "[object Uint32Array]", ne = /[\\^$.*+?()[\]{}|]/g, Q = /^\[object .+?Constructor\]$/, ae = /^(?:0|[1-9]\d*)$/, W = {};
  W[ee] = W[le] = W[xe] = W[Ie] = W[Ue] = W[M] = W[P] = W[K] = W[te] = !0, W[s] = W[f] = W[j] = W[v] = W[B] = W[g] = W[b] = W[y] = W[p] = W[S] = W[T] = W[L] = W[I] = W[z] = W[O] = !1;
  var et = typeof kt == "object" && kt && kt.Object === Object && kt, We = typeof self == "object" && self && self.Object === Object && self, we = et || We || Function("return this")(), tt = t && !t.nodeType && t, Ae = tt && !0 && e && !e.nodeType && e, Nt = Ae && Ae.exports === tt, gt = Nt && et.process, _t = function() {
    try {
      var c = Ae && Ae.require && Ae.require("util").types;
      return c || gt && gt.binding && gt.binding("util");
    } catch {
    }
  }(), Ot = _t && _t.isTypedArray;
  function or(c, u, h) {
    switch (h.length) {
      case 0:
        return c.call(u);
      case 1:
        return c.call(u, h[0]);
      case 2:
        return c.call(u, h[0], h[1]);
      case 3:
        return c.call(u, h[0], h[1], h[2]);
    }
    return c.apply(u, h);
  }
  function ir(c, u) {
    for (var h = -1, R = Array(c); ++h < c; )
      R[h] = u(h);
    return R;
  }
  function At(c) {
    return function(u) {
      return c(u);
    };
  }
  function lr(c, u) {
    return c == null ? void 0 : c[u];
  }
  function A(c, u) {
    return function(h) {
      return c(u(h));
    };
  }
  var D = Array.prototype, k = Function.prototype, H = Object.prototype, oe = we["__core-js_shared__"], $ = k.toString, F = H.hasOwnProperty, de = function() {
    var c = /[^.]+$/.exec(oe && oe.keys && oe.keys.IE_PROTO || "");
    return c ? "Symbol(src)_1." + c : "";
  }(), ve = H.toString, ye = $.call(Object), pt = RegExp(
    "^" + $.call(F).replace(ne, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  ), Rt = Nt ? we.Buffer : void 0, zr = we.Symbol, Xr = we.Uint8Array;
  Rt && Rt.allocUnsafe;
  var Kr = A(Object.getPrototypeOf, Object), Zr = Object.create, eo = H.propertyIsEnumerable, to = D.splice, je = zr ? zr.toStringTag : void 0, Dt = function() {
    try {
      var c = ur(Object, "defineProperty");
      return c({}, "", {}), c;
    } catch {
    }
  }(), ro = Rt ? Rt.isBuffer : void 0, Yr = Math.max, no = Date.now, qr = ur(we, "Map"), bt = ur(Object, "create"), ao = /* @__PURE__ */ function() {
    function c() {
    }
    return function(u) {
      if (!He(u))
        return {};
      if (Zr)
        return Zr(u);
      c.prototype = u;
      var h = new c();
      return c.prototype = void 0, h;
    };
  }();
  function Ge(c) {
    var u = -1, h = c == null ? 0 : c.length;
    for (this.clear(); ++u < h; ) {
      var R = c[u];
      this.set(R[0], R[1]);
    }
  }
  function oo() {
    this.__data__ = bt ? bt(null) : {}, this.size = 0;
  }
  function io(c) {
    var u = this.has(c) && delete this.__data__[c];
    return this.size -= u ? 1 : 0, u;
  }
  function lo(c) {
    var u = this.__data__;
    if (bt) {
      var h = u[c];
      return h === n ? void 0 : h;
    }
    return F.call(u, c) ? u[c] : void 0;
  }
  function co(c) {
    var u = this.__data__;
    return bt ? u[c] !== void 0 : F.call(u, c);
  }
  function so(c, u) {
    var h = this.__data__;
    return this.size += this.has(c) ? 0 : 1, h[c] = bt && u === void 0 ? n : u, this;
  }
  Ge.prototype.clear = oo, Ge.prototype.delete = io, Ge.prototype.get = lo, Ge.prototype.has = co, Ge.prototype.set = so;
  function Re(c) {
    var u = -1, h = c == null ? 0 : c.length;
    for (this.clear(); ++u < h; ) {
      var R = c[u];
      this.set(R[0], R[1]);
    }
  }
  function uo() {
    this.__data__ = [], this.size = 0;
  }
  function fo(c) {
    var u = this.__data__, h = Tt(u, c);
    if (h < 0)
      return !1;
    var R = u.length - 1;
    return h == R ? u.pop() : to.call(u, h, 1), --this.size, !0;
  }
  function ho(c) {
    var u = this.__data__, h = Tt(u, c);
    return h < 0 ? void 0 : u[h][1];
  }
  function mo(c) {
    return Tt(this.__data__, c) > -1;
  }
  function vo(c, u) {
    var h = this.__data__, R = Tt(h, c);
    return R < 0 ? (++this.size, h.push([c, u])) : h[R][1] = u, this;
  }
  Re.prototype.clear = uo, Re.prototype.delete = fo, Re.prototype.get = ho, Re.prototype.has = mo, Re.prototype.set = vo;
  function rt(c) {
    var u = -1, h = c == null ? 0 : c.length;
    for (this.clear(); ++u < h; ) {
      var R = c[u];
      this.set(R[0], R[1]);
    }
  }
  function go() {
    this.size = 0, this.__data__ = {
      hash: new Ge(),
      map: new (qr || Re)(),
      string: new Ge()
    };
  }
  function po(c) {
    var u = It(this, c).delete(c);
    return this.size -= u ? 1 : 0, u;
  }
  function bo(c) {
    return It(this, c).get(c);
  }
  function xo(c) {
    return It(this, c).has(c);
  }
  function wo(c, u) {
    var h = It(this, c), R = h.size;
    return h.set(c, u), this.size += h.size == R ? 0 : 1, this;
  }
  rt.prototype.clear = go, rt.prototype.delete = po, rt.prototype.get = bo, rt.prototype.has = xo, rt.prototype.set = wo;
  function nt(c) {
    var u = this.__data__ = new Re(c);
    this.size = u.size;
  }
  function yo() {
    this.__data__ = new Re(), this.size = 0;
  }
  function So(c) {
    var u = this.__data__, h = u.delete(c);
    return this.size = u.size, h;
  }
  function Co(c) {
    return this.__data__.get(c);
  }
  function Eo(c) {
    return this.__data__.has(c);
  }
  function No(c, u) {
    var h = this.__data__;
    if (h instanceof Re) {
      var R = h.__data__;
      if (!qr || R.length < r - 1)
        return R.push([c, u]), this.size = ++h.size, this;
      h = this.__data__ = new rt(R);
    }
    return h.set(c, u), this.size = h.size, this;
  }
  nt.prototype.clear = yo, nt.prototype.delete = So, nt.prototype.get = Co, nt.prototype.has = Eo, nt.prototype.set = No;
  function _o(c, u) {
    var h = hr(c), R = !h && fr(c), V = !h && !R && rn(c), X = !h && !R && !V && an(c), Y = h || R || V || X, G = Y ? ir(c.length, String) : [], q = G.length;
    for (var ge in c)
      Y && // Safari 9 has enumerable `arguments.length` in strict mode.
      (ge == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      V && (ge == "offset" || ge == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      X && (ge == "buffer" || ge == "byteLength" || ge == "byteOffset") || // Skip index properties.
      en(ge, q)) || G.push(ge);
    return G;
  }
  function cr(c, u, h) {
    (h !== void 0 && !Pt(c[u], h) || h === void 0 && !(u in c)) && sr(c, u, h);
  }
  function Oo(c, u, h) {
    var R = c[u];
    (!(F.call(c, u) && Pt(R, h)) || h === void 0 && !(u in c)) && sr(c, u, h);
  }
  function Tt(c, u) {
    for (var h = c.length; h--; )
      if (Pt(c[h][0], u))
        return h;
    return -1;
  }
  function sr(c, u, h) {
    u == "__proto__" && Dt ? Dt(c, u, {
      configurable: !0,
      enumerable: !0,
      value: h,
      writable: !0
    }) : c[u] = h;
  }
  var Ao = Wo();
  function Lt(c) {
    return c == null ? c === void 0 ? _ : C : je && je in Object(c) ? jo(c) : Ko(c);
  }
  function Qr(c) {
    return xt(c) && Lt(c) == s;
  }
  function Ro(c) {
    if (!He(c) || zo(c))
      return !1;
    var u = vr(c) ? pt : Q;
    return u.test(Qo(c));
  }
  function Do(c) {
    return xt(c) && nn(c.length) && !!W[Lt(c)];
  }
  function To(c) {
    if (!He(c))
      return Xo(c);
    var u = tn(c), h = [];
    for (var R in c)
      R == "constructor" && (u || !F.call(c, R)) || h.push(R);
    return h;
  }
  function Jr(c, u, h, R, V) {
    c !== u && Ao(u, function(X, Y) {
      if (V || (V = new nt()), He(X))
        Lo(c, u, Y, h, Jr, R, V);
      else {
        var G = R ? R(dr(c, Y), X, Y + "", c, u, V) : void 0;
        G === void 0 && (G = X), cr(c, Y, G);
      }
    }, on);
  }
  function Lo(c, u, h, R, V, X, Y) {
    var G = dr(c, h), q = dr(u, h), ge = Y.get(q);
    if (ge) {
      cr(c, h, ge);
      return;
    }
    var ue = X ? X(G, q, h + "", c, u, Y) : void 0, wt = ue === void 0;
    if (wt) {
      var gr = hr(q), pr = !gr && rn(q), cn = !gr && !pr && an(q);
      ue = q, gr || pr || cn ? hr(G) ? ue = G : Jo(G) ? ue = Fo(G) : pr ? (wt = !1, ue = ko(q)) : cn ? (wt = !1, ue = Bo(q)) : ue = [] : ei(q) || fr(q) ? (ue = G, fr(G) ? ue = ti(G) : (!He(G) || vr(G)) && (ue = Go(q))) : wt = !1;
    }
    wt && (Y.set(q, ue), V(ue, q, R, X, Y), Y.delete(q)), cr(c, h, ue);
  }
  function Io(c, u) {
    return Yo(Zo(c, u, ln), c + "");
  }
  var Po = Dt ? function(c, u) {
    return Dt(c, "toString", {
      configurable: !0,
      enumerable: !1,
      value: ni(u),
      writable: !0
    });
  } : ln;
  function ko(c, u) {
    return c.slice();
  }
  function Mo(c) {
    var u = new c.constructor(c.byteLength);
    return new Xr(u).set(new Xr(c)), u;
  }
  function Bo(c, u) {
    var h = Mo(c.buffer);
    return new c.constructor(h, c.byteOffset, c.length);
  }
  function Fo(c, u) {
    var h = -1, R = c.length;
    for (u || (u = Array(R)); ++h < R; )
      u[h] = c[h];
    return u;
  }
  function Vo(c, u, h, R) {
    var V = !h;
    h || (h = {});
    for (var X = -1, Y = u.length; ++X < Y; ) {
      var G = u[X], q = void 0;
      q === void 0 && (q = c[G]), V ? sr(h, G, q) : Oo(h, G, q);
    }
    return h;
  }
  function Uo(c) {
    return Io(function(u, h) {
      var R = -1, V = h.length, X = V > 1 ? h[V - 1] : void 0, Y = V > 2 ? h[2] : void 0;
      for (X = c.length > 3 && typeof X == "function" ? (V--, X) : void 0, Y && Ho(h[0], h[1], Y) && (X = V < 3 ? void 0 : X, V = 1), u = Object(u); ++R < V; ) {
        var G = h[R];
        G && c(u, G, R, X);
      }
      return u;
    });
  }
  function Wo(c) {
    return function(u, h, R) {
      for (var V = -1, X = Object(u), Y = R(u), G = Y.length; G--; ) {
        var q = Y[++V];
        if (h(X[q], q, X) === !1)
          break;
      }
      return u;
    };
  }
  function It(c, u) {
    var h = c.__data__;
    return $o(u) ? h[typeof u == "string" ? "string" : "hash"] : h.map;
  }
  function ur(c, u) {
    var h = lr(c, u);
    return Ro(h) ? h : void 0;
  }
  function jo(c) {
    var u = F.call(c, je), h = c[je];
    try {
      c[je] = void 0;
      var R = !0;
    } catch {
    }
    var V = ve.call(c);
    return R && (u ? c[je] = h : delete c[je]), V;
  }
  function Go(c) {
    return typeof c.constructor == "function" && !tn(c) ? ao(Kr(c)) : {};
  }
  function en(c, u) {
    var h = typeof c;
    return u = u ?? l, !!u && (h == "number" || h != "symbol" && ae.test(c)) && c > -1 && c % 1 == 0 && c < u;
  }
  function Ho(c, u, h) {
    if (!He(h))
      return !1;
    var R = typeof u;
    return (R == "number" ? mr(h) && en(u, h.length) : R == "string" && u in h) ? Pt(h[u], c) : !1;
  }
  function $o(c) {
    var u = typeof c;
    return u == "string" || u == "number" || u == "symbol" || u == "boolean" ? c !== "__proto__" : c === null;
  }
  function zo(c) {
    return !!de && de in c;
  }
  function tn(c) {
    var u = c && c.constructor, h = typeof u == "function" && u.prototype || H;
    return c === h;
  }
  function Xo(c) {
    var u = [];
    if (c != null)
      for (var h in Object(c))
        u.push(h);
    return u;
  }
  function Ko(c) {
    return ve.call(c);
  }
  function Zo(c, u, h) {
    return u = Yr(u === void 0 ? c.length - 1 : u, 0), function() {
      for (var R = arguments, V = -1, X = Yr(R.length - u, 0), Y = Array(X); ++V < X; )
        Y[V] = R[u + V];
      V = -1;
      for (var G = Array(u + 1); ++V < u; )
        G[V] = R[V];
      return G[u] = h(Y), or(c, this, G);
    };
  }
  function dr(c, u) {
    if (!(u === "constructor" && typeof c[u] == "function") && u != "__proto__")
      return c[u];
  }
  var Yo = qo(Po);
  function qo(c) {
    var u = 0, h = 0;
    return function() {
      var R = no(), V = o - (R - h);
      if (h = R, V > 0) {
        if (++u >= a)
          return arguments[0];
      } else
        u = 0;
      return c.apply(void 0, arguments);
    };
  }
  function Qo(c) {
    if (c != null) {
      try {
        return $.call(c);
      } catch {
      }
      try {
        return c + "";
      } catch {
      }
    }
    return "";
  }
  function Pt(c, u) {
    return c === u || c !== c && u !== u;
  }
  var fr = Qr(/* @__PURE__ */ function() {
    return arguments;
  }()) ? Qr : function(c) {
    return xt(c) && F.call(c, "callee") && !eo.call(c, "callee");
  }, hr = Array.isArray;
  function mr(c) {
    return c != null && nn(c.length) && !vr(c);
  }
  function Jo(c) {
    return xt(c) && mr(c);
  }
  var rn = ro || ai;
  function vr(c) {
    if (!He(c))
      return !1;
    var u = Lt(c);
    return u == y || u == w || u == d || u == N;
  }
  function nn(c) {
    return typeof c == "number" && c > -1 && c % 1 == 0 && c <= l;
  }
  function He(c) {
    var u = typeof c;
    return c != null && (u == "object" || u == "function");
  }
  function xt(c) {
    return c != null && typeof c == "object";
  }
  function ei(c) {
    if (!xt(c) || Lt(c) != T)
      return !1;
    var u = Kr(c);
    if (u === null)
      return !0;
    var h = F.call(u, "constructor") && u.constructor;
    return typeof h == "function" && h instanceof h && $.call(h) == ye;
  }
  var an = Ot ? At(Ot) : Do;
  function ti(c) {
    return Vo(c, on(c));
  }
  function on(c) {
    return mr(c) ? _o(c) : To(c);
  }
  var ri = Uo(function(c, u, h) {
    Jr(c, u, h);
  });
  function ni(c) {
    return function() {
      return c;
    };
  }
  function ln(c) {
    return c;
  }
  function ai() {
    return !1;
  }
  e.exports = ri;
})(Zt, Zt.exports);
var ki = Zt.exports;
const Wn = /* @__PURE__ */ Pr(ki), Mi = {
  [De.Sm]: 768,
  [De.Md]: 1024,
  [De.Lg]: 1400,
  [De.Xl]: 1920
}, sn = kn(Mi), sd = Wn({}, Un, {
  theme: {
    screens: sn,
    container: {
      center: !0,
      screens: sn,
      padding: {
        DEFAULT: J(20),
        md: J(48),
        lg: J(120),
        xl: J(240)
      }
    }
  }
}), Bi = {
  default: 0
}, Fi = kn(Bi), ud = Wn({}, Un, {
  theme: {
    screens: Fi
  },
  corePlugins: {
    container: !1
  }
});
var jn = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function r() {
      for (var o = "", l = 0; l < arguments.length; l++) {
        var s = arguments[l];
        s && (o = a(o, n(s)));
      }
      return o;
    }
    function n(o) {
      if (typeof o == "string" || typeof o == "number")
        return o;
      if (typeof o != "object")
        return "";
      if (Array.isArray(o))
        return r.apply(null, o);
      if (o.toString !== Object.prototype.toString && !o.toString.toString().includes("[native code]"))
        return o.toString();
      var l = "";
      for (var s in o)
        t.call(o, s) && o[s] && (l = a(l, s));
      return l;
    }
    function a(o, l) {
      return l ? o ? o + " " + l : o + l : o;
    }
    e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
  })();
})(jn);
var Vi = jn.exports;
const x = /* @__PURE__ */ Pr(Vi);
var re = /* @__PURE__ */ ((e) => (e.Neutral = "neutral", e.PrimarySolid = "primary-solid", e.PrimarySoft = "primary-soft", e.Success = "success", e.Warning = "warning", e.Error = "error", e))(re || {});
const Ui = {
  [re.PrimarySolid]: "badge-bg-color-primary",
  [re.Neutral]: "badge-bg-color-neutral",
  [re.PrimarySoft]: "badge-bg-color-primary-soft",
  [re.Success]: "bg-success-surface",
  [re.Warning]: "bg-warning-surface",
  [re.Error]: "bg-error-surface"
}, Wi = {
  [re.PrimarySolid]: "badge-text-color-primary",
  [re.Neutral]: "badge-text-color-neutral",
  [re.PrimarySoft]: "badge-text-color-primary-soft",
  [re.Success]: "text-on-success",
  [re.Warning]: "text-on-warning",
  [re.Error]: "text-on-error"
}, ji = {
  [re.PrimarySolid]: "badge-border-color-primary",
  [re.Neutral]: "badge-border-color-neutral",
  [re.PrimarySoft]: "badge-border-color-soft",
  [re.Success]: "border-success-surface",
  [re.Warning]: "border-warning-surface",
  [re.Error]: "border-error-surface"
}, Gi = "text-label-md";
function Yt({ type: e, label: t }) {
  const r = Ui[e], n = Wi[e], a = ji[e];
  return /* @__PURE__ */ i(
    "div",
    {
      className: x(
        "inline-flex items-center space-x-2 rounded-full border disabled:opacity-30",
        r,
        a,
        t ? "px-xs py-xxs" : "h-1.5 w-1.5"
      ),
      children: /* @__PURE__ */ i("span", { className: x(Gi, n), children: t })
    }
  );
}
var ie = /* @__PURE__ */ ((e) => (e.Small = "small", e.Medium = "medium", e))(ie || {}), U = /* @__PURE__ */ ((e) => (e.Primary = "primary", e.Secondary = "secondary", e.Ghost = "ghost", e.Outlined = "outlined", e.Destructive = "destructive", e))(U || {}), er = /* @__PURE__ */ ((e) => (e.Button = "button", e.Submit = "submit", e.Reset = "reset", e))(er || {});
const Hi = {
  [ie.Small]: "px-md py-xs",
  [ie.Medium]: "px-md py-sm"
}, $i = {
  [ie.Small]: "p-xs",
  [ie.Medium]: "p-sm"
}, zi = {
  [U.Primary]: "button-bg-color-primary",
  [U.Secondary]: "button-bg-color-secondary",
  [U.Ghost]: "bg-transparent",
  [U.Outlined]: "bg-transparent button-border-color-outline",
  [U.Destructive]: "button-bg-color-error"
}, Xi = {
  [U.Primary]: "button-bg-color-disabled-primary",
  [U.Secondary]: "button-bg-color-secondary",
  [U.Ghost]: "bg-transparent",
  [U.Outlined]: "bg-transparent button-border-color-outline",
  [U.Destructive]: "button-bg-color-error"
}, Xe = "button-text-color-neutral", Ki = {
  [U.Primary]: "button-text-color-primary",
  [U.Secondary]: Xe,
  [U.Ghost]: Xe,
  [U.Outlined]: Xe,
  [U.Destructive]: "button-text-color-error"
}, Zi = {
  [ie.Small]: "text-label-md",
  [ie.Medium]: "text-label-lg"
}, Yi = {
  [U.Primary]: Xe,
  [U.Secondary]: Xe,
  [U.Ghost]: Xe,
  [U.Outlined]: Xe,
  [U.Destructive]: "button-text-color-error"
}, pe = Le(
  ({
    icon: e,
    text: t,
    disabled: r,
    onClick: n,
    fullWidth: a,
    htmlType: o = er.Button,
    size: l = ie.Medium,
    type: s = U.Primary,
    iconAfterText: f = !1,
    tabIndex: d = 0,
    testId: v,
    ...g
  }, b) => {
    const y = e && !t ? $i[l] : Hi[l], w = Zi[l], p = r ? Xi[s] : zi[s], S = r ? Yi[s] : Ki[s];
    return /* @__PURE__ */ E(
      "button",
      {
        type: o,
        ...g,
        ref: b,
        onClick: n,
        className: x(
          "state-layer relative flex items-center justify-center gap-2 rounded-full transition-all duration-150 ease-in disabled:cursor-not-allowed disabled:opacity-40",
          y,
          p,
          a && "w-full",
          f ? "flex-row-reverse" : "flex-row",
          `btn btn-${s}`
        ),
        disabled: r,
        tabIndex: d,
        "data-testid": v,
        children: [
          e && /* @__PURE__ */ i("span", { className: x(S), children: e }),
          t && /* @__PURE__ */ i("span", { className: x("font-inter", S, w), children: t })
        ]
      }
    );
  }
);
function dd({
  htmlType: e = er.Button,
  children: t,
  tabIndex: r = 0,
  ...n
}) {
  return /* @__PURE__ */ i(
    "button",
    {
      className: "button-pill-border-color button-pill-text-color flex items-center justify-center rounded-xl border px-sm text-body-md disabled:opacity-40",
      type: e,
      tabIndex: r,
      ...n,
      children: t
    }
  );
}
function se({
  htmlType: e = er.Button,
  children: t,
  className: r,
  tabIndex: n = 0,
  testId: a,
  ...o
}) {
  return /* @__PURE__ */ i(
    "button",
    {
      type: e,
      ...o,
      className: x("appearance-none", r),
      tabIndex: n,
      "data-testid": a,
      children: t
    }
  );
}
function Gn(e) {
  return /* @__PURE__ */ i(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      fill: "none",
      viewBox: "0 0 24 24",
      ...e,
      children: /* @__PURE__ */ i(
        "path",
        {
          fill: "currentColor",
          d: "M4 12.004a1 1 0 0 0 .293.703l6 6a1 1 0 0 0 1.414-1.414L7.414 13H19a1 1 0 1 0 0-2H7.414l4.293-4.293a1 1 0 0 0-1.414-1.414l-6 6a1 1 0 0 0-.293.705z"
        }
      )
    }
  );
}
function qi(e) {
  return /* @__PURE__ */ i(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      fill: "none",
      viewBox: "0 0 24 24",
      ...e,
      children: /* @__PURE__ */ i(
        "path",
        {
          fill: "currentColor",
          d: "M11.45 15.335a1 1 0 0 0 1.257-.128l5-5a1 1 0 0 0-1.414-1.414L12 13.086 7.707 8.793a1 1 0 0 0-1.414 1.414l5 5a1 1 0 0 0 .157.128"
        }
      )
    }
  );
}
function Qi(e) {
  return /* @__PURE__ */ i(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      fill: "none",
      viewBox: "0 0 24 24",
      ...e,
      children: /* @__PURE__ */ i(
        "path",
        {
          fill: "currentColor",
          d: "M8.165 11.45a1 1 0 0 0 .128 1.257l5 5a1 1 0 0 0 1.414-1.414L10.414 12l4.293-4.293a1 1 0 0 0-1.414-1.414l-5 5a1 1 0 0 0-.128.157"
        }
      )
    }
  );
}
function kr(e) {
  return /* @__PURE__ */ i(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      fill: "none",
      viewBox: "0 0 24 24",
      ...e,
      children: /* @__PURE__ */ i(
        "path",
        {
          fill: "currentColor",
          d: "m10.707 6.293 5 5a1 1 0 0 1 0 1.414l-5 5a1 1 0 0 1-1.414-1.414L13.586 12 9.293 7.707a1 1 0 0 1 1.414-1.414"
        }
      )
    }
  );
}
function Ji(e) {
  return /* @__PURE__ */ i(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      fill: "none",
      viewBox: "0 0 24 24",
      ...e,
      children: /* @__PURE__ */ i(
        "path",
        {
          fill: "currentColor",
          d: "M17.483 6.29a1 1 0 0 0-.705-.29h-8.07a1 1 0 1 0 0 2h5.656l-8.071 8.071a1 1 0 1 0 1.414 1.414l8.071-8.07v5.656a1 1 0 1 0 2 0v-8.07a1 1 0 0 0-.291-.706l-.002-.002z"
        }
      )
    }
  );
}
function el(e) {
  return /* @__PURE__ */ i(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      fill: "none",
      viewBox: "0 0 24 24",
      ...e,
      children: /* @__PURE__ */ i(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m10.26 13.845 5.95-5.95a.994.994 0 0 1 1.405-.008.994.994 0 0 1-.008 1.406L10.95 15.95a.994.994 0 0 1-1.406.008l-2.846-2.845a.994.994 0 0 1 .01-1.406.994.994 0 0 1 1.405-.009z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function tl(e) {
  return /* @__PURE__ */ i(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      fill: "none",
      viewBox: "0 0 24 24",
      ...e,
      children: /* @__PURE__ */ i(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m4.21-14.104-5.95 5.95-2.147-2.148a.994.994 0 0 0-1.406.009.994.994 0 0 0-.009 1.405l2.846 2.846a.994.994 0 0 0 1.406-.008l6.657-6.657a.994.994 0 0 0 .008-1.406.994.994 0 0 0-1.405.009",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function Et(e) {
  return /* @__PURE__ */ i(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      fill: "none",
      viewBox: "0 0 24 24",
      ...e,
      children: /* @__PURE__ */ i(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M18.707 6.707a1 1 0 0 0-1.414-1.414L12 10.586 6.707 5.293a1 1 0 0 0-1.414 1.415L10.586 12l-5.293 5.293a1 1 0 1 0 1.414 1.414L12 13.414l5.293 5.294a1 1 0 0 0 1.414-1.415L13.414 12z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function Mr(e) {
  return /* @__PURE__ */ i(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      fill: "none",
      viewBox: "0 0 24 24",
      ...e,
      children: /* @__PURE__ */ i(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v1h1a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3h-8a3 3 0 0 1-3-3v-1H6a3 3 0 0 1-3-3zm6 12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1h-8a1 1 0 0 0-1 1zm6-11h-5a3 3 0 0 0-3 3v5H6a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function rl(e) {
  return /* @__PURE__ */ i(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      fill: "none",
      viewBox: "0 0 24 24",
      ...e,
      children: /* @__PURE__ */ i("rect", { width: 10, height: 2, x: 7, y: 11, fill: "currentColor", rx: 1 })
    }
  );
}
function nl(e) {
  return /* @__PURE__ */ E(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      fill: "none",
      viewBox: "0 0 24 24",
      ...e,
      children: [
        /* @__PURE__ */ i(
          "path",
          {
            fill: "currentColor",
            d: "M11.165 11.45a1 1 0 0 0 .128 1.257l5 5a1 1 0 0 0 1.414-1.414L13.414 12l4.293-4.293a1 1 0 0 0-1.414-1.414l-5 5a1 1 0 0 0-.128.157"
          }
        ),
        /* @__PURE__ */ i(
          "path",
          {
            fill: "currentColor",
            d: "M5.165 11.45a1 1 0 0 0 .128 1.257l5 5a1 1 0 0 0 1.414-1.414L7.414 12l4.293-4.293a1 1 0 0 0-1.414-1.414l-5 5a1 1 0 0 0-.128.157"
          }
        )
      ]
    }
  );
}
function al(e) {
  return /* @__PURE__ */ E(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      fill: "none",
      viewBox: "0 0 24 24",
      ...e,
      children: [
        /* @__PURE__ */ i(
          "path",
          {
            fill: "currentColor",
            d: "M11.835 11.45a1 1 0 0 1-.128 1.257l-5 5a1 1 0 0 1-1.414-1.414L9.586 12 5.293 7.707a1 1 0 0 1 1.414-1.414l5 5a1 1 0 0 1 .128.157"
          }
        ),
        /* @__PURE__ */ i(
          "path",
          {
            fill: "currentColor",
            d: "M17.835 11.45a1 1 0 0 1-.128 1.257l-5 5a1 1 0 0 1-1.414-1.414L15.586 12l-4.293-4.293a1 1 0 0 1 1.414-1.414l5 5a1 1 0 0 1 .128.157"
          }
        )
      ]
    }
  );
}
function tr(e) {
  return /* @__PURE__ */ i(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      fill: "none",
      viewBox: "0 0 24 24",
      ...e,
      children: /* @__PURE__ */ i(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18m0-14.4A1.2 1.2 0 1 0 12 9a1.2 1.2 0 0 0 0-2.4m1.2 9a1.2 1.2 0 0 1-2.4 0V12a1.2 1.2 0 0 1 2.4 0z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function ol(e) {
  return /* @__PURE__ */ i(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      fill: "none",
      viewBox: "0 0 24 24",
      ...e,
      children: /* @__PURE__ */ i(
        "path",
        {
          fill: "currentColor",
          d: "M18.27 2.259c0 .695-.568 1.259-1.268 1.259s-1.267-.564-1.267-1.259S16.302 1 17.002 1s1.268.564 1.268 1.259m1.425 17.785c0 .695-.568 1.259-1.268 1.259s-1.267-.564-1.267-1.26c0-.695.567-1.258 1.267-1.258s1.268.563 1.268 1.259m-2.33-13.379a1.06 1.06 0 0 0 1.063-1.056 1.06 1.06 0 0 0-1.063-1.057A1.06 1.06 0 0 0 16.3 5.61a1.06 1.06 0 0 0 1.064 1.056Zm3.891-.651a1.06 1.06 0 0 1-1.063 1.056 1.06 1.06 0 0 1-1.064-1.056 1.06 1.06 0 0 1 1.064-1.057 1.06 1.06 0 0 1 1.063 1.057m-4.253 3.329c.5 0 .905-.403.905-.9 0-.496-.405-.9-.905-.9s-.906.404-.906.9c0 .497.406.9.906.9m3.734-.52c0 .497-.405.9-.905.9a.903.903 0 0 1-.906-.9c0-.496.405-.9.906-.9.5 0 .905.404.905.9m1.357 1.777c.5 0 .906-.402.906-.899s-.405-.9-.906-.9c-.5 0-.905.403-.905.9s.405.9.905.9Zm-2.309.495a.79.79 0 0 1-.792.787.79.79 0 0 1-.791-.787c0-.434.354-.786.791-.786s.792.352.792.786m-3.62.404a.79.79 0 0 0 .792-.787.79.79 0 0 0-.792-.786.79.79 0 0 0-.791.786c0 .435.354.787.791.787m5.907.471a.79.79 0 0 1-.791.787.79.79 0 0 1-.792-.786.79.79 0 0 1 .792-.787.79.79 0 0 1 .791.787Zm-4.21 1.554c.375 0 .68-.302.68-.675a.677.677 0 0 0-.68-.675.68.68 0 0 0-.68.675c0 .373.304.675.68.675m2.968.178a.68.68 0 0 1-.68.676.677.677 0 0 1-.68-.676c0-.373.304-.675.68-.675.375 0 .68.302.68.675m-5.774-.582c.375 0 .68-.302.68-.675a.68.68 0 0 0-.68-.675.68.68 0 0 0-.68.675c0 .373.304.675.68.675m2.127.943c0 .31-.254.561-.566.561a.564.564 0 0 1-.566-.562c0-.31.253-.561.566-.561s.566.251.566.562m.407 2.114a.496.496 0 0 0 .498-.494.496.496 0 0 0-.498-.495.496.496 0 0 0-.498.495c0 .273.223.494.498.494m-.791-.09a.407.407 0 0 1-.408.405.407.407 0 0 1-.408-.405c0-.223.182-.405.408-.405s.408.181.408.405m-1.472-.765a.496.496 0 0 0 .498-.494.496.496 0 0 0-.498-.495.496.496 0 0 0-.498.495c0 .273.223.494.498.494m-.973-1.64c0 .31-.254.562-.566.562a.564.564 0 0 1-.566-.562c0-.31.253-.562.566-.562s.566.251.566.562m-.588-3.666a.564.564 0 0 0 .566-.562.564.564 0 0 0-.566-.562.564.564 0 0 0-.565.562c0 .31.253.562.565.562m.745-2.473a.496.496 0 0 1-.497.494.496.496 0 0 1-.498-.494c0-.273.223-.494.498-.494s.498.22.498.494Zm.047-1.123a.406.406 0 0 0 .407-.406.406.406 0 0 0-.407-.405.407.407 0 0 0-.408.405c0 .224.182.406.408.406m-.452-1.26a.496.496 0 0 1-.498.494.496.496 0 0 1-.498-.494c0-.273.223-.494.498-.494s.498.22.498.494m4.776 10.32a.564.564 0 0 0 .566-.561.564.564 0 0 0-.566-.562.564.564 0 0 0-.566.562c0 .31.253.562.566.562ZM12.883 4.439c0 .31-.254.562-.566.562a.564.564 0 0 1-.566-.562c0-.31.254-.562.566-.562s.566.251.566.562m-.18 2.945a.564.564 0 0 0 .566-.562.564.564 0 0 0-.566-.561.564.564 0 0 0-.566.561c0 .31.253.562.566.562m.045 1.597a.677.677 0 0 1-.68.676.68.68 0 0 1-.679-.676c0-.373.304-.675.68-.675.375 0 .68.302.68.675Zm-2.74.676a.79.79 0 0 0 .791-.786.79.79 0 0 0-.791-.787.79.79 0 0 0-.792.787c0 .434.354.786.792.786m-1.494-.36c0 .497-.405.9-.905.9a.903.903 0 0 1-.906-.9c0-.497.406-.9.906-.9s.905.403.905.9m-3.529 2.18a1.06 1.06 0 0 0 1.063-1.056 1.06 1.06 0 0 0-1.063-1.056A1.06 1.06 0 0 0 3.92 10.42a1.06 1.06 0 0 0 1.064 1.056Zm-1.45.9c0 .696-.568 1.26-1.268 1.26S1 13.073 1 12.377c0-.695.567-1.259 1.267-1.259s1.268.564 1.268 1.26Zm.386-3.531A1.06 1.06 0 0 0 4.985 7.79 1.06 1.06 0 0 0 3.92 6.733 1.06 1.06 0 0 0 2.858 7.79 1.06 1.06 0 0 0 3.92 8.846Zm3.53-2.181c0 .497-.405.9-.906.9a.903.903 0 0 1-.905-.9c0-.496.405-.9.905-.9s.906.404.906.9M6.162 5.182c.5 0 .905-.403.905-.9 0-.496-.405-.9-.905-.9s-.906.404-.906.9c0 .497.406.9.906.9m3.19-1.326a.79.79 0 0 1-.791.787.79.79 0 0 1-.792-.787c0-.434.354-.786.792-.786.437 0 .791.352.791.786m1.268.788c.375 0 .68-.303.68-.675a.677.677 0 0 0-.68-.676.68.68 0 0 0-.68.675c0 .373.304.676.68.676m1.063 1.708a.68.68 0 0 1-.68.675.677.677 0 0 1-.68-.675c0-.373.305-.675.68-.675s.68.302.68.675m-2.739.695a.79.79 0 0 0 .792-.786.79.79 0 0 0-.792-.786.79.79 0 0 0-.791.786c0 .434.354.786.791.786m-1.832 5.578a.407.407 0 0 1-.408.405.407.407 0 0 1-.408-.405c0-.223.182-.405.408-.405s.408.181.408.405m1.221.201a.496.496 0 0 0 .497-.494.496.496 0 0 0-.497-.495.496.496 0 0 0-.498.495c0 .273.223.494.498.494m2.354-1.236c0 .31-.253.562-.565.562a.564.564 0 0 1-.566-.562c0-.31.253-.562.566-.562s.565.252.565.562m-.135 2.361c.375 0 .68-.302.68-.675a.677.677 0 0 0-.68-.675.677.677 0 0 0-.68.675c0 .373.304.675.68.675m-1.608-.135c0 .31-.253.562-.566.562a.564.564 0 0 1-.565-.562c0-.31.253-.562.565-.562.313 0 .566.252.566.562m-2.488.538a.496.496 0 0 0 .498-.494.496.496 0 0 0-.498-.495.496.496 0 0 0-.498.495c0 .273.223.494.498.494m.588.991c0 .31-.254.562-.566.562a.564.564 0 0 1-.566-.562c0-.31.253-.562.566-.562s.566.252.566.562m1.742.855c.376 0 .68-.303.68-.675a.677.677 0 0 0-.68-.676.677.677 0 0 0-.68.675c0 .373.305.676.68.676m3.484-1.08a.79.79 0 0 1-.79.786.79.79 0 0 1-.792-.786c0-.435.354-.787.791-.787s.792.352.792.787Zm.794 2.743c.5 0 .906-.402.906-.9 0-.496-.406-.899-.906-.899s-.905.403-.905.9.405.9.905.9Zm-2.536-.518a.79.79 0 0 1-.792.786.79.79 0 0 1-.792-.787.79.79 0 0 1 .792-.786.79.79 0 0 1 .792.787m-2.669 2.316a.79.79 0 0 0 .791-.786.79.79 0 0 0-.792-.786.79.79 0 0 0-.791.786c0 .434.354.786.792.786m2.466 1.079c0 .497-.405.9-.905.9a.903.903 0 0 1-.906-.9c0-.496.405-.9.906-.9.5 0 .905.404.905.9M13.584 22a1.06 1.06 0 0 0 1.064-1.056 1.06 1.06 0 0 0-1.064-1.057 1.06 1.06 0 0 0-1.063 1.057A1.06 1.06 0 0 0 13.584 22m-1.379-2.788c0 .497-.405.9-.905.9a.903.903 0 0 1-.906-.9c0-.497.405-.9.905-.9s.906.403.906.9m3.123.54a1.06 1.06 0 0 0 1.063-1.057 1.06 1.06 0 0 0-1.063-1.056 1.06 1.06 0 0 0-1.064 1.056 1.06 1.06 0 0 0 1.064 1.057m-7.741-2.699a.677.677 0 0 1-.68.676.677.677 0 0 1-.68-.676c0-.373.305-.675.68-.675s.68.302.68.675"
        }
      )
    }
  );
}
function Hn(e) {
  return /* @__PURE__ */ i(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      fill: "none",
      viewBox: "0 0 24 24",
      ...e,
      children: /* @__PURE__ */ i(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M5.533 9.321A7 7 0 1 0 19 12a1 1 0 1 1 2 0 9 9 0 1 1-9-9 1 1 0 1 1 0 2 7 7 0 0 0-6.467 4.321",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function il(e) {
  return /* @__PURE__ */ i(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      fill: "none",
      viewBox: "0 0 24 24",
      ...e,
      children: /* @__PURE__ */ i(
        "path",
        {
          fill: "currentColor",
          d: "M21 9a1 1 0 0 1-1 1H4a1 1 0 1 1 0-2h16a1 1 0 0 1 1 1m0 6a1 1 0 0 1-1 1H10a1 1 0 1 1 0-2h10a1 1 0 0 1 1 1"
        }
      )
    }
  );
}
function $n(e) {
  return /* @__PURE__ */ i(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      fill: "none",
      viewBox: "0 0 24 24",
      ...e,
      children: /* @__PURE__ */ i(
        "path",
        {
          fill: "currentColor",
          d: "M5 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4m9-2a2 2 0 1 1-4 0 2 2 0 0 1 4 0m7 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
        }
      )
    }
  );
}
function ll(e) {
  return /* @__PURE__ */ E(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      fill: "none",
      viewBox: "0 0 24 24",
      ...e,
      children: [
        /* @__PURE__ */ i(
          "path",
          {
            fill: "currentColor",
            d: "M11 9a2 2 0 1 1-4 0 2 2 0 0 1 4 0m4 2a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
          }
        ),
        /* @__PURE__ */ i(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M2 8a6 6 0 0 1 6-6h8a6 6 0 0 1 6 6v8a6 6 0 0 1-6 6H8a6 6 0 0 1-6-6zm2 0a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v3.871a19.13 19.13 0 0 1-16 0zm0 6.051V16a4 4 0 0 0 4 4h8a4 4 0 0 0 4-4v-1.949a21.13 21.13 0 0 1-16 0",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
function zn(e) {
  return /* @__PURE__ */ i(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      fill: "none",
      viewBox: "0 0 24 24",
      ...e,
      children: /* @__PURE__ */ i(
        "path",
        {
          fill: "currentColor",
          d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"
        }
      )
    }
  );
}
function cl(e) {
  return /* @__PURE__ */ E(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      fill: "none",
      viewBox: "0 0 24 24",
      ...e,
      children: [
        /* @__PURE__ */ i(
          "path",
          {
            fill: "currentColor",
            d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"
          }
        ),
        /* @__PURE__ */ i("path", { fill: "currentColor", d: "M12 17a5 5 0 1 0 0-10 5 5 0 0 0 0 10" })
      ]
    }
  );
}
function sl(e) {
  return /* @__PURE__ */ i(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      fill: "none",
      viewBox: "0 0 24 24",
      ...e,
      children: /* @__PURE__ */ i(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M11 4a7 7 0 1 0 3.594 13.008l3.699 3.7a1 1 0 0 0 1.414-1.415l-3.555-3.555A7 7 0 0 0 11 4m-5 7a5 5 0 1 1 10 0 5 5 0 0 1-10 0",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function ul(e) {
  return /* @__PURE__ */ i(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      fill: "none",
      viewBox: "0 0 24 24",
      ...e,
      children: /* @__PURE__ */ i(
        "path",
        {
          fill: "currentColor",
          d: "M12 6a1 1 0 0 0-1 1v9.586l-2.293-2.293a1 1 0 0 0-1.414 1.414l4 4a1 1 0 0 0 1.414 0l4-4a1 1 0 0 0-1.414-1.414L13 16.586V7a1 1 0 0 0-1-1"
        }
      )
    }
  );
}
function un(e) {
  return /* @__PURE__ */ i(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      fill: "none",
      viewBox: "0 0 24 24",
      ...e,
      children: /* @__PURE__ */ i(
        "path",
        {
          fill: "currentColor",
          d: "M11.293 4.293a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1-1.414 1.414L13 7.414V17a1 1 0 1 1-2 0V7.414L8.707 9.707a1 1 0 0 1-1.414-1.414z"
        }
      )
    }
  );
}
function dl(e) {
  return /* @__PURE__ */ i(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      fill: "none",
      viewBox: "0 0 24 24",
      ...e,
      children: /* @__PURE__ */ i(
        "path",
        {
          fill: "currentColor",
          d: "M17.35 9c.578 0 .867.681.459 1.08l-4.85 4.735a.66.66 0 0 1-.917 0l-4.85-4.735C6.781 9.68 7.071 9 7.648 9z"
        }
      )
    }
  );
}
function Xn(e) {
  return /* @__PURE__ */ E(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      fill: "none",
      viewBox: "0 0 24 24",
      ...e,
      children: [
        /* @__PURE__ */ i(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M18.72 6.695a1 1 0 1 0-1.44-1.39l-1.518 1.572C14.601 6.348 13.331 6 12 6 8.739 6 5.843 8.092 4.017 9.805c-1.29 1.212-1.29 3.178 0 4.39a18 18 0 0 0 2.666 2.083l-1.695 1.755a1 1 0 0 0 1.438 1.39zM8.67 14.219l5.431-5.623a4 4 0 0 0-5.43 5.623Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ i(
          "path",
          {
            fill: "currentColor",
            d: "M16 12a4 4 0 0 1-3.975 4l-1.749 1.81c.56.122 1.136.19 1.724.19 3.26 0 6.157-2.092 7.983-3.805 1.29-1.212 1.29-3.178 0-4.39a20 20 0 0 0-1.071-.936l-2.914 3.017z"
          }
        )
      ]
    }
  );
}
function Kn(e) {
  return /* @__PURE__ */ E(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      fill: "none",
      viewBox: "0 0 24 24",
      ...e,
      children: [
        /* @__PURE__ */ i("path", { fill: "currentColor", d: "M12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4" }),
        /* @__PURE__ */ i(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M19.983 9.805c1.29 1.212 1.29 3.178 0 4.39C18.157 15.908 15.26 18 12 18c-3.261 0-6.157-2.092-7.983-3.805-1.29-1.212-1.29-3.178 0-4.39C5.843 8.092 8.74 6 12 6s6.157 2.092 7.983 3.805M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
function fd({
  id: e,
  name: t,
  label: r,
  supportingLabel: n,
  body: a,
  isChecked: o,
  isDisabled: l,
  onChange: s,
  ...f
}) {
  const d = o ? cl : zn;
  return /* @__PURE__ */ E(
    "label",
    {
      className: x(
        "flex flex-row items-center gap-x-1 text-center has-[:disabled]:opacity-40",
        {
          disabled: l,
          "cursor-pointer": !l
        }
      ),
      children: [
        /* @__PURE__ */ E(
          "div",
          {
            className: x(
              "relative flex h-10 w-10 shrink-0 items-center justify-center rounded-full",
              {
                "state-layer-secondary": !l
              }
            ),
            children: [
              /* @__PURE__ */ i(
                "input",
                {
                  id: e,
                  name: t,
                  type: "radio",
                  checked: o,
                  onChange: s,
                  disabled: l,
                  className: x("peer appearance-none"),
                  ...f
                }
              ),
              /* @__PURE__ */ i("span", { className: "radio-icon-color peer-checked:radio-icon-checked-color peer-checked:peer-disabled:radio-icon-checked-disabled-color absolute size-6", children: /* @__PURE__ */ i(d, { className: "size-full" }) })
            ]
          }
        ),
        /* @__PURE__ */ E("div", { className: "flex flex-col items-start gap-xxs text-start", children: [
          /* @__PURE__ */ E("span", { className: "radio-label-color inline-flex items-center justify-center gap-1 text-label-lg", children: [
            r,
            n && /* @__PURE__ */ i("span", { className: "text-iota-neutral-60 dark:text-iota-neutral-40", children: n })
          ] }),
          a && /* @__PURE__ */ i("p", { className: "text-body-sm text-iota-neutral-40 dark:text-iota-neutral-60", children: a })
        ] })
      ]
    }
  );
}
const fl = "bg-transparent", hl = "button-segment-bg-color-selected", ml = "button-segment-text-color-default", vl = "button-segment-text-color-hover", gl = "button-segment-text-color-focused", pl = `${ml} ${vl} ${gl}`, bl = "button-segment-text-color-selected", xl = `
  button-segment-underline-base
  before:bottom-0
  button-segment-underline-hover
  button-segment-underline-hover-color
`, wl = `
  button-segment-underline-base
  button-segment-underline-selected
`;
var st = /* @__PURE__ */ ((e) => (e.Rounded = "rounded", e.Underlined = "underlined", e))(st || {});
function hd({
  icon: e,
  label: t,
  selected: r,
  disabled: n,
  onClick: a,
  type: o = st.Rounded,
  isNested: l = !1,
  ...s
}) {
  const f = o === st.Underlined, d = r ? f ? "bg-transparent" : hl : fl, v = f ? r ? wl : xl : "", g = r ? bl : pl, b = f ? l ? "px-md py-sm" : "px-lg py-md" : "px-sm py-[6px]", y = f ? "" : "rounded-full", w = l ? f ? "text-title-sm" : "text-label-md" : f ? "text-title-md" : "text-label-lg";
  return /* @__PURE__ */ i(
    se,
    {
      onClick: a,
      className: x(
        "enabled:state-layer-secondary relative flex items-center disabled:opacity-40",
        d,
        g,
        b,
        y,
        v,
        {
          "pl-xs": !!e && !f
        }
      ),
      disabled: n,
      ...s,
      children: /* @__PURE__ */ E("div", { className: x("flex flex-row items-center justify-center gap-2", w), children: [
        e && /* @__PURE__ */ i("span", { children: e }),
        /* @__PURE__ */ i("span", { className: "text-start font-inter", children: t })
      ] })
    }
  );
}
const Zn = Le(
  ({
    isChecked: e,
    isIndeterminate: t,
    label: r,
    isLabelFirst: n,
    isDisabled: a,
    onCheckedChange: o,
    name: l,
    ...s
  }, f) => {
    const d = ce(null);
    fe(() => {
      d.current && (d.current.indeterminate = t ?? !1);
    }, [t, d]);
    const v = t ? rl : el;
    function g(b) {
      f && (typeof f == "function" ? f(b) : f.current = b), d.current = b;
    }
    return /* @__PURE__ */ E(
      "div",
      {
        className: x(
          "group inline-flex has-[:disabled]:opacity-40",
          n ? "flex-row-reverse" : "flex-row",
          {
            disabled: a,
            "gap-x-2": r
          }
        ),
        children: [
          /* @__PURE__ */ i(
            "input",
            {
              id: l,
              name: l,
              type: "checkbox",
              className: "peer hidden appearance-none",
              checked: e,
              ref: g,
              disabled: a,
              onChange: (b) => {
                o == null || o(b);
              },
              ...s
            }
          ),
          /* @__PURE__ */ i(
            "span",
            {
              onClick: () => {
                var b;
                return (b = d.current) == null ? void 0 : b.click();
              },
              className: x(
                "checkbox-base checkbox-state checkbox-icon checkbox-icon-hidden",
                "checkbox-border-default",
                "peer-[&:is(:checked,:indeterminate)]:checkbox-border-checked",
                "peer-[&:is(:checked,:indeterminate)]:checkbox-bg-checked",
                "peer-[&:is(:checked,:indeterminate)]:checkbox-text-checked",
                "peer-disabled:peer-[&:not(:checked,:indeterminate)]:checkbox-border-color-disabled",
                "peer-disabled:peer-[&:is(:checked,:indeterminate)]:checkbox-border-color-disabled-checked",
                "peer-disabled:peer-[&:is(:checked,:indeterminate)]:checkbox-bg-color-disabled-checked"
              ),
              children: /* @__PURE__ */ i(v, {})
            }
          ),
          /* @__PURE__ */ i(yl, { label: r, name: l })
        ]
      }
    );
  }
);
function yl({ label: e, name: t }) {
  return /* @__PURE__ */ i("label", { htmlFor: t, className: "checkbox-label checkbox-label-disabled", children: e });
}
var Ke = /* @__PURE__ */ ((e) => (e.Vertical = "vertical", e.Horizontal = "horizontal", e))(Ke || {});
const Sl = "divider-bg-color", Cl = {
  [Ke.Horizontal]: "w-full",
  [Ke.Vertical]: "h-full"
}, El = "1px";
function Nl({
  type: e = Ke.Horizontal,
  width: t,
  height: r,
  lineHeight: n = El
}) {
  const a = {
    ...e === Ke.Horizontal ? { height: n } : { width: n }
  };
  let o = Cl[e];
  return t && e === Ke.Horizontal ? o = t : r && e === Ke.Vertical && (o = r), /* @__PURE__ */ i("div", { className: x(Sl, o), style: a });
}
var jt = /* @__PURE__ */ ((e) => (e.Small = "small", e.Medium = "medium", e))(jt || {}), $e = /* @__PURE__ */ ((e) => (e.Top = "top", e.Bottom = "bottom", e.Left = "left", e.Right = "right", e))($e || {});
function vt({
  text: e,
  position: t = $e.Top,
  maxWidth: r = "max-w-[200px]",
  offset: n = 8,
  openDelay: a = 0,
  closeDelay: o = 100,
  children: l
}) {
  const s = ce(null), f = ce(null), [d, v] = me(!1), [g, b] = me({ top: 0, left: 0 }), y = ce(), w = ce(), p = () => {
    clearTimeout(y.current), clearTimeout(w.current);
  }, S = () => {
    p(), y.current = setTimeout(() => v(!0), a);
  }, C = () => {
    p(), w.current = setTimeout(() => v(!1), o);
  };
  return Ar(() => {
    var I;
    if (!d) return;
    const N = (I = s.current) == null ? void 0 : I.getBoundingClientRect();
    if (!N) return;
    const L = {
      [$e.Top]: {
        top: N.top - n,
        left: N.left + N.width / 2,
        transform: "translate(-50%, -100%)"
      },
      [$e.Bottom]: {
        top: N.bottom + n,
        left: N.left + N.width / 2,
        transform: "translate(-50%, 0)"
      },
      [$e.Left]: {
        top: N.top + N.height / 2,
        left: N.left - n,
        transform: "translate(-100%, -50%)"
      },
      [$e.Right]: {
        top: N.top + N.height / 2,
        left: N.right + n,
        transform: "translate(0, -50%)"
      }
    }[t];
    b({ top: L.top, left: L.left }), f.current.style.transform = L.transform;
  }, [d, t, n]), Ar(() => {
    if (!d) return;
    const N = () => {
      var I;
      const L = (I = s.current) == null ? void 0 : I.getBoundingClientRect();
      L && b((z) => ({ ...z, left: L.left + L.width / 2 }));
    };
    return window.addEventListener("scroll", N, !0), window.addEventListener("resize", N), () => {
      window.removeEventListener("scroll", N, !0), window.removeEventListener("resize", N);
    };
  }, [d]), /* @__PURE__ */ E(Ye, { children: [
    /* @__PURE__ */ i(
      "div",
      {
        ref: s,
        className: "inline-block cursor-pointer",
        onMouseEnter: S,
        onFocus: S,
        onMouseLeave: C,
        onBlur: C,
        children: l
      }
    ),
    d && di(
      /* @__PURE__ */ i(
        "div",
        {
          ref: f,
          role: "tooltip",
          style: {
            position: "fixed",
            top: g.top,
            left: g.left,
            transition: "opacity .15s ease",
            opacity: 1
          },
          className: x("z-[9999999999] w-max rounded p-xs tooltip-bg tooltip-text-color", r),
          onMouseEnter: S,
          onMouseLeave: C,
          children: /* @__PURE__ */ i("p", { className: "w-full break-words", children: e })
        }
      ),
      document.body
    )
  ] });
}
function md({
  keyText: e,
  value: t,
  tooltipPosition: r,
  tooltipText: n,
  supportingLabel: a,
  size: o = jt.Small,
  isTruncated: l = !1,
  copyText: s,
  onCopySuccess: f,
  onCopyError: d,
  fullwidth: v,
  isReverse: g = !1,
  valueHoverTitle: b
}) {
  const y = g ? "flex-row-reverse" : "flex-row";
  async function w(p) {
    if (navigator.clipboard && s)
      try {
        await navigator.clipboard.writeText(s), f == null || f(p, s);
      } catch (S) {
        console.error("Failed to copy:", S), d == null || d(S, s);
      }
  }
  return /* @__PURE__ */ E(
    "div",
    {
      className: x(
        "flex w-full items-baseline gap-xs py-xxs font-inter",
        y,
        {
          "justify-between": v
        }
      ),
      children: [
        /* @__PURE__ */ E(
          "div",
          {
            className: x("flex shrink-0 flex-row items-center gap-x-0.5", {
              "w-1/4": !v
            }),
            children: [
              /* @__PURE__ */ i("span", { className: "key-value-key-text-color text-body-md", children: e }),
              n && /* @__PURE__ */ i(vt, { text: n, position: r, children: /* @__PURE__ */ i(tr, { className: "key-supporting-text-color" }) })
            ]
          }
        ),
        /* @__PURE__ */ E(
          "div",
          {
            className: x("flex flex-row items-baseline gap-1 break-all", {
              "w-3/4": !v,
              truncate: l
            }),
            children: [
              /* @__PURE__ */ i(
                "span",
                {
                  title: b,
                  className: x(
                    "key-value-hover-text-color",
                    o === jt.Medium ? "text-body-lg" : "text-body-md",
                    { truncate: l }
                  ),
                  children: t
                }
              ),
              a && /* @__PURE__ */ i(
                "span",
                {
                  className: x(
                    "key-supporting-text-color",
                    o === jt.Medium ? "text-body-md" : "text-body-sm"
                  ),
                  children: a
                }
              ),
              /* @__PURE__ */ i("div", { className: "self-center", children: s && /* @__PURE__ */ i(se, { onClick: w, "aria-label": "Copy to clipboard", children: /* @__PURE__ */ i(Mr, { className: "key-supporting-text-color" }) }) })
            ]
          }
        )
      ]
    }
  );
}
var he = /* @__PURE__ */ ((e) => (e.Small = "small", e.Medium = "medium", e.Large = "large", e))(he || {});
const _l = {
  [he.Small]: "text-title-sm",
  [he.Medium]: "text-title-md",
  [he.Large]: "text-title-lg"
}, Ol = {
  [he.Small]: "text-label-md",
  [he.Medium]: "text-label-md",
  [he.Large]: "text-label-lg"
}, Al = {
  [he.Small]: "text-label-md",
  [he.Medium]: "text-label-md",
  [he.Large]: "text-label-lg"
};
function vd({
  size: e = he.Medium,
  isCentered: t,
  supportingLabel: r,
  label: n,
  text: a,
  tooltipPosition: o,
  tooltipText: l
}) {
  const s = _l[e], f = Ol[e], d = Al[e], v = t ? "items-center" : "items-start", g = e === he.Small ? "gap-0.5" : "gap-1";
  return /* @__PURE__ */ E("div", { className: x("flex flex-col", v, g), children: [
    /* @__PURE__ */ E("div", { className: "flex flex-row flex-wrap items-center gap-0.5", children: [
      /* @__PURE__ */ i("span", { className: x("label-text-primary-neutral font-inter", s), children: a }),
      r && /* @__PURE__ */ i(
        "span",
        {
          className: x(
            "label-text-secondary-neutral font-inter",
            f
          ),
          children: r
        }
      )
    ] }),
    /* @__PURE__ */ i("div", { className: "flex flex-row items-center gap-x-0.5", children: /* @__PURE__ */ E(
      "span",
      {
        className: x(
          "label-text-secondary-neutral flex items-center font-inter",
          d
        ),
        children: [
          n,
          l && /* @__PURE__ */ i("div", { className: "ml-xxxs flex items-center", children: /* @__PURE__ */ i(vt, { text: l, position: o, children: /* @__PURE__ */ i(tr, { className: "label-text-secondary-neutral" }) }) })
        ]
      }
    ) })
  ] });
}
function Rl({
  showRightIcon: e,
  hideBottomBorder: t,
  onClick: r,
  isDisabled: n,
  children: a,
  isHighlighted: o,
  ...l
}) {
  function s(d) {
    (d.key === "Enter" || d.key === " ") && !n && r && r();
  }
  function f() {
    !n && r && r();
  }
  return /* @__PURE__ */ i(
    "div",
    {
      className: x(
        "w-full",
        {
          "list-item-border-color border-b pb-xs": !t
        },
        { "opacity-40": n }
      ),
      children: /* @__PURE__ */ E(
        "div",
        {
          onClick: f,
          role: "button",
          tabIndex: 0,
          onKeyDown: s,
          ...l,
          className: x(
            "list-item-color relative flex flex-row items-center justify-between px-md py-sm",
            !n && r ? "cursor-pointer" : "cursor-default",
            {
              "list-item-highlight-bg": o,
              "state-layer-secondary": !n
            }
          ),
          children: [
            a,
            e && /* @__PURE__ */ i(
              pe,
              {
                size: ie.Small,
                type: U.Ghost,
                disabled: n,
                icon: /* @__PURE__ */ i(kr, {})
              }
            )
          ]
        }
      )
    }
  );
}
function gd({
  title: e,
  titleCentered: t,
  onBack: r,
  onClose: n,
  testId: a
}) {
  const o = t ? "text-center" : r ? "ml-1" : "", l = t && (!r || !n);
  return /* @__PURE__ */ E("div", { className: "header-bg-color header-text-color flex min-h-[56px] w-full items-center px-md--rs pb-xs pt-sm [&_svg]:h-5 [&_svg]:w-5", children: [
    r ? /* @__PURE__ */ i(
      pe,
      {
        size: ie.Small,
        type: U.Ghost,
        onClick: r,
        icon: /* @__PURE__ */ i(Gn, {}),
        "aria-label": "Back"
      }
    ) : l && /* @__PURE__ */ i("div", { className: "w-9" }),
    /* @__PURE__ */ i("div", { className: x("flex-grow", o), children: /* @__PURE__ */ i("span", { className: "font-inter text-title-lg", "data-testid": a, children: e }) }),
    n ? /* @__PURE__ */ i(
      pe,
      {
        size: ie.Small,
        type: U.Ghost,
        onClick: n,
        icon: /* @__PURE__ */ i(Et, {}),
        testId: "close-icon",
        "aria-label": "Close"
      }
    ) : l && /* @__PURE__ */ i("div", { className: "w-9" })
  ] });
}
function pd({
  children: e,
  hasBorder: t,
  bgColor: r = "panel-bg"
}) {
  return /* @__PURE__ */ i("div", { className: x("flex w-full flex-col rounded-xl", r, t ? "border panel-border-color" : "border border-transparent"), children: e });
}
function Dl() {
  return /* @__PURE__ */ i("div", { className: "flex h-full w-full items-center justify-center bg-iota-neutral-96 dark:bg-iota-neutral-10", children: /* @__PURE__ */ i(ll, { className: "h-4 w-4 text-iota-neutral-40 dark:text-iota-neutral-60" }) });
}
const Tl = Le(
  ({ onError: e, renderFallback: t, ...r }, n) => {
    const [a, o] = me(!1);
    function l(s) {
      o(!0), e == null || e(s);
    }
    return a || !r.src ? t || /* @__PURE__ */ i(Dl, {}) : /* @__PURE__ */ i(Yn, { onError: l, ref: n, ...r });
  }
), Yn = Le(
  (e, t) => /* @__PURE__ */ i("img", { className: "h-full w-full object-cover", ref: t, ...e })
);
var Te = /* @__PURE__ */ ((e) => (e.Default = "default", e.Error = "error", e.Success = "success", e.Warning = "warning", e))(Te || {}), Gt = /* @__PURE__ */ ((e) => (e.Default = "default", e.Elevated = "elevated", e))(Gt || {});
const Ll = {
  [Te.Default]: "bg-default-surface text-on-default",
  [Te.Error]: "bg-error-surface text-on-error",
  [Te.Success]: "bg-success-surface text-on-success",
  [Te.Warning]: "bg-warning-surface text-on-warning"
}, Il = {
  [Te.Default]: "bg-default-surface",
  [Te.Error]: "bg-error-surface",
  [Te.Success]: "bg-success-surface",
  [Te.Warning]: "bg-warning-surface"
};
function bd({
  icon: e,
  title: t,
  supportingText: r,
  type: n,
  style: a
}) {
  const o = Ll[n], l = a === Gt.Elevated ? Il[n] : "";
  return /* @__PURE__ */ E(
    "div",
    {
      className: x("flex flex-row items-start gap-4 py-xs pr-lg", l, {
        "rounded-lg pl-xs": a === Gt.Elevated
      }),
      children: [
        e && /* @__PURE__ */ i(
          "span",
          {
            className: x(
              "flex items-center justify-center rounded-lg [&_svg]:h-4 [&_svg]:w-4",
              o,
              {
                "p-xs": a === Gt.Default
              }
            ),
            children: e
          }
        ),
        /* @__PURE__ */ E("div", { className: "flex flex-col gap-1", children: [
          t && /* @__PURE__ */ i("span", { className: "infobox-text-title text-title-sm", children: t }),
          r && /* @__PURE__ */ i("span", { className: "infobox-supporting-text text-body-sm", children: r })
        ] })
      ]
    }
  );
}
var Ee = /* @__PURE__ */ ((e) => (e.Default = "default", e.Error = "error", e.Warning = "warning", e.Success = "success", e))(Ee || {});
const dn = {
  [Ee.Default]: "text-on-default",
  [Ee.Error]: "text-on-error",
  [Ee.Warning]: "text-on-warning",
  [Ee.Success]: "text-on-success"
}, Pl = {
  [Ee.Default]: "bg-default-surface",
  [Ee.Error]: "bg-error-surface",
  [Ee.Warning]: "bg-warning-surface",
  [Ee.Success]: "bg-success-surface"
};
function xd({
  text: e,
  duration: t = 2e3,
  onClose: r,
  showClose: n,
  type: a = Ee.Default
}) {
  return fe(() => {
    if (t) {
      const o = setTimeout(r, t);
      return () => clearTimeout(o);
    }
  }, [t, r]), /* @__PURE__ */ E(
    "div",
    {
      className: x(
        "transition-all duration-300 ease-out",
        "z-99 bottom-0",
        "flex w-full items-center justify-between gap-xxs rounded-md py-sm pl-md pr-sm",
        Pl[a]
      ),
      children: [
        /* @__PURE__ */ i("div", { className: x("w-full text-left text-body-md", dn[a]), children: e }),
        n && /* @__PURE__ */ i(se, { onClick: r, "aria-label": "Close", children: /* @__PURE__ */ i(Et, { className: x("h-5 w-5", dn[a]) }) })
      ]
    }
  );
}
function wd({
  color: e = "loading-indicator-color",
  size: t = "w-5 h-5",
  text: r,
  testId: n
}) {
  return /* @__PURE__ */ E("div", { className: "flex items-center justify-center gap-xs", children: [
    /* @__PURE__ */ i(Hn, { className: x("animate-spin", e, t), "data-testid": n }),
    r && /* @__PURE__ */ i("span", { className: x("text-body-sm", e), children: r })
  ] });
}
function kl({ width: e = "w-full", height: t = "h-4" }) {
  return /* @__PURE__ */ i(
    "div",
    {
      className: x(
        "animate-pulse rounded-md bg-gradient-to-r from-shader-primary-light-8 bg-[length:1000px_100%] dark:from-shader-primary-dark-8",
        e,
        t
      )
    }
  );
}
function yd({
  children: e,
  className: t,
  hasSecondaryColors: r
}) {
  return /* @__PURE__ */ i(
    "div",
    {
      className: x(
        "h-3 w-full animate-pulse rounded-full",
        r ? "skeleton-secondary-bg" : "skeleton-bg",
        t
      ),
      children: e
    }
  );
}
const Ml = {
  autoPlay: !0,
  muted: !0,
  playsInline: !0,
  controls: !0,
  controlsList: "nodownload",
  disablePictureInPicture: !0,
  preload: "auto",
  loop: !0,
  width: "100%",
  height: "auto"
}, Bl = {
  autoPlay: !0,
  muted: !0,
  playsInline: !0,
  controls: !1,
  disablePictureInPicture: !0,
  preload: "auto",
  loop: !0,
  width: "100%",
  height: "auto"
}, Fl = Le(({ width: e = "100%", height: t = "auto", isAutoPlayEnabled: r, disableControls: n, ...a }, o) => /* @__PURE__ */ i("video", { ref: o, width: e, height: t, ...r ? n ? Bl : Ml : { preload: "metadata", autoPlay: !1 }, ...a, children: "Your browser does not support the video tag." }));
var Ve = /* @__PURE__ */ ((e) => (e.Small = "small", e.Default = "default", e))(Ve || {}), Rr = /* @__PURE__ */ ((e) => (e.Left = "left", e.Right = "right", e))(Rr || {});
const Vl = "relative inline-flex items-center p-xxs border rounded-full cursor-pointer", Mt = {
  active: "toggle-bg-active toggle-border-active",
  inactive: "toggle-bg-inactive toggle-border-inactive",
  disabledActive: "toggle-bg-disabled-active toggle-border-disabled-active",
  disabled: "opacity-40 cursor-not-allowed"
}, Ul = {
  [Ve.Small]: "h-5 w-10",
  [Ve.Default]: "h-6 w-12"
}, Wl = "absolute rounded-full transition-all duration-200 ease-in-out", fn = {
  [Ve.Small]: {
    unchecked: "left-1",
    checked: "left-[34px] -translate-x-full"
  },
  [Ve.Default]: {
    unchecked: "left-1",
    checked: "left-[42px] -translate-x-full"
  }
}, hn = {
  unchecked: "toggle-thumb-color",
  checked: "toggle-thumb-color-checked"
}, jl = {
  [Ve.Small]: "h-3 w-3",
  [Ve.Default]: "h-4 w-4"
}, Gl = "inline-flex items-center gap-2", Hl = "text-label-lg toggle-label-color", Sd = Le(
  ({
    label: e,
    isToggled: t,
    labelPosition: r = Rr.Right,
    isDisabled: n = !1,
    onChange: a,
    name: o,
    size: l = Ve.Default,
    testId: s,
    ...f
  }, d) => {
    const v = ce(null);
    function g(C) {
      const T = C.target.checked;
      a == null || a(T, C);
    }
    function b(C) {
      d && (typeof d == "function" ? d(C) : d.current = C), v.current = C;
    }
    const y = x(Vl, {
      [Mt.active]: t && !n,
      [Mt.inactive]: !t,
      [Mt.disabledActive]: n && t,
      [Mt.disabled]: n,
      [Ul[l]]: !0
    }), w = x(Wl, {
      [fn[l].unchecked]: !t,
      [fn[l].checked]: t,
      [hn.unchecked]: !t,
      [hn.checked]: t,
      [jl[l]]: !0
    }), p = x(Gl, {
      "flex-row-reverse": r === Rr.Left,
      "cursor-not-allowed": n
    }), S = x(Hl, {
      "opacity-40": n && !t
    });
    return /* @__PURE__ */ E("div", { className: p, children: [
      /* @__PURE__ */ i(
        "input",
        {
          id: o,
          name: o,
          type: "checkbox",
          className: "sr-only",
          checked: t,
          ref: b,
          disabled: n,
          onChange: g,
          "data-testid": s
        }
      ),
      /* @__PURE__ */ i(
        "span",
        {
          role: "switch",
          "aria-checked": t,
          onClick: () => {
            var C;
            return (C = v.current) == null ? void 0 : C.click();
          },
          className: y,
          ...f,
          children: /* @__PURE__ */ i("span", { className: w })
        }
      ),
      e && /* @__PURE__ */ i("label", { htmlFor: o, className: S, children: e })
    ] });
  }
);
function qt({ children: e, hasErrorStyles: t }) {
  return /* @__PURE__ */ i(
    "p",
    {
      className: x("secondary-text-color text-label-lg", {
        ["group-[.errored]:w-full group-[.errored]:secondary-text-error-color group-[.errored]:bg-error-surface group-[.errored]:rounded-xl group-[.errored]:py-1 group-[.errored]:px-2"]: t
      }),
      children: e
    }
  );
}
function $l({
  text: e,
  isCopyable: t,
  isExternal: r,
  externalLink: n,
  copyText: a = e,
  onCopySuccess: o,
  onCopyError: l,
  onOpen: s
}) {
  async function f(v) {
    if (navigator.clipboard) {
      v == null || v.stopPropagation();
      try {
        await navigator.clipboard.writeText(a), o == null || o(v, a);
      } catch (g) {
        console.error("Failed to copy:", g), l == null || l(g, a);
      }
    }
  }
  function d(v) {
    if (v == null || v.stopPropagation(), n) {
      const g = window.open(n, "_blank", "noopener noreferrer");
      g && (g.opener = null);
    }
    s == null || s(v);
  }
  return /* @__PURE__ */ E("div", { className: "address-text-color group flex flex-row items-center gap-1", children: [
    /* @__PURE__ */ i("span", { className: x("font-inter text-body-sm"), children: e }),
    t && /* @__PURE__ */ i(
      se,
      {
        onClick: f,
        className: "opacity-100",
        "aria-label": "Copy to clipboard",
        children: /* @__PURE__ */ i(Mr, {})
      }
    ),
    r && /* @__PURE__ */ i(
      se,
      {
        onClick: d,
        className: "opacity-100",
        "aria-label": "Open in new tab",
        children: /* @__PURE__ */ i(Ji, {})
      }
    )
  ] });
}
var qn = /* @__PURE__ */ ((e) => (e.Image = "image", e.Video = "video", e))(qn || {});
function zl({
  src: e,
  isAutoPlayEnabled: t,
  assetType: r,
  altText: n,
  showFallback: a,
  disableControls: o
}) {
  return r === qn.Video ? /* @__PURE__ */ i(
    Fl,
    {
      src: e,
      isAutoPlayEnabled: t,
      disableControls: o
    }
  ) : a ? /* @__PURE__ */ i(Tl, { src: e, alt: n }) : /* @__PURE__ */ i(Yn, { src: e, alt: n });
}
var Z = /* @__PURE__ */ ((e) => (e.Outline = "outline", e.Elevated = "elevated", e.Success = "success", e.Brand = "brand", e.Error = "error", e))(Z || {}), Dr = /* @__PURE__ */ ((e) => (e.Small = "small", e.Default = "default", e))(Dr || {});
const mn = "rounded-full", Xl = {
  [Z.Outline]: "bg-transparent",
  [Z.Elevated]: "chip-bg-elevated",
  [Z.Success]: "bg-success-surface",
  [Z.Brand]: "chip-bg-brand",
  [Z.Error]: "bg-error-surface"
}, Kl = "outline outline-1 hover:chip-outline-color-hover active:chip-outline-color-active", Zl = "hover:chip-bg-color-hover active:chip-bg-color-active group-focus:chip-bg-color-focus", Yl = `${Kl} ${Zl}`, ql = {
  [Z.Outline]: "chip-bg-selected-outline"
}, Ql = "chip-bg-selected-overlay", Jl = {
  [Z.Outline]: "chip-text-secondary"
}, ec = {
  [Z.Outline]: "chip-border-default",
  [Z.Elevated]: "border-transparent",
  [Z.Success]: "border-success-surface",
  [Z.Brand]: "chip-border-color-brand",
  [Z.Error]: "border-error-surface"
}, tc = {
  [Z.Outline]: "chip-text-default",
  [Z.Elevated]: "chip-text-secondary",
  [Z.Success]: "chip-text-secondary",
  [Z.Brand]: "chip-text-brand",
  [Z.Error]: "chip-text-secondary"
}, rc = "focus-visible:shadow-[0_0_0_2px] focus-visible:chip-focus-ring focus-visible:outline-none", nc = "chip-close-icon-opacity group-hover:opacity-100 group-focus:opacity-100 group-active:opacity-100";
function Cd({
  label: e,
  type: t = Z.Outline,
  selected: r,
  showClose: n,
  onClose: a,
  onClick: o,
  avatar: l,
  leadingElement: s,
  trailingElement: f,
  disabled: d,
  size: v = Dr.Default,
  ...g
}) {
  const b = t === Z.Outline && r, y = r ? t === Z.Outline ? "outline-transparent names:outline-names-neutral-20" : "chip-outline-color" : "outline-transparent", w = x(
    "group-focus:chip-outline-color-active",
    t === Z.Outline && "names:group-focus:outline-transparent"
  ), p = r && !d && t !== Z.Outline ? Ql : "";
  return /* @__PURE__ */ i(
    se,
    {
      onClick: o,
      className: x(
        "group border disabled:opacity-40",
        mn,
        b ? ql[Z.Outline] : Xl[t],
        r ? "border-transparent" : ec[t]
      ),
      disabled: d,
      ...g,
      children: /* @__PURE__ */ E(
        "span",
        {
          className: x(
            "flex h-full w-full flex-row items-center gap-x-2",
            l ? "py-xxs" : "py-[6px]",
            l ? "pl-xxs" : s ? "pl-xs" : "pl-sm",
            n ? "pr-xs" : "pr-sm",
            mn,
            b ? Jl[Z.Outline] : tc[t],
            y,
            !d && w,
            !d && Yl,
            rc,
            p
          ),
          children: [
            l ?? s,
            /* @__PURE__ */ i("span", { className: x(v === Dr.Small ? "text-label-md" : "text-body-md"), children: e }),
            f,
            n && /* @__PURE__ */ i(
              se,
              {
                onClick: (S) => {
                  S.stopPropagation(), a == null || a();
                },
                disabled: d,
                "aria-label": "Remove",
                children: /* @__PURE__ */ i(
                  Et,
                  {
                    className: x(
                      "h-4 w-4 transition-opacity duration-150",
                      d ? "" : r ? "opacity-100" : nc
                    )
                  }
                )
              }
            )
          ]
        }
      )
    }
  );
}
var ut = /* @__PURE__ */ ((e) => (e.Outlined = "outlined", e.Filled = "filled", e.Transparent = "transparent", e))(ut || {});
const ac = {
  [ut.Outlined]: "bg-transparent",
  [ut.Filled]: "segmented-filled-bg-color",
  [ut.Transparent]: "bg-transparent"
}, oc = "border segmented-outlined-border";
function Ed({
  type: e = ut.Filled,
  children: t,
  shape: r = st.Rounded
}) {
  const n = ac[e], a = e === ut.Outlined ? oc : "", o = r === st.Rounded ? "rounded-full gap-1 p-xxs" : "", l = r === st.Rounded ? "flex-wrap" : "flex-nowrap overflow-x-auto";
  return /* @__PURE__ */ i(
    "div",
    {
      className: x("flex flex-row", n, a, o, l),
      children: t
    }
  );
}
var ht = /* @__PURE__ */ ((e) => (e.Small = "small", e.Medium = "medium", e))(ht || {});
const ic = {
  [ht.Small]: "px-md py-sm--rs",
  [ht.Medium]: "px-md--rs py-sm--rs"
}, lc = {
  [ht.Small]: "text-title-md",
  [ht.Medium]: "text-title-lg"
};
function Nd({
  title: e,
  subtitle: t,
  trailingElement: r,
  tooltipText: n,
  supportingElement: a,
  tooltipPosition: o,
  size: l = ht.Medium,
  testId: s
}) {
  return /* @__PURE__ */ E(
    "div",
    {
      className: x("flex flex-row items-center justify-between", ic[l]),
      "data-testid": s,
      children: [
        /* @__PURE__ */ E("div", { className: "flex flex-row items-center gap-x-xxxs", children: [
          /* @__PURE__ */ E("div", { className: "flex flex-col justify-start", children: [
            /* @__PURE__ */ E("div", { className: "title-main-color flex flex-row items-center gap-x-0.5", children: [
              /* @__PURE__ */ i("h4", { className: x(lc[l]), children: e }),
              n && /* @__PURE__ */ i(vt, { text: n, position: o, children: /* @__PURE__ */ i(tr, { className: "title-icon-color" }) })
            ] }),
            /* @__PURE__ */ i("p", { className: "title-subtitle-color text-label-md", children: t })
          ] }),
          a
        ] }),
        r
      ]
    }
  );
}
const Qn = "w-full input-caret-color bg-transparent text-body-lg caret-input-caret-color focus:outline-none focus-visible:outline-none disabled:cursor-not-allowed", Jn = "input-text-color", ea = "input-placeholder-color", cc = "[appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none disabled:cursor-not-allowed", ta = "px-md py-sm rounded-lg border input-border-color input-border-color-disabled group-[.enabled]:cursor-text input-border-error-color hover:group-[.enabled]:input-border-color-hover input-border-color-focus", sc = "flex flex-col gap-y-2 text-label-lg input-label-color";
var ra = /* @__PURE__ */ ((e) => (e.Label = "label", e.Div = "div", e))(ra || {});
function Br({
  label: e,
  caption: t,
  disabled: r,
  errorMessage: n,
  amountCounter: a,
  required: o,
  labelHtmlTag: l = "label",
  children: s
}) {
  return /* @__PURE__ */ E(
    "div",
    {
      className: x("group flex w-full flex-col gap-y-2", {
        "cursor-not-allowed opacity-40": r,
        errored: n,
        enabled: !r,
        required: o
      }),
      children: [
        e ? /* @__PURE__ */ E(uc, { labelHtmlTag: l, children: [
          e,
          s
        ] }) : s,
        (n || t || a) && /* @__PURE__ */ E(
          "div",
          {
            className: x(
              "flex flex-row items-center",
              t || n ? "justify-between gap-md" : "justify-end"
            ),
            children: [
              (n || t) && /* @__PURE__ */ i(qt, { hasErrorStyles: !0, children: n || t }),
              a && /* @__PURE__ */ i(qt, { children: a })
            ]
          }
        )
      ]
    }
  );
}
function uc({
  labelHtmlTag: e,
  children: t
}) {
  return oi(e, { className: sc }, t);
}
var Se = /* @__PURE__ */ ((e) => (e.Text = "text", e.Password = "password", e.Number = "number", e.NumericFormat = "numericFormat", e))(Se || {}), dc = /* @__PURE__ */ ((e) => (e.None = "none", e.Vertical = "vertical", e))(dc || {});
function na(e, t) {
  var r = {};
  for (var n in e)
    Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
      t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
}
var St;
(function(e) {
  e.event = "event", e.props = "prop";
})(St || (St = {}));
function Me() {
}
function fc(e) {
  var t, r = void 0;
  return function() {
    for (var n = [], a = arguments.length; a--; ) n[a] = arguments[a];
    return t && n.length === t.length && n.every(function(o, l) {
      return o === t[l];
    }) || (t = n, r = e.apply(void 0, n)), r;
  };
}
function Ct(e) {
  return !!(e || "").match(/\d/);
}
function dt(e) {
  return e == null;
}
function hc(e) {
  return typeof e == "number" && isNaN(e);
}
function aa(e) {
  return dt(e) || hc(e) || typeof e == "number" && !isFinite(e);
}
function oa(e) {
  return e.replace(/[-[\]/{}()*+?.\\^$|]/g, "\\$&");
}
function mc(e) {
  switch (e) {
    case "lakh":
      return /(\d+?)(?=(\d\d)+(\d)(?!\d))(\.\d+)?/g;
    case "wan":
      return /(\d)(?=(\d{4})+(?!\d))/g;
    case "thousand":
    default:
      return /(\d)(?=(\d{3})+(?!\d))/g;
  }
}
function vc(e, t, r) {
  var n = mc(r), a = e.search(/[1-9]/);
  return a = a === -1 ? e.length : a, e.substring(0, a) + e.substring(a, e.length).replace(n, "$1" + t);
}
function gc(e) {
  var t = ce(e);
  t.current = e;
  var r = ce(function() {
    for (var n = [], a = arguments.length; a--; ) n[a] = arguments[a];
    return t.current.apply(t, n);
  });
  return r.current;
}
function Fr(e, t) {
  t === void 0 && (t = !0);
  var r = e[0] === "-", n = r && t;
  e = e.replace("-", "");
  var a = e.split("."), o = a[0], l = a[1] || "";
  return {
    beforeDecimal: o,
    afterDecimal: l,
    hasNegation: r,
    addNegation: n
  };
}
function pc(e) {
  if (!e)
    return e;
  var t = e[0] === "-";
  t && (e = e.substring(1, e.length));
  var r = e.split("."), n = r[0].replace(/^0+/, "") || "0", a = r[1] || "";
  return (t ? "-" : "") + n + (a ? "." + a : "");
}
function ia(e, t, r) {
  for (var n = "", a = r ? "0" : "", o = 0; o <= t - 1; o++)
    n += e[o] || a;
  return n;
}
function vn(e, t) {
  return Array(t + 1).join(e);
}
function la(e) {
  var t = e + "", r = t[0] === "-" ? "-" : "";
  r && (t = t.substring(1));
  var n = t.split(/[eE]/g), a = n[0], o = n[1];
  if (o = Number(o), !o)
    return r + a;
  a = a.replace(".", "");
  var l = 1 + o, s = a.length;
  return l < 0 ? a = "0." + vn("0", Math.abs(l)) + a : l >= s ? a = a + vn("0", l - s) : a = (a.substring(0, l) || "0") + "." + a.substring(l), r + a;
}
function gn(e, t, r) {
  if (["", "-"].indexOf(e) !== -1)
    return e;
  var n = (e.indexOf(".") !== -1 || r) && t, a = Fr(e), o = a.beforeDecimal, l = a.afterDecimal, s = a.hasNegation, f = parseFloat("0." + (l || "0")), d = l.length <= t ? "0." + l : f.toFixed(t), v = d.split("."), g = o;
  o && Number(v[0]) && (g = o.split("").reverse().reduce(function(p, S, C) {
    return p.length > C ? (Number(p[0]) + Number(S)).toString() + p.substring(1, p.length) : S + p;
  }, v[0]));
  var b = ia(v[1] || "", t, r), y = s ? "-" : "", w = n ? "." : "";
  return "" + y + g + w + b;
}
function ze(e, t) {
  if (e.value = e.value, e !== null) {
    if (e.createTextRange) {
      var r = e.createTextRange();
      return r.move("character", t), r.select(), !0;
    }
    return e.selectionStart || e.selectionStart === 0 ? (e.focus(), e.setSelectionRange(t, t), !0) : (e.focus(), !1);
  }
}
var ca = fc(function(e, t) {
  for (var r = 0, n = 0, a = e.length, o = t.length; e[r] === t[r] && r < a; )
    r++;
  for (; e[a - 1 - n] === t[o - 1 - n] && o - n > r && a - n > r; )
    n++;
  return {
    from: { start: r, end: a - n },
    to: { start: r, end: o - n }
  };
}), bc = function(e, t) {
  var r = Math.min(e.selectionStart, t);
  return {
    from: { start: r, end: e.selectionEnd },
    to: { start: r, end: t }
  };
};
function xc(e, t, r) {
  return Math.min(Math.max(e, t), r);
}
function xr(e) {
  return Math.max(e.selectionStart, e.selectionEnd);
}
function wc() {
  return typeof navigator < "u" && !(navigator.platform && /iPhone|iPod/.test(navigator.platform));
}
function yc(e) {
  return {
    from: {
      start: 0,
      end: 0
    },
    to: {
      start: 0,
      end: e.length
    },
    lastValue: ""
  };
}
function Sc(e) {
  var t = e.currentValue, r = e.formattedValue, n = e.currentValueIndex, a = e.formattedValueIndex;
  return t[n] === r[a];
}
function Cc(e, t, r, n, a, o, l) {
  l === void 0 && (l = Sc);
  var s = a.findIndex(function(L) {
    return L;
  }), f = e.slice(0, s);
  !t && !r.startsWith(f) && (t = f, r = f + r, n = n + f.length);
  for (var d = r.length, v = e.length, g = {}, b = new Array(d), y = 0; y < d; y++) {
    b[y] = -1;
    for (var w = 0, p = v; w < p; w++) {
      var S = l({
        currentValue: r,
        lastValue: t,
        formattedValue: e,
        currentValueIndex: y,
        formattedValueIndex: w
      });
      if (S && g[w] !== !0) {
        b[y] = w, g[w] = !0;
        break;
      }
    }
  }
  for (var C = n; C < d && (b[C] === -1 || !o(r[C])); )
    C++;
  var T = C === d || b[C] === -1 ? v : b[C];
  for (C = n - 1; C > 0 && b[C] === -1; )
    C--;
  var N = C === -1 || b[C] === -1 ? 0 : b[C] + 1;
  return N > T ? T : n - N < T - n ? N : T;
}
function pn(e, t, r, n) {
  var a = e.length;
  if (t = xc(t, 0, a), n === "left") {
    for (; t >= 0 && !r[t]; )
      t--;
    t === -1 && (t = r.indexOf(!0));
  } else {
    for (; t <= a && !r[t]; )
      t++;
    t > a && (t = r.lastIndexOf(!0));
  }
  return t === -1 && (t = a), t;
}
function Ec(e) {
  for (var t = Array.from({ length: e.length + 1 }).map(function() {
    return !0;
  }), r = 0, n = t.length; r < n; r++)
    t[r] = !!(Ct(e[r]) || Ct(e[r - 1]));
  return t;
}
function sa(e, t, r, n, a, o) {
  o === void 0 && (o = Me);
  var l = gc(function(w, p) {
    var S, C;
    return aa(w) ? (C = "", S = "") : typeof w == "number" || p ? (C = typeof w == "number" ? la(w) : w, S = n(C)) : (C = a(w, void 0), S = n(C)), { formattedValue: S, numAsString: C };
  }), s = me(function() {
    return l(dt(e) ? t : e, r);
  }), f = s[0], d = s[1], v = function(w, p) {
    w.formattedValue !== f.formattedValue && d({
      formattedValue: w.formattedValue,
      numAsString: w.value
    }), o(w, p);
  }, g = e, b = r;
  dt(e) && (g = f.numAsString, b = !0);
  var y = l(g, b);
  return ii(function() {
    d(y);
  }, [y.formattedValue]), [f, v];
}
function Nc(e) {
  return e.replace(/[^0-9]/g, "");
}
function _c(e) {
  return e;
}
function Oc(e) {
  var t = e.type;
  t === void 0 && (t = "text");
  var r = e.displayType;
  r === void 0 && (r = "input");
  var n = e.customInput, a = e.renderText, o = e.getInputRef, l = e.format;
  l === void 0 && (l = _c);
  var s = e.removeFormatting;
  s === void 0 && (s = Nc);
  var f = e.defaultValue, d = e.valueIsNumericString, v = e.onValueChange, g = e.isAllowed, b = e.onChange;
  b === void 0 && (b = Me);
  var y = e.onKeyDown;
  y === void 0 && (y = Me);
  var w = e.onMouseUp;
  w === void 0 && (w = Me);
  var p = e.onFocus;
  p === void 0 && (p = Me);
  var S = e.onBlur;
  S === void 0 && (S = Me);
  var C = e.value, T = e.getCaretBoundary;
  T === void 0 && (T = Ec);
  var N = e.isValidInputCharacter;
  N === void 0 && (N = Ct);
  var L = e.isCharacterSame, I = na(e, ["type", "displayType", "customInput", "renderText", "getInputRef", "format", "removeFormatting", "defaultValue", "valueIsNumericString", "onValueChange", "isAllowed", "onChange", "onKeyDown", "onMouseUp", "onFocus", "onBlur", "value", "getCaretBoundary", "isValidInputCharacter", "isCharacterSame"]), z = sa(C, f, !!d, l, s, v), _ = z[0], O = _.formattedValue, j = _.numAsString, B = z[1], ee = ce(), le = ce({ formattedValue: O, numAsString: j }), xe = function(A, D) {
    le.current = { formattedValue: A.formattedValue, numAsString: A.value }, B(A, D);
  }, Ie = me(!1), Ue = Ie[0], M = Ie[1], P = ce(null), K = ce({
    setCaretTimeout: null,
    focusTimeout: null
  });
  fe(function() {
    return M(!0), function() {
      clearTimeout(K.current.setCaretTimeout), clearTimeout(K.current.focusTimeout);
    };
  }, []);
  var te = l, ne = function(A, D) {
    var k = parseFloat(D);
    return {
      formattedValue: A,
      value: D,
      floatValue: isNaN(k) ? void 0 : k
    };
  }, Q = function(A, D, k) {
    A.selectionStart === 0 && A.selectionEnd === A.value.length || (ze(A, D), K.current.setCaretTimeout = setTimeout(function() {
      A.value === k && A.selectionStart !== D && ze(A, D);
    }, 0));
  }, ae = function(A, D, k) {
    return pn(A, D, T(A), k);
  }, W = function(A, D, k) {
    var H = T(D), oe = Cc(D, O, A, k, H, N, L);
    return oe = pn(D, oe, H), oe;
  }, et = function(A) {
    var D = A.formattedValue;
    D === void 0 && (D = "");
    var k = A.input, H = A.source, oe = A.event, $ = A.numAsString, F;
    if (k) {
      var de = A.inputValue || k.value, ve = xr(k);
      k.value = D, F = W(de, D, ve), F !== void 0 && Q(k, F, D);
    }
    D !== O && xe(ne(D, $), { event: oe, source: H });
  };
  fe(function() {
    var A = le.current, D = A.formattedValue, k = A.numAsString;
    (O !== D || j !== k) && xe(ne(O, j), {
      event: void 0,
      source: St.props
    });
  }, [O, j]);
  var We = P.current ? xr(P.current) : void 0, we = typeof window < "u" ? Ar : fe;
  we(function() {
    var A = P.current;
    if (O !== le.current.formattedValue && A) {
      var D = W(le.current.formattedValue, O, We);
      A.value = O, Q(A, D, O);
    }
  }, [O]);
  var tt = function(A, D, k) {
    var H = D.target, oe = ee.current ? bc(ee.current, H.selectionEnd) : ca(O, A), $ = Object.assign(Object.assign({}, oe), { lastValue: O }), F = s(A, $), de = te(F);
    if (F = s(de, void 0), g && !g(ne(de, F))) {
      var ve = D.target, ye = xr(ve), pt = W(A, O, ye);
      return ve.value = O, Q(ve, pt, O), !1;
    }
    return et({
      formattedValue: de,
      numAsString: F,
      inputValue: A,
      event: D,
      source: k,
      input: D.target
    }), !0;
  }, Ae = function(A, D) {
    D === void 0 && (D = 0);
    var k = A.selectionStart, H = A.selectionEnd;
    ee.current = { selectionStart: k, selectionEnd: H + D };
  }, Nt = function(A) {
    var D = A.target, k = D.value, H = tt(k, A, St.event);
    H && b(A), ee.current = void 0;
  }, gt = function(A) {
    var D = A.target, k = A.key, H = D.selectionStart, oe = D.selectionEnd, $ = D.value;
    $ === void 0 && ($ = "");
    var F;
    k === "ArrowLeft" || k === "Backspace" ? F = Math.max(H - 1, 0) : k === "ArrowRight" ? F = Math.min(H + 1, $.length) : k === "Delete" && (F = H);
    var de = 0;
    k === "Delete" && H === oe && (de = 1);
    var ve = k === "ArrowLeft" || k === "ArrowRight";
    if (F === void 0 || H !== oe && !ve) {
      y(A), Ae(D, de);
      return;
    }
    var ye = F;
    if (ve) {
      var pt = k === "ArrowLeft" ? "left" : "right";
      ye = ae($, F, pt), ye !== F && A.preventDefault();
    } else k === "Delete" && !N($[F]) ? ye = ae($, F, "right") : k === "Backspace" && !N($[F]) && (ye = ae($, F, "left"));
    ye !== F && Q(D, ye, $), y(A), Ae(D, de);
  }, _t = function(A) {
    var D = A.target, k = function() {
      var H = D.selectionStart, oe = D.selectionEnd, $ = D.value;
      if ($ === void 0 && ($ = ""), H === oe) {
        var F = ae($, H);
        F !== H && Q(D, F, $);
      }
    };
    k(), requestAnimationFrame(function() {
      k();
    }), w(A), Ae(D);
  }, Ot = function(A) {
    A.persist && A.persist();
    var D = A.target, k = A.currentTarget;
    P.current = D, K.current.focusTimeout = setTimeout(function() {
      var H = D.selectionStart, oe = D.selectionEnd, $ = D.value;
      $ === void 0 && ($ = "");
      var F = ae($, H);
      F !== H && !(H === 0 && oe === $.length) && Q(D, F, $), p(Object.assign(Object.assign({}, A), { currentTarget: k }));
    }, 0);
  }, or = function(A) {
    P.current = null, clearTimeout(K.current.focusTimeout), clearTimeout(K.current.setCaretTimeout), S(A);
  }, ir = Ue && wc() ? "numeric" : void 0, At = Object.assign({ inputMode: ir }, I, {
    type: t,
    value: O,
    onChange: Nt,
    onKeyDown: gt,
    onMouseUp: _t,
    onFocus: Ot,
    onBlur: or
  });
  if (r === "text")
    return a ? lt.createElement(lt.Fragment, null, a(O, I) || null) : lt.createElement("span", Object.assign({}, I, { ref: o }), O);
  if (n) {
    var lr = n;
    return lt.createElement(lr, Object.assign({}, At, { ref: o }));
  }
  return lt.createElement("input", Object.assign({}, At, { ref: o }));
}
function bn(e, t) {
  var r = t.decimalScale, n = t.fixedDecimalScale, a = t.prefix;
  a === void 0 && (a = "");
  var o = t.suffix;
  o === void 0 && (o = "");
  var l = t.allowNegative, s = t.thousandsGroupStyle;
  if (s === void 0 && (s = "thousand"), e === "" || e === "-")
    return e;
  var f = rr(t), d = f.thousandSeparator, v = f.decimalSeparator, g = r !== 0 && e.indexOf(".") !== -1 || r && n, b = Fr(e, l), y = b.beforeDecimal, w = b.afterDecimal, p = b.addNegation;
  return r !== void 0 && (w = ia(w, r, !!n)), d && (y = vc(y, d, s)), a && (y = a + y), o && (w = w + o), p && (y = "-" + y), e = y + (g && v || "") + w, e;
}
function rr(e) {
  var t = e.decimalSeparator;
  t === void 0 && (t = ".");
  var r = e.thousandSeparator, n = e.allowedDecimalSeparators;
  return r === !0 && (r = ","), n || (n = [t, "."]), {
    decimalSeparator: t,
    thousandSeparator: r,
    allowedDecimalSeparators: n
  };
}
function Ac(e, t) {
  e === void 0 && (e = "");
  var r = new RegExp("(-)"), n = new RegExp("(-)(.)*(-)"), a = r.test(e), o = n.test(e);
  return e = e.replace(/-/g, ""), a && !o && t && (e = "-" + e), e;
}
function Rc(e, t) {
  return new RegExp("(^-)|[0-9]|" + oa(e), "g");
}
function Dc(e, t, r) {
  return e === "" ? !0 : !(t != null && t.match(/\d/)) && !(r != null && r.match(/\d/)) && typeof e == "string" && !isNaN(Number(e));
}
function Tc(e, t, r) {
  var n;
  t === void 0 && (t = yc(e));
  var a = r.allowNegative, o = r.prefix;
  o === void 0 && (o = "");
  var l = r.suffix;
  l === void 0 && (l = "");
  var s = r.decimalScale, f = t.from, d = t.to, v = d.start, g = d.end, b = rr(r), y = b.allowedDecimalSeparators, w = b.decimalSeparator, p = e[g] === w;
  if (Ct(e) && (e === o || e === l) && t.lastValue === "")
    return e;
  if (g - v === 1 && y.indexOf(e[v]) !== -1) {
    var S = s === 0 ? "" : w;
    e = e.substring(0, v) + S + e.substring(v + 1, e.length);
  }
  var C = function(P, K, te) {
    var ne = !1, Q = !1;
    o.startsWith("-") ? ne = !1 : P.startsWith("--") ? (ne = !1, Q = !0) : l.startsWith("-") && P.length === l.length ? ne = !1 : P[0] === "-" && (ne = !0);
    var ae = ne ? 1 : 0;
    return Q && (ae = 2), ae && (P = P.substring(ae), K -= ae, te -= ae), { value: P, start: K, end: te, hasNegation: ne };
  }, T = C(e, v, g), N = T.hasNegation;
  n = T, e = n.value, v = n.start, g = n.end;
  var L = C(t.lastValue, f.start, f.end), I = L.start, z = L.end, _ = L.value, O = e.substring(v, g);
  e.length && _.length && (I > _.length - l.length || z < o.length) && !(O && l.startsWith(O)) && (e = _);
  var j = 0;
  e.startsWith(o) ? j += o.length : v < o.length && (j = v), e = e.substring(j), g -= j;
  var B = e.length, ee = e.length - l.length;
  e.endsWith(l) ? B = ee : (g > ee || g > e.length - l.length) && (B = g), e = e.substring(0, B), e = Ac(N ? "-" + e : e, a), e = (e.match(Rc(w)) || []).join("");
  var le = e.indexOf(w);
  e = e.replace(new RegExp(oa(w), "g"), function(P, K) {
    return K === le ? "." : "";
  });
  var xe = Fr(e, a), Ie = xe.beforeDecimal, Ue = xe.afterDecimal, M = xe.addNegation;
  return d.end - d.start < f.end - f.start && Ie === "" && p && !parseFloat(Ue) && (e = M ? "-" : ""), e;
}
function Lc(e, t) {
  var r = t.prefix;
  r === void 0 && (r = "");
  var n = t.suffix;
  n === void 0 && (n = "");
  var a = Array.from({ length: e.length + 1 }).map(function() {
    return !0;
  }), o = e[0] === "-";
  a.fill(!1, 0, r.length + (o ? 1 : 0));
  var l = e.length;
  return a.fill(!1, l - n.length + 1, l + 1), a;
}
function Ic(e) {
  var t = rr(e), r = t.thousandSeparator, n = t.decimalSeparator, a = e.prefix;
  a === void 0 && (a = "");
  var o = e.allowNegative;
  if (o === void 0 && (o = !0), r === n)
    throw new Error(`
        Decimal separator can't be same as thousand separator.
        thousandSeparator: ` + r + ` (thousandSeparator = {true} is same as thousandSeparator = ",")
        decimalSeparator: ` + n + ` (default value for decimalSeparator is .)
     `);
  return a.startsWith("-") && o && (console.error(`
      Prefix can't start with '-' when allowNegative is true.
      prefix: ` + a + `
      allowNegative: ` + o + `
    `), o = !1), Object.assign(Object.assign({}, e), { allowNegative: o });
}
function Pc(e) {
  e = Ic(e), e.decimalSeparator, e.allowedDecimalSeparators, e.thousandsGroupStyle;
  var t = e.suffix, r = e.allowNegative, n = e.allowLeadingZeros, a = e.onKeyDown;
  a === void 0 && (a = Me);
  var o = e.onBlur;
  o === void 0 && (o = Me);
  var l = e.thousandSeparator, s = e.decimalScale, f = e.fixedDecimalScale, d = e.prefix;
  d === void 0 && (d = "");
  var v = e.defaultValue, g = e.value, b = e.valueIsNumericString, y = e.onValueChange, w = na(e, ["decimalSeparator", "allowedDecimalSeparators", "thousandsGroupStyle", "suffix", "allowNegative", "allowLeadingZeros", "onKeyDown", "onBlur", "thousandSeparator", "decimalScale", "fixedDecimalScale", "prefix", "defaultValue", "value", "valueIsNumericString", "onValueChange"]), p = rr(e), S = p.decimalSeparator, C = p.allowedDecimalSeparators, T = function(M) {
    return bn(M, e);
  }, N = function(M, P) {
    return Tc(M, P, e);
  }, L = dt(g) ? v : g, I = b ?? Dc(L, d, t);
  dt(g) ? dt(v) || (I = I || typeof v == "number") : I = I || typeof g == "number";
  var z = function(M) {
    return aa(M) ? M : (typeof M == "number" && (M = la(M)), I && typeof s == "number" ? gn(M, s, !!f) : M);
  }, _ = sa(z(g), z(v), !!I, T, N, y), O = _[0], j = O.numAsString, B = O.formattedValue, ee = _[1], le = function(M) {
    var P = M.target, K = M.key, te = P.selectionStart, ne = P.selectionEnd, Q = P.value;
    if (Q === void 0 && (Q = ""), (K === "Backspace" || K === "Delete") && ne < d.length) {
      M.preventDefault();
      return;
    }
    if (te !== ne) {
      a(M);
      return;
    }
    K === "Backspace" && Q[0] === "-" && te === d.length + 1 && r && ze(P, 1), s && f && (K === "Backspace" && Q[te - 1] === S ? (ze(P, te - 1), M.preventDefault()) : K === "Delete" && Q[te] === S && M.preventDefault()), C != null && C.includes(K) && Q[te] === S && ze(P, te + 1);
    var ae = l === !0 ? "," : l;
    K === "Backspace" && Q[te - 1] === ae && ze(P, te - 1), K === "Delete" && Q[te] === ae && ze(P, te + 1), a(M);
  }, xe = function(M) {
    var P = j;
    if (P.match(/\d/g) || (P = ""), n || (P = pc(P)), f && s && (P = gn(P, s, f)), P !== j) {
      var K = bn(P, e);
      ee({
        formattedValue: K,
        value: P,
        floatValue: parseFloat(P)
      }, {
        event: M,
        source: St.event
      });
    }
    o(M);
  }, Ie = function(M) {
    return M === S ? !0 : Ct(M);
  }, Ue = function(M) {
    var P = M.currentValue, K = M.lastValue, te = M.formattedValue, ne = M.currentValueIndex, Q = M.formattedValueIndex, ae = P[ne], W = te[Q], et = ca(K, P), We = et.to, we = function(tt) {
      return N(tt).indexOf(".") + d.length;
    };
    return g === 0 && f && s && P[We.start] === S && we(P) < ne && we(te) > Q ? !1 : ne >= We.start && ne < We.end && C && C.includes(ae) && W === S ? !0 : ae === W;
  };
  return Object.assign(Object.assign({}, w), {
    value: B,
    valueIsNumericString: !1,
    isValidInputCharacter: Ie,
    isCharacterSame: Ue,
    onValueChange: ee,
    format: T,
    removeFormatting: N,
    getCaretBoundary: function(M) {
      return Lc(M, e);
    },
    onKeyDown: le,
    onBlur: xe
  });
}
function kc(e) {
  var t = Pc(e);
  return lt.createElement(Oc, Object.assign({}, t));
}
const _d = Le(function({
  label: t,
  caption: r,
  disabled: n,
  errorMessage: a,
  leadingIcon: o,
  supportingText: l,
  amountCounter: s,
  trailingElement: f,
  isContentVisible: d,
  value: v,
  supportingValue: g,
  defaultValue: b,
  onClearInput: y,
  isVisibilityToggleEnabled: w,
  type: p,
  ...S
}, C) {
  w ?? (w = p === Se.Password);
  const T = ce(null), [N, L] = me(
    d ?? p !== Se.Password
  );
  fe(() => {
    L(d ?? p !== Se.Password);
  }, [p, d]);
  function I() {
    L((_) => !_);
  }
  function z() {
    var _;
    T.current && ((_ = T.current.querySelector("input")) == null || _.focus());
  }
  return /* @__PURE__ */ i(
    Br,
    {
      label: t,
      caption: r,
      disabled: n,
      errorMessage: a,
      amountCounter: s,
      required: S.required,
      children: /* @__PURE__ */ E(
        "div",
        {
          className: x(
            "input-container relative flex flex-row items-center gap-x-3",
            ta
          ),
          onClick: z,
          ref: T,
          children: [
            o && /* @__PURE__ */ i("span", { className: "input-icon-color", children: o }),
            /* @__PURE__ */ E("div", { className: "flex flex-1 flex-col items-start", children: [
              /* @__PURE__ */ i(
                Mc,
                {
                  ...S,
                  inputRef: C,
                  value: v,
                  type: p === Se.Password && N ? Se.Text : p,
                  disabled: n,
                  className: x(
                    Qn,
                    Jn,
                    ea,
                    cc
                  )
                }
              ),
              g && /* @__PURE__ */ i("span", { className: "text-label-md text-iota-neutral-60 names:text-iota-neutral-60 dark:text-iota-neutral-40", children: g })
            ] }),
            l && /* @__PURE__ */ i(qt, { children: l }),
            /* @__PURE__ */ i(
              Fc,
              {
                value: v,
                type: p,
                onClearInput: y,
                isContentVisible: N,
                trailingElement: f,
                isVisibilityToggleEnabled: w,
                onToggleButtonClick: I
              }
            )
          ]
        }
      )
    }
  );
});
function Mc({
  type: e,
  inputRef: t,
  ...r
}) {
  function n(a) {
    if (e === Se.Number) {
      const o = a.currentTarget;
      o.blur(), a.stopPropagation(), setTimeout(() => {
        o.focus({ preventScroll: !0 });
      }, 0);
    }
  }
  return e === Se.NumericFormat ? /* @__PURE__ */ i(Bc, { inputRef: t, ...r, type: e }) : /* @__PURE__ */ i(
    "input",
    {
      ref: t,
      ...r,
      type: e,
      onWheel: (a) => {
        var o;
        n(a), (o = r.onWheel) == null || o.call(r, a);
      }
    }
  );
}
function Bc({
  inputRef: e,
  className: t,
  type: r,
  ...n
}) {
  return /* @__PURE__ */ i(
    kc,
    {
      className: t,
      valueIsNumericString: !0,
      getInputRef: e,
      ...n
    }
  );
}
function Fc({
  value: e,
  type: t,
  onClearInput: r,
  isContentVisible: n,
  trailingElement: a,
  onToggleButtonClick: o,
  isVisibilityToggleEnabled: l
}) {
  const s = !!(t === Se.Text && e && r), f = !!(t === Se.Password && l), d = !!(a && !s && !f);
  if (s)
    return /* @__PURE__ */ i(
      se,
      {
        className: "input-icon-color [&_svg]:h-5 [&_svg]:w-5",
        onClick: r,
        tabIndex: -1,
        "aria-label": "Clear input",
        children: /* @__PURE__ */ i(Et, {})
      }
    );
  if (f)
    return /* @__PURE__ */ i(
      se,
      {
        onClick: o,
        className: "input-icon-color [&_svg]:h-5 [&_svg]:w-5",
        tabIndex: -1,
        "aria-label": "Toggle visibility",
        children: n ? /* @__PURE__ */ i(Kn, {}) : /* @__PURE__ */ i(Xn, {})
      }
    );
  if (d)
    return /* @__PURE__ */ i(li, { children: a });
}
const Od = Le(function({
  label: t,
  caption: r,
  disabled: n,
  errorMessage: a,
  value: o,
  amountCounter: l,
  isVisibilityToggleEnabled: s,
  isResizeEnabled: f,
  required: d,
  isContentVisible: v,
  defaultValue: g,
  ...b
}, y) {
  const [w, p] = me(
    v ?? !0
  );
  fe(() => {
    p(v ?? !0);
  }, [v]);
  function S() {
    p((C) => !C);
  }
  return /* @__PURE__ */ i(
    Br,
    {
      label: t,
      caption: r,
      disabled: n || !w,
      errorMessage: a,
      amountCounter: l,
      required: d,
      children: /* @__PURE__ */ E("div", { className: "relative", children: [
        /* @__PURE__ */ i(
          "textarea",
          {
            disabled: n || !w,
            required: d,
            ref: y,
            className: x(
              "text-area-container peer block min-h-[50px]",
              ta,
              Qn,
              Jn,
              ea,
              w && f ? "resize-y" : "resize-none",
              !w && "not-visible select-none text-transparent"
            ),
            defaultValue: w && g ? g : void 0,
            value: w && o ? o : void 0,
            ...b
          }
        ),
        !w && /* @__PURE__ */ i("div", { className: "absolute left-0 top-0 flex h-full w-full flex-col items-stretch gap-y-2 px-md py-sm peer-[.not-visible]:select-none", children: /* @__PURE__ */ i(Vc, { rows: 3, halfWidthRow: 3 }) }),
        s && /* @__PURE__ */ i("span", { className: "absolute bottom-4 right-4 flex", children: /* @__PURE__ */ i(
          se,
          {
            onClick: S,
            className: "input-icon-color [&_svg]:h-5 [&_svg]:w-5",
            tabIndex: -1,
            children: w ? /* @__PURE__ */ i(Kn, {}) : /* @__PURE__ */ i(Xn, {})
          }
        ) })
      ] })
    }
  );
});
function Vc({ rows: e, halfWidthRow: t }) {
  return /* @__PURE__ */ i(Ye, { children: Array.from({ length: e }).map((r, n) => {
    const o = t === n + 1 ? "w-1/2" : "w-full";
    return /* @__PURE__ */ i("div", { className: `input-visibility-bar h-2.5 rounded ${o}` }, n);
  }) });
}
var Vr = /* @__PURE__ */ ((e) => (e.Horizontal = "horizontal", e.Vertical = "vertical", e))(Vr || {});
const ua = "navbar-item-icon-selected-color", da = "navbar-item-icon-color", Uc = "py-xxs px-sm", Wc = "p-sm", fa = "bg-shader-primary-light-12 dark:bg-shader-primary-dark-12", jc = "-top-3 right-3", Gc = "-top-1 right-3", ha = "navbar-item-label-selected-color", ma = "navbar-item-label-color";
function Hc({
  icon: e,
  text: t,
  isSelected: r,
  hasBadge: n,
  onClick: a,
  isDisabled: o = !1,
  ...l
}) {
  const s = r ? ua : da, f = t ? Uc : Wc, d = r && fa, v = t ? jc : Gc, g = r ? ha : ma, b = o ? "cursor-not-allowed opacity-60" : "state-layer-secondary";
  return /* @__PURE__ */ E(
    "div",
    {
      onClick: (w) => {
        if (o) {
          w.preventDefault();
          return;
        }
        a == null || a(w);
      },
      role: "button",
      className: x(
        "inline-flex cursor-pointer flex-col items-center justify-center space-y-1"
      ),
      ...l,
      children: [
        /* @__PURE__ */ E(
          "div",
          {
            className: x(
              "relative inline-flex rounded-full",
              f,
              d,
              b
            ),
            children: [
              /* @__PURE__ */ i("div", { className: x("inline-flex [&_svg]:h-6 [&_svg]:w-6", s), children: e }),
              n && /* @__PURE__ */ i("div", { className: x("absolute", v), children: /* @__PURE__ */ i(Yt, { type: re.PrimarySolid }) })
            ]
          }
        ),
        t && /* @__PURE__ */ i("span", { className: x("text-center text-label-md", g), children: t })
      ]
    }
  );
}
function $c({
  icon: e,
  text: t,
  isSelected: r,
  hasBadge: n,
  onClick: a,
  isDisabled: o = !1,
  ...l
}) {
  const s = r ? ua : da, f = r && fa, d = r ? ha : ma;
  return /* @__PURE__ */ E(
    "div",
    {
      onClick: (b) => {
        if (o) {
          b.preventDefault();
          return;
        }
        a == null || a(b);
      },
      role: "button",
      className: x(
        "relative inline-flex w-full flex-row items-center justify-between rounded-full p-sm",
        f,
        o ? "cursor-not-allowed opacity-60" : "state-layer-secondary cursor-pointer "
      ),
      ...l,
      children: [
        /* @__PURE__ */ E("div", { className: "flex items-center gap-3", children: [
          /* @__PURE__ */ i("div", { className: x("inline-flex [&_svg]:h-6 [&_svg]:w-6", s), children: e }),
          t && /* @__PURE__ */ i("span", { className: x("text-center text-label-lg", d), children: t })
        ] }),
        n && /* @__PURE__ */ i(Yt, { type: re.PrimarySolid })
      ]
    }
  );
}
function va(e) {
  const { type: t, text: r } = e;
  return t === Vr.Vertical && r ? /* @__PURE__ */ i($c, { ...e }) : /* @__PURE__ */ i(Hc, { ...e });
}
function Ad({
  title: e,
  subtitle: t,
  badgeType: r,
  badgeText: n,
  avatarContent: a,
  onOptionsClick: o,
  onCopy: l,
  copyText: s,
  onOpen: f,
  isCopyable: d,
  isExternal: v,
  isSelected: g,
  isActive: b,
  showSelected: y,
  badgeTooltipText: w,
  badgeTooltipPosition: p = $e.Bottom
}) {
  const S = a;
  return /* @__PURE__ */ i(
    "div",
    {
      "data-testid": "account-tile",
      className: x(
        "state-layer group relative flex w-full items-center justify-between space-x-3 rounded-xl px-sm py-xs hover:cursor-pointer",
        b && "state-active"
      ),
      children: /* @__PURE__ */ E("div", { className: "flex w-full items-center gap-x-3", children: [
        /* @__PURE__ */ i("div", { children: /* @__PURE__ */ i(S, {}) }),
        /* @__PURE__ */ E("div", { className: "flex w-full min-w-0 flex-col items-start py-xs", children: [
          /* @__PURE__ */ E("div", { className: "flex w-full min-w-0 items-center space-x-2", children: [
            /* @__PURE__ */ i("p", { className: "account-title-color min-w-0 max-w-full truncate font-inter text-title-md", children: e }),
            n && r ? w ? /* @__PURE__ */ i(vt, { text: w, position: p, children: /* @__PURE__ */ i(Yt, { type: r, label: n }) }) : /* @__PURE__ */ i(Yt, { type: r, label: n }) : null
          ] }),
          /* @__PURE__ */ i(
            $l,
            {
              text: t,
              onCopySuccess: l,
              copyText: s,
              onOpen: f,
              isCopyable: d,
              isExternal: v
            }
          )
        ] }),
        /* @__PURE__ */ E("div", { className: "ml-auto flex items-center space-x-2 [&_button]:h-5 [&_button]:w-5 [&_svg]:h-5 [&_svg]:w-5", children: [
          /* @__PURE__ */ i("div", { className: "account-icon-color flex items-center space-x-2 [&_button:not(.locked)]:invisible group-hover:[&_button:not(.locked)]:visible", children: o && /* @__PURE__ */ i(se, { onClick: o, "aria-label": "More options", children: /* @__PURE__ */ i($n, {}) }) }),
          y && /* @__PURE__ */ i(se, { "aria-label": "Checkmark", children: g ? /* @__PURE__ */ i(tl, { className: "account-check-active-color h-5 w-5" }) : /* @__PURE__ */ i(zn, { className: "account-check-inactive-color h-5 w-5" }) })
        ] })
      ] })
    }
  );
}
function zc({ children: e }) {
  return /* @__PURE__ */ i("ul", { className: "dropdown-bg dropdown-border-color list-none rounded-lg border py-xs", children: e });
}
var Ht = /* @__PURE__ */ ((e) => (e.Top = "top", e.Bottom = "bottom", e))(Ht || {});
function Xc({
  children: e,
  hasLastBorderNoneClass: t,
  isContentCentered: r
}) {
  return /* @__PURE__ */ i(
    "td",
    {
      className: x(
        "table-cell-border-color h-14  border-b px-md",
        { "last:border-none": t },
        { "flex items-center justify-center": r }
      ),
      children: e
    }
  );
}
function Rd({
  children: e,
  supportingLabel: t
}) {
  return /* @__PURE__ */ E("div", { className: "flex flex-row items-baseline gap-1", children: [
    /* @__PURE__ */ i("span", { children: e }),
    t && /* @__PURE__ */ i("span", { className: "table-cell-supporting-label-color text-body-sm", children: t })
  ] });
}
function Dd() {
  return /* @__PURE__ */ i(kl, {});
}
var $t = /* @__PURE__ */ ((e) => (e.Small = "small", e.Default = "default", e))($t || {});
const Td = Le(
  ({
    disabled: e,
    label: t,
    leadingIcon: r,
    supportingText: n,
    errorMessage: a,
    caption: o,
    options: l,
    placeholder: s,
    onValueChange: f,
    onOptionClick: d,
    value: v,
    dropdownPosition: g = Ht.Bottom,
    size: b = $t.Default,
    ...y
  }, w) => {
    const [p, S] = me(!1), C = z(v, l), T = ce(null), N = C || s, L = b === $t.Small ? "px-sm" : "px-md", I = b === $t.Small ? "text-body-md" : "text-body-lg";
    fe(() => {
      e && p && j();
    }, [e, p]), fe(() => {
      if (!p) return;
      const B = (ee) => {
        const le = ee.target;
        T.current && !T.current.contains(le) && j();
      };
      return document.addEventListener("mousedown", B), () => {
        document.removeEventListener("mousedown", B);
      };
    }, [p]);
    function z(B, ee = []) {
      return ee.find(
        (le) => typeof le == "string" ? le === B : le.id === B
      ) ?? ee[0];
    }
    function _() {
      S((B) => !B);
    }
    function O(B) {
      j();
      const ee = typeof B == "string" ? B : B.id;
      d == null || d(ee), B !== C && (f == null || f(ee));
    }
    function j() {
      S(!1);
    }
    return /* @__PURE__ */ i(
      Br,
      {
        label: t,
        caption: o,
        disabled: e,
        errorMessage: a,
        labelHtmlTag: ra.Div,
        children: /* @__PURE__ */ E("div", { className: "relative flex w-full flex-col", ref: T, children: [
          /* @__PURE__ */ E(
            se,
            {
              ref: w,
              onClick: _,
              disabled: e,
              "aria-expanded": p,
              "aria-haspopup": "listbox",
              className: x(
                "select-container select-border-color focus-visible:enabled:select-border-focus-color active:enabled:select-border-focus-color group-[.errored]:select-border-error-color group-[.opened]:select-border-focus-color [&:is(:focus,_:focus-visible,_:active)]:enabled:select-border-focus-color hover:enabled:select-border-hover-color flex flex-row items-center gap-x-3 rounded-lg border py-sm disabled:cursor-not-allowed [&_svg]:h-5 [&_svg]:w-5",
                L
              ),
              ...y,
              children: [
                r && /* @__PURE__ */ i("span", { className: "select-icon-color", children: r }),
                /* @__PURE__ */ E("div", { className: "flex w-full flex-row items-baseline gap-x-3", children: [
                  N && /* @__PURE__ */ i(
                    "div",
                    {
                      className: x(
                        "select-label-color block w-full text-start",
                        I
                      ),
                      children: /* @__PURE__ */ i(xn, { option: N })
                    }
                  ),
                  n && /* @__PURE__ */ i("div", { className: "ml-auto", children: /* @__PURE__ */ i(qt, { children: n }) })
                ] }),
                /* @__PURE__ */ i(
                  dl,
                  {
                    className: x("select-icon-color transition-transform", {
                      " rotate-180": p
                    })
                  }
                )
              ]
            }
          ),
          p && /* @__PURE__ */ i(
            "div",
            {
              className: "fixed left-0 top-0 z-[49] bg-transparent",
              onClick: j
            }
          ),
          /* @__PURE__ */ i(
            "div",
            {
              className: x("absolute z-50 min-w-full", {
                hidden: !p,
                "top-full": !g || g === Ht.Bottom,
                "bottom-full": g === Ht.Top
              }),
              children: /* @__PURE__ */ i(zc, { children: l.map((B) => /* @__PURE__ */ i(
                Rl,
                {
                  onClick: () => O(B),
                  hideBottomBorder: !0,
                  children: /* @__PURE__ */ i(xn, { option: B })
                },
                typeof B == "string" ? B : B.id
              )) })
            }
          )
        ] })
      }
    );
  }
);
function xn({ option: e }) {
  return typeof e == "string" ? e : "renderLabel" in e ? e.renderLabel() : e.label;
}
var Pe = /* @__PURE__ */ ((e) => (e.Asc = "asc", e.Desc = "desc", e))(Pe || {});
function Kc({
  label: e,
  columnKey: t,
  hasSort: r,
  hasCheckbox: n,
  isChecked: a,
  isIndeterminate: o,
  isContentCentered: l,
  onSortClick: s,
  onCheckboxChange: f,
  sortOrder: d,
  ...v
}) {
  const g = () => {
    const p = d === Pe.Asc ? Pe.Desc : Pe.Asc;
    s && s(t, p);
  }, b = "table-header-text-color", y = "text-label-lg", w = r ? d === Pe.Asc ? /* @__PURE__ */ i(un, { className: "shrink-0" }) : d === Pe.Desc ? /* @__PURE__ */ i(ul, { className: "shrink-0" }) : /* @__PURE__ */ i(un, { className: "invisible shrink-0 group-hover:visible" }) : null;
  return /* @__PURE__ */ i(
    "th",
    {
      onClick: r ? g : void 0,
      className: x(
        "state-layer table-cell-border-color group relative h-14 border-b px-md after:pointer-events-none",
        {
          "cursor-pointer": r
        }
      ),
      "aria-sort": r ? d === Pe.Asc ? "ascending" : d === Pe.Desc ? "descending" : "none" : void 0,
      ...v,
      children: /* @__PURE__ */ E(
        "div",
        {
          className: x(
            "flex flex-row items-center gap-1 [&_svg]:h-4 [&_svg]:w-4",
            b,
            y,
            {
              "justify-center": l
            }
          ),
          children: [
            n ? /* @__PURE__ */ i(
              Zn,
              {
                isChecked: a,
                isIndeterminate: o,
                onCheckedChange: f
              }
            ) : /* @__PURE__ */ i(
              "span",
              {
                className: x({
                  "text-left": !l
                }),
                children: e
              }
            ),
            w
          ]
        }
      )
    }
  );
}
var Ne = /* @__PURE__ */ ((e) => (e.Outlined = "outlined", e.Filled = "filled", e))(Ne || {});
const Zc = {
  [Ne.Outlined]: "bg-transparent",
  [Ne.Filled]: "search-bg-color-filled"
}, Yc = {
  [Ne.Outlined]: "border-l border-r border-t search-border-color",
  [Ne.Filled]: "search-bg-color-filled"
}, qc = {
  [Ne.Outlined]: "rounded-b-3xl border-b border-l border-r search-border-color search-suggestion-bg-color",
  [Ne.Filled]: "rounded-b-3xl search-bg-color-filled"
};
function Ld({
  searchValue: e,
  suggestions: t,
  onSearchValueChange: r,
  onSuggestionClick: n,
  placeholder: a,
  isLoading: o = !1,
  type: l = Ne.Outlined,
  renderSuggestion: s,
  ...f
}) {
  const d = ce(null), v = ce(null), [g, b] = me(!0), [y, w] = me(null);
  function p(_) {
    const O = _.target.value;
    r(O);
  }
  fe(() => {
    const _ = (O) => {
      var j;
      O.key === "Escape" && (b(!1), (j = d.current) == null || j.blur());
    };
    return document.addEventListener("keydown", _), () => {
      document.removeEventListener("keydown", _);
    };
  }, []), fe(() => {
    const _ = (O) => {
      var B;
      const j = d == null ? void 0 : d.current;
      !j || j.contains(O == null ? void 0 : O.target) || (B = v.current) != null && B.contains(O.target) || b(!1);
    };
    return document.addEventListener("click", _, !0), document.addEventListener("touchstart", _, !0), () => {
      document.removeEventListener("click", _, !0), document.removeEventListener("touchstart", _, !0);
    };
  }, [d]);
  const S = g && t && t.length > 0, C = S ? x(
    "rounded-t-3xl border-b",
    l === Ne.Outlined ? "[&:not(.dark_*,.names_*)]:border-b-transparent" : "border-b-transparent"
  ) : l === Ne.Outlined ? "rounded-3xl border-b" : "rounded-full", T = Yc[l], N = Zc[l], L = qc[l], I = (_) => {
    var O;
    n == null || n(_), r(""), b(!1), w(null), (O = d.current) == null || O.blur();
  }, z = (_) => {
    t && (t == null ? void 0 : t.length) > 0 && (_.key === "ArrowDown" ? (_.preventDefault(), w(
      (O) => O === null || O >= t.length - 1 ? 0 : O + 1
    )) : _.key === "ArrowUp" ? (_.preventDefault(), w(
      (O) => O === null || O <= 0 ? t.length - 1 : O - 1
    )) : _.key === "Enter" && (_.preventDefault(), y !== null && t[y] ? I(t[y]) : t.length === 1 && I(t[0])));
  };
  return /* @__PURE__ */ E("div", { className: "relative w-full", children: [
    /* @__PURE__ */ E(
      "div",
      {
        className: x(
          "search-text-color flex items-center overflow-hidden px-md py-sm [&_svg]:h-6 [&_svg]:w-6",
          C,
          T
        ),
        children: [
          /* @__PURE__ */ i(
            "input",
            {
              ref: d,
              type: "text",
              value: e,
              onChange: p,
              onKeyDown: z,
              onFocus: () => b(!0),
              placeholder: a,
              className: x(
                "search-placeholder-color w-full flex-1 outline-none",
                N
              ),
              role: "combobox",
              "aria-expanded": S,
              "aria-haspopup": "listbox",
              "aria-autocomplete": "list",
              ...f
            }
          ),
          /* @__PURE__ */ i(sl, {})
        ]
      }
    ),
    S && s && /* @__PURE__ */ E(
      "div",
      {
        ref: v,
        className: x(
          "absolute left-0 top-full flex w-full flex-col items-center overflow-hidden",
          L
        ),
        role: "listbox",
        children: [
          /* @__PURE__ */ i(Nl, { width: "w-11/12" }),
          o ? /* @__PURE__ */ i("div", { className: "px-md py-sm", children: /* @__PURE__ */ i(Hn, { className: "animate-spin" }) }) : t.map((_, O) => /* @__PURE__ */ i(
            "div",
            {
              onClick: () => I(_),
              onMouseEnter: () => w(O),
              className: x(
                "w-full cursor-pointer px-md py-sm",
                y === O ? "search-selected-index-bg-color" : ""
              ),
              role: "option",
              "aria-selected": y === O,
              "aria-label": _.label,
              children: s(_, O)
            },
            _.id
          ))
        ]
      }
    )
  ] });
}
var yt = /* @__PURE__ */ ((e) => (e.Default = "default", e.Outlined = "outlined", e.Filled = "filled", e))(yt || {}), Ze = /* @__PURE__ */ ((e) => (e.Placeholder = "placeholder", e.BgSolid = "bg-solid", e.BgWhite = "bg-white", e.BgTransparent = "bg-transparent", e))(Ze || {}), mt = /* @__PURE__ */ ((e) => (e.Rounded = "rounded", e.SquareRounded = "square-rounded", e))(mt || {}), zt = /* @__PURE__ */ ((e) => (e.Link = "link", e.SupportingText = "supporting-text", e.Button = "button", e))(zt || {});
const Qc = "cursor-default opacity-40", wn = "h-10 w-10", yn = {
  [mt.SquareRounded]: `${wn} rounded-md`,
  [mt.Rounded]: `${wn} rounded-full`
}, Jc = {
  [Ze.Placeholder]: "",
  [Ze.BgSolid]: "card-image-bg-solid",
  [Ze.BgWhite]: "card-image-bg-white",
  [Ze.BgTransparent]: ""
}, es = {
  [yt.Default]: "border border-transparent",
  [yt.Outlined]: "border border-shader-neutral-light-8 dark:border-shader-primary-dark-8 p-xs",
  [yt.Filled]: "border border-transparent card-filled-bg p-xs"
};
function Id({
  isDisabled: e = !1,
  type: t = yt.Default,
  isHoverable: r,
  onClick: n,
  children: a,
  testId: o,
  ...l
}) {
  function s() {
    e || n == null || n();
  }
  const f = !e && n;
  return /* @__PURE__ */ i(
    "div",
    {
      onClick: s,
      role: f ? "button" : void 0,
      className: x(
        "relative inline-flex w-full items-center gap-3 rounded-xl px-sm py-xs",
        es[t],
        {
          "state-layer": r || f,
          [Qc]: e,
          "cursor-pointer": n
        }
      ),
      "data-testid": o,
      ...l,
      children: a
    }
  );
}
function Pd({
  type: e,
  onClick: t,
  subtitle: r,
  title: n,
  icon: a,
  iconAfterText: o,
  buttonType: l,
  buttonDisabled: s
}) {
  function f(d) {
    t && (d.stopPropagation(), t());
  }
  return e === zt.Link ? /* @__PURE__ */ i(
    "div",
    {
      onClick: f,
      className: "card-action-link-color shrink-0 [&_svg]:h-5 [&_svg]:w-5",
      children: a || /* @__PURE__ */ i(kr, {})
    }
  ) : e === zt.SupportingText ? /* @__PURE__ */ E("div", { className: "shrink-0 text-right", children: [
    n && /* @__PURE__ */ i("div", { className: "card-action-title-color font-inter text-label-md", children: n }),
    r && /* @__PURE__ */ i("div", { className: "card-action-subtitle-color font-inter text-label-sm", children: r })
  ] }) : e === zt.Button ? /* @__PURE__ */ i("div", { className: "shrink-0", children: /* @__PURE__ */ i(
    pe,
    {
      type: l || U.Outlined,
      size: ie.Small,
      text: n,
      onClick: f,
      icon: a,
      iconAfterText: o,
      disabled: s
    }
  ) }) : null;
}
function ts({ variant: e = mt.Rounded }) {
  return e === mt.Rounded ? /* @__PURE__ */ i(rs, {}) : /* @__PURE__ */ i(ns, {});
}
function rs() {
  return /* @__PURE__ */ E(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "40",
      height: "40",
      viewBox: "0 0 40 40",
      fill: "none",
      children: [
        /* @__PURE__ */ E("g", { "clip-path": "url(#clip0_880_55185)", children: [
          /* @__PURE__ */ i(
            "path",
            {
              d: "M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z",
              fill: "#5B9CFE"
            }
          ),
          /* @__PURE__ */ i(
            "path",
            {
              d: "M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z",
              fill: "url(#paint0_linear_880_55185)",
              "fill-opacity": "0.2"
            }
          ),
          /* @__PURE__ */ i(
            "path",
            {
              d: "M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z",
              fill: "url(#paint1_linear_880_55185)",
              "fill-opacity": "0.2"
            }
          ),
          /* @__PURE__ */ i(
            "path",
            {
              d: "M0.5 20C0.5 9.23045 9.23045 0.5 20 0.5C30.7696 0.5 39.5 9.23045 39.5 20C39.5 30.7696 30.7696 39.5 20 39.5C9.23045 39.5 0.5 30.7696 0.5 20Z",
              stroke: "#002F6D",
              "stroke-opacity": "0.08"
            }
          )
        ] }),
        /* @__PURE__ */ E("defs", { children: [
          /* @__PURE__ */ E(
            "linearGradient",
            {
              id: "paint0_linear_880_55185",
              x1: "20",
              y1: "0",
              x2: "29.5238",
              y2: "22.381",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ i("stop", { offset: "0.990135", "stop-opacity": "0" }),
                /* @__PURE__ */ i("stop", { offset: "1" })
              ]
            }
          ),
          /* @__PURE__ */ E(
            "linearGradient",
            {
              id: "paint1_linear_880_55185",
              x1: "20",
              y1: "0",
              x2: "11.4286",
              y2: "9.04762",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ i("stop", { offset: "0.9999", "stop-opacity": "0" }),
                /* @__PURE__ */ i("stop", { offset: "1" })
              ]
            }
          ),
          /* @__PURE__ */ i("clipPath", { id: "clip0_880_55185", children: /* @__PURE__ */ i(
            "path",
            {
              d: "M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z",
              fill: "white"
            }
          ) })
        ] })
      ]
    }
  );
}
function ns() {
  return /* @__PURE__ */ E(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "40",
      height: "40",
      viewBox: "0 0 40 40",
      fill: "none",
      children: [
        /* @__PURE__ */ E("g", { "clip-path": "url(#clip0_880_55190)", children: [
          /* @__PURE__ */ i(
            "path",
            {
              d: "M0 8C0 3.58172 3.58172 0 8 0H32C36.4183 0 40 3.58172 40 8V32C40 36.4183 36.4183 40 32 40H8C3.58172 40 0 36.4183 0 32V8Z",
              fill: "#5B9CFE"
            }
          ),
          /* @__PURE__ */ i(
            "path",
            {
              d: "M0 8C0 3.58172 3.58172 0 8 0H32C36.4183 0 40 3.58172 40 8V32C40 36.4183 36.4183 40 32 40H8C3.58172 40 0 36.4183 0 32V8Z",
              fill: "url(#paint0_linear_880_55190)",
              "fill-opacity": "0.2"
            }
          ),
          /* @__PURE__ */ i(
            "path",
            {
              d: "M0 8C0 3.58172 3.58172 0 8 0H32C36.4183 0 40 3.58172 40 8V32C40 36.4183 36.4183 40 32 40H8C3.58172 40 0 36.4183 0 32V8Z",
              fill: "url(#paint1_linear_880_55190)",
              "fill-opacity": "0.2"
            }
          ),
          /* @__PURE__ */ i(
            "path",
            {
              d: "M0.5 8C0.5 3.85786 3.85786 0.5 8 0.5H32C36.1421 0.5 39.5 3.85786 39.5 8V32C39.5 36.1421 36.1421 39.5 32 39.5H8C3.85786 39.5 0.5 36.1421 0.5 32V8Z",
              stroke: "#002F6D",
              "stroke-opacity": "0.08"
            }
          )
        ] }),
        /* @__PURE__ */ E("defs", { children: [
          /* @__PURE__ */ E(
            "linearGradient",
            {
              id: "paint0_linear_880_55190",
              x1: "20",
              y1: "0",
              x2: "29.5238",
              y2: "22.381",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ i("stop", { offset: "0.990135", "stop-opacity": "0" }),
                /* @__PURE__ */ i("stop", { offset: "1" })
              ]
            }
          ),
          /* @__PURE__ */ E(
            "linearGradient",
            {
              id: "paint1_linear_880_55190",
              x1: "20",
              y1: "0",
              x2: "11.4286",
              y2: "9.04762",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ i("stop", { offset: "0.9999", "stop-opacity": "0" }),
                /* @__PURE__ */ i("stop", { offset: "1" })
              ]
            }
          ),
          /* @__PURE__ */ i("clipPath", { id: "clip0_880_55190", children: /* @__PURE__ */ i(
            "path",
            {
              d: "M0 8C0 3.58172 3.58172 0 8 0H32C36.4183 0 40 3.58172 40 8V32C40 36.4183 36.4183 40 32 40H8C3.58172 40 0 36.4183 0 32V8Z",
              fill: "white"
            }
          ) })
        ] })
      ]
    }
  );
}
function kd({
  type: e = Ze.BgSolid,
  shape: t = mt.Rounded,
  url: r,
  children: n
}) {
  return /* @__PURE__ */ E(
    "div",
    {
      className: x(
        yn[t],
        Jc[e],
        "flex shrink-0 items-center justify-center  overflow-hidden"
      ),
      children: [
        e === Ze.Placeholder && !n && /* @__PURE__ */ i(ts, { variant: t }),
        r && !n && /* @__PURE__ */ i(
          "img",
          {
            src: r,
            className: x(yn[t], "object-cover"),
            alt: "Card Image"
          }
        ),
        n
      ]
    }
  );
}
function Md({
  title: e,
  subtitle: t,
  clickableAction: r,
  icon: n,
  isTextTruncated: a,
  tooltipText: o,
  tooltipPosition: l
}) {
  const s = (f) => {
    f == null || f.stopPropagation();
  };
  return /* @__PURE__ */ E(
    "div",
    {
      className: x("flex w-full flex-col", {
        truncate: a
      }),
      children: [
        /* @__PURE__ */ E(
          "div",
          {
            className: x("flex flex-row items-center gap-x-xxs", {
              "grow-1": a
            }),
            children: [
              /* @__PURE__ */ i(
                "div",
                {
                  className: x("card-body-title-color font-inter text-title-md", {
                    truncate: a
                  }),
                  children: e
                }
              ),
              o ? /* @__PURE__ */ i(vt, { text: o, position: l, children: n }) : /* @__PURE__ */ i("div", { className: "flex items-center", children: n }),
              r && /* @__PURE__ */ i("div", { onClick: s, className: "flex items-center", children: r })
            ]
          }
        ),
        t && /* @__PURE__ */ i(
          "div",
          {
            className: x("card-body-subtitle-color font-inter text-body-md", {
              truncate: a
            }),
            children: t
          }
        )
      ]
    }
  );
}
var Be = /* @__PURE__ */ ((e) => (e.Default = "default", e.Highlight = "highlight", e.Secondary = "secondary", e))(Be || {}), _e = /* @__PURE__ */ ((e) => (e.Default = "default", e.Large = "large", e))(_e || {});
const as = {
  [Be.Default]: "display-stats-bg-default",
  [Be.Highlight]: "display-stats-bg-highlight",
  [Be.Secondary]: "display-stats-bg-secondary"
}, os = {
  [Be.Default]: "display-stats-text-default",
  [Be.Highlight]: "display-stats-text-highlight",
  [Be.Secondary]: "display-stats-text-secondary"
}, is = {
  [_e.Default]: "gap-y-sm",
  [_e.Large]: "gap-y-md"
}, ls = {
  [_e.Default]: "text-title-md",
  [_e.Large]: "text-headline-sm"
}, cs = {
  [_e.Default]: "text-label-md",
  [_e.Large]: "text-label-lg"
}, ss = {
  [_e.Default]: "text-label-sm",
  [_e.Large]: "text-label-md"
};
function Bd({
  label: e,
  tooltipPosition: t,
  tooltipText: r,
  value: n,
  supportingLabel: a,
  type: o = Be.Default,
  size: l = _e.Default,
  icon: s,
  copyText: f,
  onCopySuccess: d,
  onCopyError: v
}) {
  const g = as[o], b = is[l], y = os[o], w = ls[l], p = ss[l], S = cs[l];
  async function C(T) {
    if (navigator.clipboard && f)
      try {
        await navigator.clipboard.writeText(f), d == null || d(T, f);
      } catch (N) {
        console.error("Failed to copy:", N), v == null || v(N, f);
      }
  }
  return /* @__PURE__ */ E(
    "div",
    {
      className: x(
        "flex h-full w-full flex-col justify-between rounded-2xl p-md--rs",
        g,
        b,
        y
      ),
      children: [
        /* @__PURE__ */ E(
          "div",
          {
            className: x("flex flex-row items-center", {
              "w-full justify-between": s
            }),
            children: [
              /* @__PURE__ */ E("div", { className: "flex flex-row items-center gap-xxs", children: [
                /* @__PURE__ */ i("span", { className: x(p, "whitespace-pre-line"), children: e }),
                r && /* @__PURE__ */ i(vt, { text: r, position: t, children: /* @__PURE__ */ i(tr, { className: "opacity-40" }) })
              ] }),
              s && /* @__PURE__ */ i("span", { className: "display-stats-icon-color", children: s })
            ]
          }
        ),
        /* @__PURE__ */ E("div", { className: "flex w-full flex-row items-baseline gap-xxs", children: [
          /* @__PURE__ */ i("span", { className: x("break-all", w), children: n }),
          a && /* @__PURE__ */ i("span", { className: x("opacity-40", S), children: a }),
          f && /* @__PURE__ */ i("div", { className: "self-center", children: /* @__PURE__ */ i(se, { onClick: C, "aria-label": "Copy to clipboard", children: /* @__PURE__ */ i(Mr, { className: "display-stats-copy-icon-color" }) }) })
        ] })
      ]
    }
  );
}
function Fd({
  onIconClick: e,
  onClick: t,
  icon: r = /* @__PURE__ */ i($n, {}),
  assetTitle: n,
  isHoverable: a = !0,
  ...o
}) {
  const l = (f) => {
    e == null || e(f), f == null || f.stopPropagation();
  }, s = !("src" in o);
  return /* @__PURE__ */ E(
    "div",
    {
      className: x("relative aspect-square w-full overflow-hidden rounded-xl", {
        "group cursor-pointer": a
      }),
      onClick: t,
      children: [
        !s && /* @__PURE__ */ i(zl, { ...o }),
        s && o.renderAsset,
        a && /* @__PURE__ */ i("div", { className: "absolute left-0 top-0 h-full w-full bg-cover bg-center bg-no-repeat group-hover:bg-shader-neutral-light-48 group-hover:transition group-hover:duration-300 group-hover:ease-in-out group-hover:names:bg-shader-inverted-light-48 group-hover:dark:bg-shader-primary-dark-48" }),
        a && e && /* @__PURE__ */ i(
          se,
          {
            className: "visual-asset-icon-color absolute right-2 top-2 z-10 h-9 w-9 cursor-pointer rounded-full p-xs opacity-0 transition-opacity duration-300 group-hover:bg-shader-neutral-light-72 group-hover:opacity-100 [&_svg]:h-5 [&_svg]:w-5",
            onClick: l,
            "aria-label": "More options",
            children: r
          }
        ),
        a && n && /* @__PURE__ */ i("div", { className: "absolute bottom-0 w-full p-xs opacity-0 transition-opacity duration-300 group-hover:opacity-100", children: /* @__PURE__ */ i("span", { className: "visual-asset-title-color break-words text-title-md", children: n }) })
      ]
    }
  );
}
function Fe(e, t, { checkForDefaultPrevented: r = !0 } = {}) {
  return function(a) {
    if (e == null || e(a), r === !1 || !a.defaultPrevented)
      return t == null ? void 0 : t(a);
  };
}
function us(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function ga(...e) {
  return (t) => e.forEach((r) => us(r, t));
}
function Je(...e) {
  return m.useCallback(ga(...e), e);
}
function ds(e, t) {
  const r = m.createContext(t);
  function n(o) {
    const { children: l, ...s } = o, f = m.useMemo(() => s, Object.values(s));
    return /* @__PURE__ */ i(r.Provider, { value: f, children: l });
  }
  function a(o) {
    const l = m.useContext(r);
    if (l) return l;
    if (t !== void 0) return t;
    throw new Error(`\`${o}\` must be used within \`${e}\``);
  }
  return n.displayName = e + "Provider", [n, a];
}
function fs(e, t = []) {
  let r = [];
  function n(o, l) {
    const s = m.createContext(l), f = r.length;
    r = [...r, l];
    function d(g) {
      const { scope: b, children: y, ...w } = g, p = (b == null ? void 0 : b[e][f]) || s, S = m.useMemo(() => w, Object.values(w));
      return /* @__PURE__ */ i(p.Provider, { value: S, children: y });
    }
    function v(g, b) {
      const y = (b == null ? void 0 : b[e][f]) || s, w = m.useContext(y);
      if (w) return w;
      if (l !== void 0) return l;
      throw new Error(`\`${g}\` must be used within \`${o}\``);
    }
    return d.displayName = o + "Provider", [d, v];
  }
  const a = () => {
    const o = r.map((l) => m.createContext(l));
    return function(s) {
      const f = (s == null ? void 0 : s[e]) || o;
      return m.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: f } }),
        [s, f]
      );
    };
  };
  return a.scopeName = e, [n, hs(a, ...t)];
}
function hs(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const r = () => {
    const n = e.map((a) => ({
      useScope: a(),
      scopeName: a.scopeName
    }));
    return function(o) {
      const l = n.reduce((s, { useScope: f, scopeName: d }) => {
        const g = f(o)[`__scope${d}`];
        return { ...s, ...g };
      }, {});
      return m.useMemo(() => ({ [`__scope${t.scopeName}`]: l }), [l]);
    };
  };
  return r.scopeName = t.scopeName, r;
}
var Qt = globalThis != null && globalThis.document ? m.useLayoutEffect : () => {
}, ms = m.useId || (() => {
}), vs = 0;
function wr(e) {
  const [t, r] = m.useState(ms());
  return Qt(() => {
    e || r((n) => n ?? String(vs++));
  }, [e]), e || (t ? `radix-${t}` : "");
}
function qe(e) {
  const t = m.useRef(e);
  return m.useEffect(() => {
    t.current = e;
  }), m.useMemo(() => (...r) => {
    var n;
    return (n = t.current) == null ? void 0 : n.call(t, ...r);
  }, []);
}
function gs({
  prop: e,
  defaultProp: t,
  onChange: r = () => {
  }
}) {
  const [n, a] = ps({ defaultProp: t, onChange: r }), o = e !== void 0, l = o ? e : n, s = qe(r), f = m.useCallback(
    (d) => {
      if (o) {
        const g = typeof d == "function" ? d(e) : d;
        g !== e && s(g);
      } else
        a(d);
    },
    [o, e, a, s]
  );
  return [l, f];
}
function ps({
  defaultProp: e,
  onChange: t
}) {
  const r = m.useState(e), [n] = r, a = m.useRef(n), o = qe(t);
  return m.useEffect(() => {
    a.current !== n && (o(n), a.current = n);
  }, [n, a, o]), r;
}
var Ur = m.forwardRef((e, t) => {
  const { children: r, ...n } = e, a = m.Children.toArray(r), o = a.find(xs);
  if (o) {
    const l = o.props.children, s = a.map((f) => f === o ? m.Children.count(l) > 1 ? m.Children.only(null) : m.isValidElement(l) ? l.props.children : null : f);
    return /* @__PURE__ */ i(Tr, { ...n, ref: t, children: m.isValidElement(l) ? m.cloneElement(l, void 0, s) : null });
  }
  return /* @__PURE__ */ i(Tr, { ...n, ref: t, children: r });
});
Ur.displayName = "Slot";
var Tr = m.forwardRef((e, t) => {
  const { children: r, ...n } = e;
  if (m.isValidElement(r)) {
    const a = ys(r);
    return m.cloneElement(r, {
      ...ws(n, r.props),
      // @ts-ignore
      ref: t ? ga(t, a) : a
    });
  }
  return m.Children.count(r) > 1 ? m.Children.only(null) : null;
});
Tr.displayName = "SlotClone";
var bs = ({ children: e }) => /* @__PURE__ */ i(Ye, { children: e });
function xs(e) {
  return m.isValidElement(e) && e.type === bs;
}
function ws(e, t) {
  const r = { ...t };
  for (const n in t) {
    const a = e[n], o = t[n];
    /^on[A-Z]/.test(n) ? a && o ? r[n] = (...s) => {
      o(...s), a(...s);
    } : a && (r[n] = a) : n === "style" ? r[n] = { ...a, ...o } : n === "className" && (r[n] = [a, o].filter(Boolean).join(" "));
  }
  return { ...e, ...r };
}
function ys(e) {
  var n, a;
  let t = (n = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : n.get, r = t && "isReactWarning" in t && t.isReactWarning;
  return r ? e.ref : (t = (a = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : a.get, r = t && "isReactWarning" in t && t.isReactWarning, r ? e.props.ref : e.props.ref || e.ref);
}
var Ss = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Oe = Ss.reduce((e, t) => {
  const r = m.forwardRef((n, a) => {
    const { asChild: o, ...l } = n, s = o ? Ur : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ i(s, { ...l, ref: a });
  });
  return r.displayName = `Primitive.${t}`, { ...e, [t]: r };
}, {});
function Cs(e, t) {
  e && Pn.flushSync(() => e.dispatchEvent(t));
}
function Es(e, t = globalThis == null ? void 0 : globalThis.document) {
  const r = qe(e);
  m.useEffect(() => {
    const n = (a) => {
      a.key === "Escape" && r(a);
    };
    return t.addEventListener("keydown", n, { capture: !0 }), () => t.removeEventListener("keydown", n, { capture: !0 });
  }, [r, t]);
}
var Ns = "DismissableLayer", Lr = "dismissableLayer.update", _s = "dismissableLayer.pointerDownOutside", Os = "dismissableLayer.focusOutside", Sn, pa = m.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), ba = m.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: r = !1,
      onEscapeKeyDown: n,
      onPointerDownOutside: a,
      onFocusOutside: o,
      onInteractOutside: l,
      onDismiss: s,
      ...f
    } = e, d = m.useContext(pa), [v, g] = m.useState(null), b = (v == null ? void 0 : v.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, y] = m.useState({}), w = Je(t, (_) => g(_)), p = Array.from(d.layers), [S] = [...d.layersWithOutsidePointerEventsDisabled].slice(-1), C = p.indexOf(S), T = v ? p.indexOf(v) : -1, N = d.layersWithOutsidePointerEventsDisabled.size > 0, L = T >= C, I = Ds((_) => {
      const O = _.target, j = [...d.branches].some((B) => B.contains(O));
      !L || j || (a == null || a(_), l == null || l(_), _.defaultPrevented || s == null || s());
    }, b), z = Ts((_) => {
      const O = _.target;
      [...d.branches].some((B) => B.contains(O)) || (o == null || o(_), l == null || l(_), _.defaultPrevented || s == null || s());
    }, b);
    return Es((_) => {
      T === d.layers.size - 1 && (n == null || n(_), !_.defaultPrevented && s && (_.preventDefault(), s()));
    }, b), m.useEffect(() => {
      if (v)
        return r && (d.layersWithOutsidePointerEventsDisabled.size === 0 && (Sn = b.body.style.pointerEvents, b.body.style.pointerEvents = "none"), d.layersWithOutsidePointerEventsDisabled.add(v)), d.layers.add(v), Cn(), () => {
          r && d.layersWithOutsidePointerEventsDisabled.size === 1 && (b.body.style.pointerEvents = Sn);
        };
    }, [v, b, r, d]), m.useEffect(() => () => {
      v && (d.layers.delete(v), d.layersWithOutsidePointerEventsDisabled.delete(v), Cn());
    }, [v, d]), m.useEffect(() => {
      const _ = () => y({});
      return document.addEventListener(Lr, _), () => document.removeEventListener(Lr, _);
    }, []), /* @__PURE__ */ i(
      Oe.div,
      {
        ...f,
        ref: w,
        style: {
          pointerEvents: N ? L ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: Fe(e.onFocusCapture, z.onFocusCapture),
        onBlurCapture: Fe(e.onBlurCapture, z.onBlurCapture),
        onPointerDownCapture: Fe(
          e.onPointerDownCapture,
          I.onPointerDownCapture
        )
      }
    );
  }
);
ba.displayName = Ns;
var As = "DismissableLayerBranch", Rs = m.forwardRef((e, t) => {
  const r = m.useContext(pa), n = m.useRef(null), a = Je(t, n);
  return m.useEffect(() => {
    const o = n.current;
    if (o)
      return r.branches.add(o), () => {
        r.branches.delete(o);
      };
  }, [r.branches]), /* @__PURE__ */ i(Oe.div, { ...e, ref: a });
});
Rs.displayName = As;
function Ds(e, t = globalThis == null ? void 0 : globalThis.document) {
  const r = qe(e), n = m.useRef(!1), a = m.useRef(() => {
  });
  return m.useEffect(() => {
    const o = (s) => {
      if (s.target && !n.current) {
        let f = function() {
          xa(
            _s,
            r,
            d,
            { discrete: !0 }
          );
        };
        const d = { originalEvent: s };
        s.pointerType === "touch" ? (t.removeEventListener("click", a.current), a.current = f, t.addEventListener("click", a.current, { once: !0 })) : f();
      } else
        t.removeEventListener("click", a.current);
      n.current = !1;
    }, l = window.setTimeout(() => {
      t.addEventListener("pointerdown", o);
    }, 0);
    return () => {
      window.clearTimeout(l), t.removeEventListener("pointerdown", o), t.removeEventListener("click", a.current);
    };
  }, [t, r]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => n.current = !0
  };
}
function Ts(e, t = globalThis == null ? void 0 : globalThis.document) {
  const r = qe(e), n = m.useRef(!1);
  return m.useEffect(() => {
    const a = (o) => {
      o.target && !n.current && xa(Os, r, { originalEvent: o }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", a), () => t.removeEventListener("focusin", a);
  }, [t, r]), {
    onFocusCapture: () => n.current = !0,
    onBlurCapture: () => n.current = !1
  };
}
function Cn() {
  const e = new CustomEvent(Lr);
  document.dispatchEvent(e);
}
function xa(e, t, r, { discrete: n }) {
  const a = r.originalEvent.target, o = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: r });
  t && a.addEventListener(e, t, { once: !0 }), n ? Cs(a, o) : a.dispatchEvent(o);
}
var yr = "focusScope.autoFocusOnMount", Sr = "focusScope.autoFocusOnUnmount", En = { bubbles: !1, cancelable: !0 }, Ls = "FocusScope", wa = m.forwardRef((e, t) => {
  const {
    loop: r = !1,
    trapped: n = !1,
    onMountAutoFocus: a,
    onUnmountAutoFocus: o,
    ...l
  } = e, [s, f] = m.useState(null), d = qe(a), v = qe(o), g = m.useRef(null), b = Je(t, (p) => f(p)), y = m.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  m.useEffect(() => {
    if (n) {
      let p = function(N) {
        if (y.paused || !s) return;
        const L = N.target;
        s.contains(L) ? g.current = L : ke(g.current, { select: !0 });
      }, S = function(N) {
        if (y.paused || !s) return;
        const L = N.relatedTarget;
        L !== null && (s.contains(L) || ke(g.current, { select: !0 }));
      }, C = function(N) {
        if (document.activeElement === document.body)
          for (const I of N)
            I.removedNodes.length > 0 && ke(s);
      };
      document.addEventListener("focusin", p), document.addEventListener("focusout", S);
      const T = new MutationObserver(C);
      return s && T.observe(s, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", p), document.removeEventListener("focusout", S), T.disconnect();
      };
    }
  }, [n, s, y.paused]), m.useEffect(() => {
    if (s) {
      _n.add(y);
      const p = document.activeElement;
      if (!s.contains(p)) {
        const C = new CustomEvent(yr, En);
        s.addEventListener(yr, d), s.dispatchEvent(C), C.defaultPrevented || (Is(Fs(ya(s)), { select: !0 }), document.activeElement === p && ke(s));
      }
      return () => {
        s.removeEventListener(yr, d), setTimeout(() => {
          const C = new CustomEvent(Sr, En);
          s.addEventListener(Sr, v), s.dispatchEvent(C), C.defaultPrevented || ke(p ?? document.body, { select: !0 }), s.removeEventListener(Sr, v), _n.remove(y);
        }, 0);
      };
    }
  }, [s, d, v, y]);
  const w = m.useCallback(
    (p) => {
      if (!r && !n || y.paused) return;
      const S = p.key === "Tab" && !p.altKey && !p.ctrlKey && !p.metaKey, C = document.activeElement;
      if (S && C) {
        const T = p.currentTarget, [N, L] = Ps(T);
        N && L ? !p.shiftKey && C === L ? (p.preventDefault(), r && ke(N, { select: !0 })) : p.shiftKey && C === N && (p.preventDefault(), r && ke(L, { select: !0 })) : C === T && p.preventDefault();
      }
    },
    [r, n, y.paused]
  );
  return /* @__PURE__ */ i(Oe.div, { tabIndex: -1, ...l, ref: b, onKeyDown: w });
});
wa.displayName = Ls;
function Is(e, { select: t = !1 } = {}) {
  const r = document.activeElement;
  for (const n of e)
    if (ke(n, { select: t }), document.activeElement !== r) return;
}
function Ps(e) {
  const t = ya(e), r = Nn(t, e), n = Nn(t.reverse(), e);
  return [r, n];
}
function ya(e) {
  const t = [], r = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (n) => {
      const a = n.tagName === "INPUT" && n.type === "hidden";
      return n.disabled || n.hidden || a ? NodeFilter.FILTER_SKIP : n.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; r.nextNode(); ) t.push(r.currentNode);
  return t;
}
function Nn(e, t) {
  for (const r of e)
    if (!ks(r, { upTo: t })) return r;
}
function ks(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function Ms(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function ke(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const r = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== r && Ms(e) && t && e.select();
  }
}
var _n = Bs();
function Bs() {
  let e = [];
  return {
    add(t) {
      const r = e[0];
      t !== r && (r == null || r.pause()), e = On(e, t), e.unshift(t);
    },
    remove(t) {
      var r;
      e = On(e, t), (r = e[0]) == null || r.resume();
    }
  };
}
function On(e, t) {
  const r = [...e], n = r.indexOf(t);
  return n !== -1 && r.splice(n, 1), r;
}
function Fs(e) {
  return e.filter((t) => t.tagName !== "A");
}
var Vs = "Portal", Sa = m.forwardRef((e, t) => {
  var s;
  const { container: r, ...n } = e, [a, o] = m.useState(!1);
  Qt(() => o(!0), []);
  const l = r || a && ((s = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : s.body);
  return l ? ui.createPortal(/* @__PURE__ */ i(Oe.div, { ...n, ref: t }), l) : null;
});
Sa.displayName = Vs;
function Us(e, t) {
  return m.useReducer((r, n) => t[r][n] ?? r, e);
}
var nr = (e) => {
  const { present: t, children: r } = e, n = Ws(t), a = typeof r == "function" ? r({ present: n.isPresent }) : m.Children.only(r), o = Je(n.ref, js(a));
  return typeof r == "function" || n.isPresent ? m.cloneElement(a, { ref: o }) : null;
};
nr.displayName = "Presence";
function Ws(e) {
  const [t, r] = m.useState(), n = m.useRef({}), a = m.useRef(e), o = m.useRef("none"), l = e ? "mounted" : "unmounted", [s, f] = Us(l, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return m.useEffect(() => {
    const d = Bt(n.current);
    o.current = s === "mounted" ? d : "none";
  }, [s]), Qt(() => {
    const d = n.current, v = a.current;
    if (v !== e) {
      const b = o.current, y = Bt(d);
      e ? f("MOUNT") : y === "none" || (d == null ? void 0 : d.display) === "none" ? f("UNMOUNT") : f(v && b !== y ? "ANIMATION_OUT" : "UNMOUNT"), a.current = e;
    }
  }, [e, f]), Qt(() => {
    if (t) {
      const d = (g) => {
        const y = Bt(n.current).includes(g.animationName);
        g.target === t && y && Pn.flushSync(() => f("ANIMATION_END"));
      }, v = (g) => {
        g.target === t && (o.current = Bt(n.current));
      };
      return t.addEventListener("animationstart", v), t.addEventListener("animationcancel", d), t.addEventListener("animationend", d), () => {
        t.removeEventListener("animationstart", v), t.removeEventListener("animationcancel", d), t.removeEventListener("animationend", d);
      };
    } else
      f("ANIMATION_END");
  }, [t, f]), {
    isPresent: ["mounted", "unmountSuspended"].includes(s),
    ref: m.useCallback((d) => {
      d && (n.current = getComputedStyle(d)), r(d);
    }, [])
  };
}
function Bt(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function js(e) {
  var n, a;
  let t = (n = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : n.get, r = t && "isReactWarning" in t && t.isReactWarning;
  return r ? e.ref : (t = (a = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : a.get, r = t && "isReactWarning" in t && t.isReactWarning, r ? e.props.ref : e.props.ref || e.ref);
}
var Cr = 0;
function Gs() {
  m.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? An()), document.body.insertAdjacentElement("beforeend", e[1] ?? An()), Cr++, () => {
      Cr === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), Cr--;
    };
  }, []);
}
function An() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none", e;
}
var Ce = function() {
  return Ce = Object.assign || function(t) {
    for (var r, n = 1, a = arguments.length; n < a; n++) {
      r = arguments[n];
      for (var o in r) Object.prototype.hasOwnProperty.call(r, o) && (t[o] = r[o]);
    }
    return t;
  }, Ce.apply(this, arguments);
};
function Ca(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
      t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
}
function Hs(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, a = t.length, o; n < a; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}
var Xt = "right-scroll-bar-position", Kt = "width-before-scroll-bar", $s = "with-scroll-bars-hidden", zs = "--removed-body-scroll-bar-size";
function Er(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function Xs(e, t) {
  var r = me(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return r.value;
        },
        set current(n) {
          var a = r.value;
          a !== n && (r.value = n, r.callback(n, a));
        }
      }
    };
  })[0];
  return r.callback = t, r.facade;
}
var Ks = typeof window < "u" ? m.useLayoutEffect : m.useEffect, Rn = /* @__PURE__ */ new WeakMap();
function Zs(e, t) {
  var r = Xs(null, function(n) {
    return e.forEach(function(a) {
      return Er(a, n);
    });
  });
  return Ks(function() {
    var n = Rn.get(r);
    if (n) {
      var a = new Set(n), o = new Set(e), l = r.current;
      a.forEach(function(s) {
        o.has(s) || Er(s, null);
      }), o.forEach(function(s) {
        a.has(s) || Er(s, l);
      });
    }
    Rn.set(r, e);
  }, [e]), r;
}
function Ys(e) {
  return e;
}
function qs(e, t) {
  t === void 0 && (t = Ys);
  var r = [], n = !1, a = {
    read: function() {
      if (n)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return r.length ? r[r.length - 1] : e;
    },
    useMedium: function(o) {
      var l = t(o, n);
      return r.push(l), function() {
        r = r.filter(function(s) {
          return s !== l;
        });
      };
    },
    assignSyncMedium: function(o) {
      for (n = !0; r.length; ) {
        var l = r;
        r = [], l.forEach(o);
      }
      r = {
        push: function(s) {
          return o(s);
        },
        filter: function() {
          return r;
        }
      };
    },
    assignMedium: function(o) {
      n = !0;
      var l = [];
      if (r.length) {
        var s = r;
        r = [], s.forEach(o), l = r;
      }
      var f = function() {
        var v = l;
        l = [], v.forEach(o);
      }, d = function() {
        return Promise.resolve().then(f);
      };
      d(), r = {
        push: function(v) {
          l.push(v), d();
        },
        filter: function(v) {
          return l = l.filter(v), r;
        }
      };
    }
  };
  return a;
}
function Qs(e) {
  e === void 0 && (e = {});
  var t = qs(null);
  return t.options = Ce({ async: !0, ssr: !1 }, e), t;
}
var Ea = function(e) {
  var t = e.sideCar, r = Ca(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var n = t.read();
  if (!n)
    throw new Error("Sidecar medium not found");
  return m.createElement(n, Ce({}, r));
};
Ea.isSideCarExport = !0;
function Js(e, t) {
  return e.useMedium(t), Ea;
}
var Na = Qs(), Nr = function() {
}, ar = m.forwardRef(function(e, t) {
  var r = m.useRef(null), n = m.useState({
    onScrollCapture: Nr,
    onWheelCapture: Nr,
    onTouchMoveCapture: Nr
  }), a = n[0], o = n[1], l = e.forwardProps, s = e.children, f = e.className, d = e.removeScrollBar, v = e.enabled, g = e.shards, b = e.sideCar, y = e.noIsolation, w = e.inert, p = e.allowPinchZoom, S = e.as, C = S === void 0 ? "div" : S, T = e.gapMode, N = Ca(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), L = b, I = Zs([r, t]), z = Ce(Ce({}, N), a);
  return m.createElement(
    m.Fragment,
    null,
    v && m.createElement(L, { sideCar: Na, removeScrollBar: d, shards: g, noIsolation: y, inert: w, setCallbacks: o, allowPinchZoom: !!p, lockRef: r, gapMode: T }),
    l ? m.cloneElement(m.Children.only(s), Ce(Ce({}, z), { ref: I })) : m.createElement(C, Ce({}, z, { className: f, ref: I }), s)
  );
});
ar.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
ar.classNames = {
  fullWidth: Kt,
  zeroRight: Xt
};
var _a = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function eu() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = _a();
  return t && e.setAttribute("nonce", t), e;
}
function tu(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function ru(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var nu = function() {
  var e = 0, t = null;
  return {
    add: function(r) {
      e == 0 && (t = eu()) && (tu(t, r), ru(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, au = function() {
  var e = nu();
  return function(t, r) {
    m.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && r]);
  };
}, ou = function() {
  var e = au(), t = function(r) {
    var n = r.styles, a = r.dynamic;
    return e(n, a), null;
  };
  return t;
}, iu = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, _r = function(e) {
  return parseInt(e || "", 10) || 0;
}, lu = function(e) {
  var t = window.getComputedStyle(document.body), r = t[e === "padding" ? "paddingLeft" : "marginLeft"], n = t[e === "padding" ? "paddingTop" : "marginTop"], a = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [_r(r), _r(n), _r(a)];
}, cu = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return iu;
  var t = lu(e), r = document.documentElement.clientWidth, n = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, n - r + t[2] - t[0])
  };
}, su = ou(), ft = "data-scroll-locked", uu = function(e, t, r, n) {
  var a = e.left, o = e.top, l = e.right, s = e.gap;
  return r === void 0 && (r = "margin"), `
  .`.concat($s, ` {
   overflow: hidden `).concat(n, `;
   padding-right: `).concat(s, "px ").concat(n, `;
  }
  body[`).concat(ft, `] {
    overflow: hidden `).concat(n, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(n, ";"),
    r === "margin" && `
    padding-left: `.concat(a, `px;
    padding-top: `).concat(o, `px;
    padding-right: `).concat(l, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(s, "px ").concat(n, `;
    `),
    r === "padding" && "padding-right: ".concat(s, "px ").concat(n, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(Xt, ` {
    right: `).concat(s, "px ").concat(n, `;
  }
  
  .`).concat(Kt, ` {
    margin-right: `).concat(s, "px ").concat(n, `;
  }
  
  .`).concat(Xt, " .").concat(Xt, ` {
    right: 0 `).concat(n, `;
  }
  
  .`).concat(Kt, " .").concat(Kt, ` {
    margin-right: 0 `).concat(n, `;
  }
  
  body[`).concat(ft, `] {
    `).concat(zs, ": ").concat(s, `px;
  }
`);
}, Dn = function() {
  var e = parseInt(document.body.getAttribute(ft) || "0", 10);
  return isFinite(e) ? e : 0;
}, du = function() {
  m.useEffect(function() {
    return document.body.setAttribute(ft, (Dn() + 1).toString()), function() {
      var e = Dn() - 1;
      e <= 0 ? document.body.removeAttribute(ft) : document.body.setAttribute(ft, e.toString());
    };
  }, []);
}, fu = function(e) {
  var t = e.noRelative, r = e.noImportant, n = e.gapMode, a = n === void 0 ? "margin" : n;
  du();
  var o = m.useMemo(function() {
    return cu(a);
  }, [a]);
  return m.createElement(su, { styles: uu(o, !t, a, r ? "" : "!important") });
};
function hu() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = _a();
  return t && e.setAttribute("nonce", t), e;
}
function mu(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function vu(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var gu = function() {
  var e = 0, t = null;
  return {
    add: function(r) {
      e == 0 && (t = hu()) && (mu(t, r), vu(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, pu = function() {
  var e = gu();
  return function(t, r) {
    m.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && r]);
  };
}, bu = function() {
  var e = pu(), t = function(r) {
    var n = r.styles, a = r.dynamic;
    return e(n, a), null;
  };
  return t;
}, Ir = !1;
if (typeof window < "u")
  try {
    var Ft = Object.defineProperty({}, "passive", {
      get: function() {
        return Ir = !0, !0;
      }
    });
    window.addEventListener("test", Ft, Ft), window.removeEventListener("test", Ft, Ft);
  } catch {
    Ir = !1;
  }
var at = Ir ? { passive: !1 } : !1, xu = function(e) {
  return e.tagName === "TEXTAREA";
}, Oa = function(e, t) {
  var r = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    r[t] !== "hidden" && // contains scroll inside self
    !(r.overflowY === r.overflowX && !xu(e) && r[t] === "visible")
  );
}, wu = function(e) {
  return Oa(e, "overflowY");
}, yu = function(e) {
  return Oa(e, "overflowX");
}, Tn = function(e, t) {
  var r = t.ownerDocument, n = t;
  do {
    typeof ShadowRoot < "u" && n instanceof ShadowRoot && (n = n.host);
    var a = Aa(e, n);
    if (a) {
      var o = Ra(e, n), l = o[1], s = o[2];
      if (l > s)
        return !0;
    }
    n = n.parentNode;
  } while (n && n !== r.body);
  return !1;
}, Su = function(e) {
  var t = e.scrollTop, r = e.scrollHeight, n = e.clientHeight;
  return [
    t,
    r,
    n
  ];
}, Cu = function(e) {
  var t = e.scrollLeft, r = e.scrollWidth, n = e.clientWidth;
  return [
    t,
    r,
    n
  ];
}, Aa = function(e, t) {
  return e === "v" ? wu(t) : yu(t);
}, Ra = function(e, t) {
  return e === "v" ? Su(t) : Cu(t);
}, Eu = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, Nu = function(e, t, r, n, a) {
  var o = Eu(e, window.getComputedStyle(t).direction), l = o * n, s = r.target, f = t.contains(s), d = !1, v = l > 0, g = 0, b = 0;
  do {
    var y = Ra(e, s), w = y[0], p = y[1], S = y[2], C = p - S - o * w;
    (w || C) && Aa(e, s) && (g += C, b += w), s instanceof ShadowRoot ? s = s.host : s = s.parentNode;
  } while (
    // portaled content
    !f && s !== document.body || // self content
    f && (t.contains(s) || t === s)
  );
  return (v && Math.abs(g) < 1 || !v && Math.abs(b) < 1) && (d = !0), d;
}, Vt = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, Ln = function(e) {
  return [e.deltaX, e.deltaY];
}, In = function(e) {
  return e && "current" in e ? e.current : e;
}, _u = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, Ou = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, Au = 0, ot = [];
function Ru(e) {
  var t = m.useRef([]), r = m.useRef([0, 0]), n = m.useRef(), a = m.useState(Au++)[0], o = m.useState(bu)[0], l = m.useRef(e);
  m.useEffect(function() {
    l.current = e;
  }, [e]), m.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(a));
      var p = Hs([e.lockRef.current], (e.shards || []).map(In), !0).filter(Boolean);
      return p.forEach(function(S) {
        return S.classList.add("allow-interactivity-".concat(a));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(a)), p.forEach(function(S) {
          return S.classList.remove("allow-interactivity-".concat(a));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var s = m.useCallback(function(p, S) {
    if ("touches" in p && p.touches.length === 2)
      return !l.current.allowPinchZoom;
    var C = Vt(p), T = r.current, N = "deltaX" in p ? p.deltaX : T[0] - C[0], L = "deltaY" in p ? p.deltaY : T[1] - C[1], I, z = p.target, _ = Math.abs(N) > Math.abs(L) ? "h" : "v";
    if ("touches" in p && _ === "h" && z.type === "range")
      return !1;
    var O = Tn(_, z);
    if (!O)
      return !0;
    if (O ? I = _ : (I = _ === "v" ? "h" : "v", O = Tn(_, z)), !O)
      return !1;
    if (!n.current && "changedTouches" in p && (N || L) && (n.current = I), !I)
      return !0;
    var j = n.current || I;
    return Nu(j, S, p, j === "h" ? N : L);
  }, []), f = m.useCallback(function(p) {
    var S = p;
    if (!(!ot.length || ot[ot.length - 1] !== o)) {
      var C = "deltaY" in S ? Ln(S) : Vt(S), T = t.current.filter(function(I) {
        return I.name === S.type && (I.target === S.target || S.target === I.shadowParent) && _u(I.delta, C);
      })[0];
      if (T && T.should) {
        S.cancelable && S.preventDefault();
        return;
      }
      if (!T) {
        var N = (l.current.shards || []).map(In).filter(Boolean).filter(function(I) {
          return I.contains(S.target);
        }), L = N.length > 0 ? s(S, N[0]) : !l.current.noIsolation;
        L && S.cancelable && S.preventDefault();
      }
    }
  }, []), d = m.useCallback(function(p, S, C, T) {
    var N = { name: p, delta: S, target: C, should: T, shadowParent: Du(C) };
    t.current.push(N), setTimeout(function() {
      t.current = t.current.filter(function(L) {
        return L !== N;
      });
    }, 1);
  }, []), v = m.useCallback(function(p) {
    r.current = Vt(p), n.current = void 0;
  }, []), g = m.useCallback(function(p) {
    d(p.type, Ln(p), p.target, s(p, e.lockRef.current));
  }, []), b = m.useCallback(function(p) {
    d(p.type, Vt(p), p.target, s(p, e.lockRef.current));
  }, []);
  m.useEffect(function() {
    return ot.push(o), e.setCallbacks({
      onScrollCapture: g,
      onWheelCapture: g,
      onTouchMoveCapture: b
    }), document.addEventListener("wheel", f, at), document.addEventListener("touchmove", f, at), document.addEventListener("touchstart", v, at), function() {
      ot = ot.filter(function(p) {
        return p !== o;
      }), document.removeEventListener("wheel", f, at), document.removeEventListener("touchmove", f, at), document.removeEventListener("touchstart", v, at);
    };
  }, []);
  var y = e.removeScrollBar, w = e.inert;
  return m.createElement(
    m.Fragment,
    null,
    w ? m.createElement(o, { styles: Ou(a) }) : null,
    y ? m.createElement(fu, { gapMode: e.gapMode }) : null
  );
}
function Du(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const Tu = Js(Na, Ru);
var Da = m.forwardRef(function(e, t) {
  return m.createElement(ar, Ce({}, e, { ref: t, sideCar: Tu }));
});
Da.classNames = ar.classNames;
var Lu = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, it = /* @__PURE__ */ new WeakMap(), Ut = /* @__PURE__ */ new WeakMap(), Wt = {}, Or = 0, Ta = function(e) {
  return e && (e.host || Ta(e.parentNode));
}, Iu = function(e, t) {
  return t.map(function(r) {
    if (e.contains(r))
      return r;
    var n = Ta(r);
    return n && e.contains(n) ? n : (console.error("aria-hidden", r, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(r) {
    return !!r;
  });
}, Pu = function(e, t, r, n) {
  var a = Iu(t, Array.isArray(e) ? e : [e]);
  Wt[r] || (Wt[r] = /* @__PURE__ */ new WeakMap());
  var o = Wt[r], l = [], s = /* @__PURE__ */ new Set(), f = new Set(a), d = function(g) {
    !g || s.has(g) || (s.add(g), d(g.parentNode));
  };
  a.forEach(d);
  var v = function(g) {
    !g || f.has(g) || Array.prototype.forEach.call(g.children, function(b) {
      if (s.has(b))
        v(b);
      else
        try {
          var y = b.getAttribute(n), w = y !== null && y !== "false", p = (it.get(b) || 0) + 1, S = (o.get(b) || 0) + 1;
          it.set(b, p), o.set(b, S), l.push(b), p === 1 && w && Ut.set(b, !0), S === 1 && b.setAttribute(r, "true"), w || b.setAttribute(n, "true");
        } catch (C) {
          console.error("aria-hidden: cannot operate on ", b, C);
        }
    });
  };
  return v(t), s.clear(), Or++, function() {
    l.forEach(function(g) {
      var b = it.get(g) - 1, y = o.get(g) - 1;
      it.set(g, b), o.set(g, y), b || (Ut.has(g) || g.removeAttribute(n), Ut.delete(g)), y || g.removeAttribute(r);
    }), Or--, Or || (it = /* @__PURE__ */ new WeakMap(), it = /* @__PURE__ */ new WeakMap(), Ut = /* @__PURE__ */ new WeakMap(), Wt = {});
  };
}, ku = function(e, t, r) {
  r === void 0 && (r = "data-aria-hidden");
  var n = Array.from(Array.isArray(e) ? e : [e]), a = Lu(e);
  return a ? (n.push.apply(n, Array.from(a.querySelectorAll("[aria-live]"))), Pu(n, a, r, "aria-hidden")) : function() {
    return null;
  };
}, Wr = "Dialog", [La, Vd] = fs(Wr), [Mu, be] = La(Wr), Ia = (e) => {
  const {
    __scopeDialog: t,
    children: r,
    open: n,
    defaultOpen: a,
    onOpenChange: o,
    modal: l = !0
  } = e, s = m.useRef(null), f = m.useRef(null), [d = !1, v] = gs({
    prop: n,
    defaultProp: a,
    onChange: o
  });
  return /* @__PURE__ */ i(
    Mu,
    {
      scope: t,
      triggerRef: s,
      contentRef: f,
      contentId: wr(),
      titleId: wr(),
      descriptionId: wr(),
      open: d,
      onOpenChange: v,
      onOpenToggle: m.useCallback(() => v((g) => !g), [v]),
      modal: l,
      children: r
    }
  );
};
Ia.displayName = Wr;
var Pa = "DialogTrigger", ka = m.forwardRef(
  (e, t) => {
    const { __scopeDialog: r, ...n } = e, a = be(Pa, r), o = Je(t, a.triggerRef);
    return /* @__PURE__ */ i(
      Oe.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": a.open,
        "aria-controls": a.contentId,
        "data-state": Hr(a.open),
        ...n,
        ref: o,
        onClick: Fe(e.onClick, a.onOpenToggle)
      }
    );
  }
);
ka.displayName = Pa;
var jr = "DialogPortal", [Bu, Ma] = La(jr, {
  forceMount: void 0
}), Ba = (e) => {
  const { __scopeDialog: t, forceMount: r, children: n, container: a } = e, o = be(jr, t);
  return /* @__PURE__ */ i(Bu, { scope: t, forceMount: r, children: m.Children.map(n, (l) => /* @__PURE__ */ i(nr, { present: r || o.open, children: /* @__PURE__ */ i(Sa, { asChild: !0, container: a, children: l }) })) });
};
Ba.displayName = jr;
var Jt = "DialogOverlay", Fa = m.forwardRef(
  (e, t) => {
    const r = Ma(Jt, e.__scopeDialog), { forceMount: n = r.forceMount, ...a } = e, o = be(Jt, e.__scopeDialog);
    return o.modal ? /* @__PURE__ */ i(nr, { present: n || o.open, children: /* @__PURE__ */ i(Fu, { ...a, ref: t }) }) : null;
  }
);
Fa.displayName = Jt;
var Fu = m.forwardRef(
  (e, t) => {
    const { __scopeDialog: r, ...n } = e, a = be(Jt, r);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ i(Da, { as: Ur, allowPinchZoom: !0, shards: [a.contentRef], children: /* @__PURE__ */ i(
        Oe.div,
        {
          "data-state": Hr(a.open),
          ...n,
          ref: t,
          style: { pointerEvents: "auto", ...n.style }
        }
      ) })
    );
  }
), Qe = "DialogContent", Va = m.forwardRef(
  (e, t) => {
    const r = Ma(Qe, e.__scopeDialog), { forceMount: n = r.forceMount, ...a } = e, o = be(Qe, e.__scopeDialog);
    return /* @__PURE__ */ i(nr, { present: n || o.open, children: o.modal ? /* @__PURE__ */ i(Vu, { ...a, ref: t }) : /* @__PURE__ */ i(Uu, { ...a, ref: t }) });
  }
);
Va.displayName = Qe;
var Vu = m.forwardRef(
  (e, t) => {
    const r = be(Qe, e.__scopeDialog), n = m.useRef(null), a = Je(t, r.contentRef, n);
    return m.useEffect(() => {
      const o = n.current;
      if (o) return ku(o);
    }, []), /* @__PURE__ */ i(
      Ua,
      {
        ...e,
        ref: a,
        trapFocus: r.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: Fe(e.onCloseAutoFocus, (o) => {
          var l;
          o.preventDefault(), (l = r.triggerRef.current) == null || l.focus();
        }),
        onPointerDownOutside: Fe(e.onPointerDownOutside, (o) => {
          const l = o.detail.originalEvent, s = l.button === 0 && l.ctrlKey === !0;
          (l.button === 2 || s) && o.preventDefault();
        }),
        onFocusOutside: Fe(
          e.onFocusOutside,
          (o) => o.preventDefault()
        )
      }
    );
  }
), Uu = m.forwardRef(
  (e, t) => {
    const r = be(Qe, e.__scopeDialog), n = m.useRef(!1), a = m.useRef(!1);
    return /* @__PURE__ */ i(
      Ua,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (o) => {
          var l, s;
          (l = e.onCloseAutoFocus) == null || l.call(e, o), o.defaultPrevented || (n.current || (s = r.triggerRef.current) == null || s.focus(), o.preventDefault()), n.current = !1, a.current = !1;
        },
        onInteractOutside: (o) => {
          var f, d;
          (f = e.onInteractOutside) == null || f.call(e, o), o.defaultPrevented || (n.current = !0, o.detail.originalEvent.type === "pointerdown" && (a.current = !0));
          const l = o.target;
          ((d = r.triggerRef.current) == null ? void 0 : d.contains(l)) && o.preventDefault(), o.detail.originalEvent.type === "focusin" && a.current && o.preventDefault();
        }
      }
    );
  }
), Ua = m.forwardRef(
  (e, t) => {
    const { __scopeDialog: r, trapFocus: n, onOpenAutoFocus: a, onCloseAutoFocus: o, ...l } = e, s = be(Qe, r), f = m.useRef(null), d = Je(t, f);
    return Gs(), /* @__PURE__ */ E(Ye, { children: [
      /* @__PURE__ */ i(
        wa,
        {
          asChild: !0,
          loop: !0,
          trapped: n,
          onMountAutoFocus: a,
          onUnmountAutoFocus: o,
          children: /* @__PURE__ */ i(
            ba,
            {
              role: "dialog",
              id: s.contentId,
              "aria-describedby": s.descriptionId,
              "aria-labelledby": s.titleId,
              "data-state": Hr(s.open),
              ...l,
              ref: d,
              onDismiss: () => s.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ E(Ye, { children: [
        /* @__PURE__ */ i(Wu, { titleId: s.titleId }),
        /* @__PURE__ */ i(Gu, { contentRef: f, descriptionId: s.descriptionId })
      ] })
    ] });
  }
), Gr = "DialogTitle", Wa = m.forwardRef(
  (e, t) => {
    const { __scopeDialog: r, ...n } = e, a = be(Gr, r);
    return /* @__PURE__ */ i(Oe.h2, { id: a.titleId, ...n, ref: t });
  }
);
Wa.displayName = Gr;
var ja = "DialogDescription", Ga = m.forwardRef(
  (e, t) => {
    const { __scopeDialog: r, ...n } = e, a = be(ja, r);
    return /* @__PURE__ */ i(Oe.p, { id: a.descriptionId, ...n, ref: t });
  }
);
Ga.displayName = ja;
var Ha = "DialogClose", $a = m.forwardRef(
  (e, t) => {
    const { __scopeDialog: r, ...n } = e, a = be(Ha, r);
    return /* @__PURE__ */ i(
      Oe.button,
      {
        type: "button",
        ...n,
        ref: t,
        onClick: Fe(e.onClick, () => a.onOpenChange(!1))
      }
    );
  }
);
$a.displayName = Ha;
function Hr(e) {
  return e ? "open" : "closed";
}
var za = "DialogTitleWarning", [Ud, Xa] = ds(za, {
  contentName: Qe,
  titleName: Gr,
  docsSlug: "dialog"
}), Wu = ({ titleId: e }) => {
  const t = Xa(za), r = `\`${t.contentName}\` requires a \`${t.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${t.docsSlug}`;
  return m.useEffect(() => {
    e && (document.getElementById(e) || console.error(r));
  }, [r, e]), null;
}, ju = "DialogDescriptionWarning", Gu = ({ contentRef: e, descriptionId: t }) => {
  const n = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${Xa(ju).contentName}}.`;
  return m.useEffect(() => {
    var o;
    const a = (o = e.current) == null ? void 0 : o.getAttribute("aria-describedby");
    t && a && (document.getElementById(t) || console.warn(n));
  }, [n, e, t]), null;
}, Hu = Ia, $u = ka, zu = Ba, Ka = Fa, Za = Va, $r = Wa, Xu = Ga, Ku = $a, Zu = "VisuallyHidden", Ya = m.forwardRef(
  (e, t) => /* @__PURE__ */ i(
    Oe.span,
    {
      ...e,
      ref: t,
      style: {
        // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
        position: "absolute",
        border: 0,
        width: 1,
        height: 1,
        padding: 0,
        margin: -1,
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap",
        wordWrap: "normal",
        ...e.style
      }
    }
  )
);
Ya.displayName = Zu;
var Yu = Ya, ct = /* @__PURE__ */ ((e) => (e.Center = "center", e.Right = "right", e))(ct || {});
const Wd = ({
  open: e,
  onOpenChange: t,
  children: r,
  ...n
}) => /* @__PURE__ */ i(Hu, { open: e, onOpenChange: (o) => {
  const l = document.querySelector(".toast-layer:hover");
  !o && l || t == null || t(o);
}, ...n, children: r }), jd = $u, qu = Ku, qa = m.forwardRef(({ showCloseIcon: e, position: t, ...r }, n) => /* @__PURE__ */ i(
  Ka,
  {
    ref: n,
    className: x(
      " dialog-overlay-bg absolute h-full w-full backdrop-blur-md names:backdrop-blur-lg"
    ),
    ...r,
    children: /* @__PURE__ */ i(
      qu,
      {
        className: x("fixed right-3 top-3", { hidden: !e }),
        "aria-label": "Close",
        children: /* @__PURE__ */ i(Et, { className: "button-text-color-neutral" })
      }
    )
  }
));
qa.displayName = Ka.displayName;
const Qu = m.forwardRef((e, t) => /* @__PURE__ */ i(
  "div",
  {
    className: x("inset-0 z-[99999]", e.isFixedPosition ? "fixed" : "absolute"),
    ref: t,
    children: /* @__PURE__ */ i("div", { className: "relative h-full w-full", children: e.children })
  }
)), Ju = m.forwardRef(
  ({
    className: e,
    containerId: t,
    showCloseOnOverlay: r,
    children: n,
    position: a = ct.Center,
    customWidth: o = "w-80 max-w-[85vw] md:w-96",
    isFixedPosition: l = a === ct.Right,
    ...s
  }, f) => {
    const [d, v] = me(
      void 0
    );
    fe(() => {
      const w = t ? document.getElementById(t) : void 0;
      v(w ?? void 0);
    }, [t]);
    const g = a === ct.Right ? "overflow-hidden right-0 h-screen top-0 w-full" : "overflow-y-auto overflow-x-hidden left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 rounded-xl", b = a === ct.Right ? "md:w-96 max-w-[500px]" : o, y = a === ct.Right ? "h-screen" : "max-h-[90vh] h-full";
    return /* @__PURE__ */ i(zu, { container: d, children: /* @__PURE__ */ E(Qu, { isFixedPosition: l, children: [
      /* @__PURE__ */ i(qa, { showCloseIcon: r, position: a }),
      /* @__PURE__ */ E(
        Za,
        {
          ref: f,
          className: x(
            "dialog-content-bg dialog-outline absolute flex flex-col justify-center",
            g,
            b
          ),
          ...s,
          children: [
            /* @__PURE__ */ E(Yu, { children: [
              /* @__PURE__ */ i($r, {}),
              /* @__PURE__ */ i(Xu, {})
            ] }),
            /* @__PURE__ */ i("div", { className: x("flex flex-1 flex-col", y), children: n })
          ]
        }
      )
    ] }) });
  }
);
Ju.displayName = Za.displayName;
const ed = m.forwardRef((e, t) => /* @__PURE__ */ i(
  $r,
  {
    ref: t,
    className: "dialog-title-color font-inter text-title-lg",
    ...e
  }
));
ed.displayName = $r.displayName;
const td = m.forwardRef(
  (e, t) => /* @__PURE__ */ i(
    "div",
    {
      ref: t,
      className: "dialog-body-color flex-1 overflow-y-auto p-md--rs text-body-sm",
      ...e
    }
  )
);
td.displayName = "DialogBody";
const Qa = ci({
  isHeaderChecked: !1,
  selectedRowIndexes: /* @__PURE__ */ new Set(),
  isHeaderIndeterminate: !1
}), Ja = () => si(Qa);
function rd({
  children: e,
  selectedRowIndexes: t,
  rowIndexes: r,
  ...n
}) {
  const a = r.length === t.size, o = !a && t.size > 0;
  return /* @__PURE__ */ i(
    Qa.Provider,
    {
      value: {
        ...n,
        isHeaderChecked: a,
        selectedRowIndexes: t,
        isHeaderIndeterminate: o
      },
      children: e
    }
  );
}
function Gd({
  paginationOptions: e,
  action: t,
  supportingLabel: r,
  selectedRowIndexes: n = /* @__PURE__ */ new Set(),
  rowIndexes: a,
  children: o,
  pageSizeSelector: l,
  heightFull: s = !1
}) {
  return /* @__PURE__ */ i(rd, { selectedRowIndexes: n, rowIndexes: a, children: /* @__PURE__ */ E("div", { className: x("w-full", { "h-full": s }), children: [
    /* @__PURE__ */ i(
      "div",
      {
        className: x("overflow-auto", {
          "h-full": s
        }),
        children: /* @__PURE__ */ i(
          "table",
          {
            className: x("w-full table-auto", {
              "h-full": s
            }),
            children: o
          }
        )
      }
    ),
    /* @__PURE__ */ E(
      "div",
      {
        className: x("flex w-full items-center gap-sm pt-md", {
          hidden: !r && !e && !t,
          "flex-col justify-between sm:flex-row": e,
          "justify-end": !e && t
        }),
        children: [
          (e || t) && /* @__PURE__ */ E("div", { className: "flex gap-2", children: [
            e && /* @__PURE__ */ E(Ye, { children: [
              /* @__PURE__ */ i(
                pe,
                {
                  type: U.Secondary,
                  size: ie.Small,
                  icon: /* @__PURE__ */ i(nl, {}),
                  disabled: !e.hasFirst,
                  onClick: e.onFirst,
                  "aria-label": "First page"
                }
              ),
              /* @__PURE__ */ i(
                pe,
                {
                  type: U.Secondary,
                  size: ie.Small,
                  icon: /* @__PURE__ */ i(Qi, {}),
                  disabled: !e.hasPrev,
                  onClick: e.onPrev,
                  "aria-label": "Previous page"
                }
              ),
              /* @__PURE__ */ i(
                pe,
                {
                  type: U.Secondary,
                  size: ie.Small,
                  icon: /* @__PURE__ */ i(kr, {}),
                  disabled: !e.hasNext,
                  onClick: e.onNext,
                  "aria-label": "Next page"
                }
              ),
              /* @__PURE__ */ i(
                pe,
                {
                  type: U.Secondary,
                  size: ie.Small,
                  icon: /* @__PURE__ */ i(al, {}),
                  disabled: !e.hasLast,
                  onClick: e.onLast,
                  "aria-label": "Last page"
                }
              )
            ] }),
            t && t
          ] }),
          r || l ? /* @__PURE__ */ E("div", { className: "flex flex-row items-center gap-x-sm", children: [
            r && /* @__PURE__ */ i("span", { className: "table-text-color text-label-md", children: r }),
            l && /* @__PURE__ */ i("div", { className: "ml-2", children: l })
          ] }) : null
        ]
      }
    )
  ] }) });
}
function Hd(e) {
  return /* @__PURE__ */ i(pe, { type: U.Secondary, size: ie.Small, ...e });
}
function $d({ children: e }) {
  return /* @__PURE__ */ i("thead", { children: e });
}
function zd({
  children: e,
  leading: t
}) {
  return /* @__PURE__ */ E("tr", { children: [
    t,
    e
  ] });
}
const nd = "table-text-color", ad = "text-body-md";
function Xd({ children: e }) {
  return /* @__PURE__ */ i("tbody", { className: x(nd, ad), children: e });
}
function Kd({
  rowIndex: e,
  onCheckboxChange: t,
  isDisabled: r
}) {
  const { selectedRowIndexes: n } = Ja();
  return /* @__PURE__ */ i(Xc, { isContentCentered: !0, children: /* @__PURE__ */ i(
    Zn,
    {
      onCheckedChange: (a) => {
        t(a.target.checked);
      },
      isChecked: n.has(e),
      isDisabled: r
    }
  ) });
}
function Zd({ onCheckboxChange: e }) {
  const { isHeaderChecked: t, isHeaderIndeterminate: r } = Ja();
  return /* @__PURE__ */ i(
    Kc,
    {
      isContentCentered: !0,
      hasCheckbox: !0,
      onCheckboxChange: (n) => {
        e(n.target.checked);
      },
      isChecked: t,
      columnKey: 1,
      isIndeterminate: r
    }
  );
}
function Yd({
  items: e,
  activeId: t,
  onClickItem: r,
  isCollapsible: n = !1,
  onToggleNavbar: a
}) {
  return /* @__PURE__ */ E(
    "div",
    {
      className: x("flex h-fit w-full", {
        "flex-col px-md py-xs sm:h-full sm:w-auto sm:px-none sm:py-xl": n
      }),
      children: [
        n && /* @__PURE__ */ E("div", { className: "flex w-full items-center justify-between sm:mb-[48px] sm:flex-col", children: [
          /* @__PURE__ */ i("div", { className: "flex justify-center [&_svg]:h-[38px] [&_svg]:w-[38px]", children: /* @__PURE__ */ i(ol, { className: "navbar-icon-color" }) }),
          /* @__PURE__ */ i(
            "div",
            {
              className: "state-layer navbar-icon-color relative rounded-full p-xs hover:cursor-pointer sm:hidden [&_svg]:h-6 [&_svg]:w-6",
              onClick: a,
              role: "button",
              "aria-label": "Toggle menu",
              children: /* @__PURE__ */ i(il, {})
            }
          )
        ] }),
        /* @__PURE__ */ i(
          "div",
          {
            className: x({
              "flex w-full justify-between px-sm py-xxs": !n,
              "hidden sm:flex sm:flex-col sm:gap-2": n
            }),
            children: e.map((o) => /* @__PURE__ */ i(
              "div",
              {
                className: x("flex items-center", {
                  "px-xs py-xxs": !n,
                  "py-xxs pl-xs pr-sm": n
                }),
                "data-testid": `nav-${o.id}`,
                children: /* @__PURE__ */ i(
                  va,
                  {
                    ...o,
                    isSelected: o.id === t,
                    onClick: (l) => {
                      o.onClick && o.onClick(l), o.isDisabled || r(o.id);
                    }
                  }
                )
              },
              o.id
            ))
          }
        )
      ]
    }
  );
}
function qd({
  items: e,
  activeId: t,
  onClickItem: r,
  isOpen: n,
  onToggleNavbar: a
}) {
  return /* @__PURE__ */ E(Ye, { children: [
    /* @__PURE__ */ i(
      "div",
      {
        onClick: a,
        className: x("duration-800 transition-opacity ease-out", {
          "opacity-1 fixed left-0 top-0 h-full w-full bg-shader-neutral-light-72": n,
          "-translate-x-full opacity-0": !n
        })
      }
    ),
    /* @__PURE__ */ i(
      "div",
      {
        className: x(
          "z-999 rounded-tb-3xl navbar-slideout-bg fixed left-0 top-0 h-full w-11/12 rounded-tr-3xl px-lg py-lg transition-transform duration-300 ease-out",
          {
            "translate-x-0": n,
            "-translate-x-full": !n
          }
        ),
        children: /* @__PURE__ */ E("div", { className: "flex flex-col gap-2", children: [
          /* @__PURE__ */ i("div", { className: "[&_svg]:h-5 [&_svg]:w-5", children: /* @__PURE__ */ i(
            pe,
            {
              type: U.Ghost,
              onClick: a,
              icon: /* @__PURE__ */ i(Gn, {}),
              "aria-label": "Close menu"
            }
          ) }),
          e.map((o) => /* @__PURE__ */ i(
            va,
            {
              ...o,
              type: Vr.Vertical,
              isSelected: o.id === t,
              onClick: () => {
                r(o.id), a && a();
              }
            },
            o.id
          ))
        ] })
      }
    )
  ] });
}
const od = "accordion-icon-color transition-transform ease-linear";
function Qd({
  onToggle: e,
  children: t,
  isExpanded: r,
  hideArrow: n
}) {
  return /* @__PURE__ */ E(
    "div",
    {
      onClick: e,
      role: "button",
      "aria-expanded": r,
      className: x(
        "state-layer relative flex cursor-pointer items-center justify-between gap-md overflow-hidden rounded-xl py-sm--rs",
        {
          "pr-md--rs": !n
        }
      ),
      children: [
        t,
        !n && /* @__PURE__ */ i("div", { className: "[&_svg]:h-5 [&_svg]:w-5", children: /* @__PURE__ */ i(
          pe,
          {
            type: U.Ghost,
            icon: /* @__PURE__ */ i(
              qi,
              {
                className: x(od, {
                  "rotate-180": r
                })
              }
            )
          }
        ) })
      ]
    }
  );
}
function Jd({
  isExpanded: e,
  children: t
}) {
  return /* @__PURE__ */ i(
    "div",
    {
      className: x({
        hidden: !e
      }),
      children: t
    }
  );
}
function ef({
  children: e,
  hideBorder: t
}) {
  return /* @__PURE__ */ i(
    "div",
    {
      className: x("accordion-bg rounded-xl", {
        "accordion-border-color border": !t
      }),
      children: e
    }
  );
}
export {
  ef as Accordion,
  Jd as AccordionContent,
  Qd as AccordionHeader,
  Ad as Account,
  $l as Address,
  zl as AssetMediaRenderer,
  Yt as Badge,
  re as BadgeType,
  pe as Button,
  er as ButtonHtmlType,
  dd as ButtonPill,
  hd as ButtonSegment,
  st as ButtonSegmentType,
  ie as ButtonSize,
  U as ButtonType,
  se as ButtonUnstyled,
  Id as Card,
  Pd as CardAction,
  zt as CardActionType,
  Md as CardBody,
  kd as CardImage,
  yt as CardType,
  Zn as Checkbox,
  Cd as Chip,
  Dr as ChipSize,
  Z as ChipType,
  Wd as Dialog,
  td as DialogBody,
  qu as DialogClose,
  Ju as DialogContent,
  ct as DialogPosition,
  ed as DialogTitle,
  jd as DialogTrigger,
  Bd as DisplayStats,
  _e as DisplayStatsSize,
  Be as DisplayStatsType,
  Nl as Divider,
  Ke as DividerType,
  zc as Dropdown,
  Ht as DropdownPosition,
  gd as Header,
  mi as IOTA_NAMES_COLOR_PALETTE,
  hi as IOTA_PRIMITIVES_COLOR_PALETTE,
  Yn as Image,
  mt as ImageShape,
  Ze as ImageType,
  Tl as ImageWithFallback,
  bd as InfoBox,
  Gt as InfoBoxStyle,
  Te as InfoBoxType,
  _d as Input,
  Se as InputType,
  md as KeyValueInfo,
  vd as LabelText,
  he as LabelTextSize,
  Rl as ListItem,
  wd as LoadingIndicator,
  Dl as MediaFallback,
  Yd as Navbar,
  va as NavbarItem,
  Vr as NavbarItemType,
  qd as NavbarSlideout,
  pd as Panel,
  kl as Placeholder,
  fd as RadioButton,
  dc as Resize,
  vi as SHADER_COLOR_PALETTE,
  De as ScreenSize,
  Ld as Search,
  Ne as SearchBarType,
  qt as SecondaryText,
  Ed as SegmentedButton,
  ut as SegmentedButtonType,
  Td as Select,
  $t as SelectSize,
  yd as Skeleton,
  xd as Snackbar,
  Ee as SnackbarType,
  Gd as Table,
  Hd as TableActionButton,
  Xd as TableBody,
  Xc as TableCellBase,
  Dd as TableCellPlaceholder,
  Rd as TableCellText,
  $d as TableHeader,
  Kc as TableHeaderCell,
  Pe as TableHeaderCellSortOrder,
  Zd as TableHeaderCheckbox,
  zd as TableRow,
  Kd as TableRowCheckbox,
  Od as TextArea,
  Nd as Title,
  ht as TitleSize,
  Sd as Toggle,
  Rr as ToggleLabelPosition,
  Ve as ToggleSize,
  vt as Tooltip,
  $e as TooltipPosition,
  fi as UIKitTheme,
  jt as ValueSize,
  Fl as Video,
  Fd as VisualAssetCard,
  qn as VisualAssetType,
  sd as uiKitResponsivePreset,
  ud as uiKitStaticPreset
};
//# sourceMappingURL=index.es.js.map
